(() => {
    var e = [
            (e, t, n) => {
                "use strict";
                n.r(t);
                var i = n(1),
                    a = n(72),
                    o = n(73),
                    r = n(74),
                    s = n(75),
                    l = (n(76), n(80));
                n(81);
                function c() {
                    $.ajax({ dataType: "json", url: "cart.js" }).done(function (e) {
                        let t = e.items,
                            n = [],
                            a = [],
                            o = 0,
                            r = 0,
                            s = 0,
                            c = 0,
                            d = 0,
                            u = [];
                        t.forEach((e, t) => {
                            e.final_price > 105 ? n.push(e) : a.push(e);
                        }),
                            n.forEach((e, t) => {
                                e.final_price > o && (o = e.final_price), (r += e.quantity);
                            }),
                            a.forEach((e, t) => {
                                s += e.quantity;
                            }),
                            (c = Math.floor(r / 14)),
                            (d = 14 - (r % 14)),
                            $.ajax({ dataType: "json", url: "/products.json" }).done(function (e) {
                                if (
                                    ((o = Number(o / 100).toFixed(2)),
                                    e.products.forEach((e, t) => {
                                        e.tags.indexOf("produkt_promocyjny") > -1 && 1 == e.variants[0].available && Number(e.variants[0].compare_at_price) <= o && u.push(e);
                                    }),
                                    $(".cart-header__info").append(`<p>Do kolejnego PROMOCYJNEGO PRODUKTU brakuje Ci opakowań: <b>${d}</b></p>`),
                                    c > s
                                        ? ($(".cart-info__maxprice").append("WYBIERZ PRODUKT PROMOCYJNY"),
                                          $(".cart-info__remainingProductsForPromo").append("Gratulacje! Wybierz produkt PROMOCYJNY i dodaj go do koszyka. Dołączymy go do Twojego zamówienia."))
                                        : ($(".cart-info__maxprice").append("PROMOCJA 14 + 1"),
                                          $(".cart-info__remainingProductsForPromo").append(`Do promocyjnego produktu brakuje Ci opakowań: <b>${d}</b>. Dodaj kolejne produkty do koszyka, aby otrzymać produkt PROMOCYJNY.`),
                                          $(".cart-info").append('<a href="/collections/all" class="cart-info__link btn">Dodaj kolejne produkty</a>')),
                                    c > s)
                                ) {
                                    $(".cart-modal-container").append('\n        <button type="button" class="btn" id="open-modal">Wybierz produkt</button>\n      '),
                                        $("body").append(
                                            '\n        <div class="cart-modal">\n                      <div class="micromodal-slide" id="modal-1" aria-hidden="true">\n                        <div class="modal__overlay" tabindex="-1" data-micromodal-close>\n                          <div class="modal__container page-width" role="dialog" aria-modal="true" aria-labelledby="modal-1-title">\n                            <header class="modal__header">\n                              <h2 class="modal__title" id="modal-1-title">\n                                Wybierz produkt PROMOCYJNY\n                              </h2>\n                              <button class="modal__close" aria-label="Close modal" data-micromodal-close></button>\n                            </header>\n                            <main class="modal__content" id="modal-1-content">\n                              <p>\n                                Wybierz produkt w promocyjnej cenie 1,05 zł:\n                              </p>\n                            </main>\n                            <main data-swiper-modal class="swiper-container">\n                                <div class="modal__product-content swiper-wrapper"></div>\n                                <div class="swiper-button-next"></div>\n                                <div class="swiper-button-prev"></div>\n                            </main>\n                            <footer class="modal__footer">\n                            </footer>\n                          </div>\n                        </div>\n                      </div>\n        </div>\n      '
                                        ),
                                        document.getElementById("open-modal").addEventListener("click", function () {
                                            l.default.show("modal-1"), window.dispatchEvent(new Event("resize"));
                                        }),
                                        u.forEach((e, t) => {
                                            $(".micromodal-slide .modal__product-content").append(
                                                `\n                  <div data-id="${e.id}" data-variant-id="${e.variants[0].id}" class="cart-modal__item swiper-slide">\n                      <img class="cart-modal__item-img" src="${e.images[0].src}"/>\n          <h3 class="cart-modal__item-title">${e.title}</h3>\n                      <button class="cart-modal__item--addToCart">Wybierz</button>\n                  </div>\n              `
                                            );
                                        });
                                    let e = setInterval(function () {
                                        var t = $(".cart-modal__item").length;
                                        if (u.length == t) {
                                            new i.default("[data-swiper-modal]", {
                                                speed: 100,
                                                slidesPerView: 1,
                                                spaceBetween: 20,
                                                breakpoints: { 750: { slidesPerView: 2 }, 980: { slidesPerView: 3 }, 1200: { slidesPerView: 4 } },
                                                navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
                                            });
                                            clearInterval(e);
                                        }
                                    }, 500);
                                }
                                let t = "";
                                a.forEach((e, n) => {
                                    t = `${t}updates[${e.variant_id.toString()}]=0&`;
                                }),
                                    a.length > 0 &&
                                        c < s &&
                                        $.post("/cart/update", `${t}`).done(function () {
                                            window.location.reload();
                                        }),
                                    $(".cart-modal__item--addToCart").click(function (e) {
                                        e.preventDefault(),
                                            $.post("/cart/add", { items: [{ quantity: 1, id: $(this).parent().attr("data-variant-id") }] }).done(function () {
                                                window.location.reload();
                                            });
                                    }),
                                    $(document).on("click",".cart__remove",function() {
                                        console.log(a)
                                        a.length > 0 &&
                                            setTimeout(function () {
                                                $.post("/cart/update", `${t}`).done(function () {
                                                    window.location.reload();
                                                });
                                            }, 1e3);
                                    });
                                    
                            });
                    });
                }
                i.default.use([a.default, o.default, r.default, s.default]),
                    (globalThis.mutationMain = () => {
                        new MutationObserver(function (e) {
                            e.length > 0 && ($(".slideShowUltimate-container").hasClass("swiper-container-initialized") || slideshow._init());
                        }).observe($("#MainContent")[0], { attributes: !0, childList: !0, characterData: !0, subtree: !0 }),
                            $(document).on("shopify:section:select", function (e) {
                                e.target.className.indexOf("shopify-section-header") > 0 && headers._run(),
                                    e.target.className.indexOf("shopify-section-cookies") > 0 && cookies._run(),
                                    (e.target.className.indexOf("shopify-section-newsletter") > 0 || e.target.className.indexOf("shopify-section-product-template") > 0) && checkbox._run(),
                                    e.target.className.indexOf("shopify-section-quotes") > 0 && quotes._run(),
                                    (e.target.className.indexOf("index-section--featured-product") > 0 || e.target.className.indexOf("shopify-section-product-template") > 0) && product._run();
                            });
                    }),
                    (globalThis._setCookie = function (e, t, n) {
                        var i = new Date();
                        i.setTime(i.getTime() + 24 * n * 60 * 60 * 1e3);
                        var a = "expires=" + i.toUTCString();
                        document.cookie = e + "=" + t + ";" + a + ";path=/";
                    }),
                    (globalThis._getCookie = function (e) {
                        for (var t = e + "=", n = decodeURIComponent(encodeURIComponent(document.cookie)).split(";"), i = 0; i < n.length; i++) {
                            for (var a = n[i]; " " == a.charAt(0); ) a = a.substring(1);
                            if (0 == a.indexOf(t)) return a.substring(t.length, a.length);
                        }
                        return "";
                    }),
                    (globalThis.slideshow = {
                        selectors: {
                            container: ".slideShowUltimate-container",
                            paginationEl: ".slideShowUltimate-pagination",
                            nextEl: ".slideShowUltimate__arrow-next",
                            prevEl: ".slideShowUltimate__arrow-prev",
                            scrollbarEl: ".slideShowUltimate-scrollbar",
                            paused: ".slideShowUltimate__pause",
                            activeEl: ".swiper-slide-active",
                            activeElMobil: ".slideShowUltimate__text-content--mobile-active",
                            slideImage: ".swiper-slide .slideshow__image",
                        },
                        _isBackgrounImage: async (e) => {
                            let t = !0;
                            return (
                                await $.each($(slideshow.selectors.slideImage, $(e)), (n, i) =>
                                    -1 === $(i).attr("style")?.indexOf("background-image") ? ((t = !1), !1) : $(slideshow.selectors.slideImage, $(e)).length === n + 1 ? ((t = !0), !0) : void 0
                                ),
                                t
                            );
                        },
                        _initSwiper: (e, t) => {
                            new i.default(e, {
                                slidesPerView: 1,
                                loop: !0,
                                loopAdditionalSlides: 0,
                                pagination: {
                                    el: t + slideshow.selectors.paginationEl,
                                    clickable: !0,
                                    renderBullet: $(e).data("pagination")
                                        ? function (t, n) {
                                              return `<span class="${n}" title="${$('[data-slider-slide-index="' + t + '"]', $(e)).data("pagination-title")}">${$('[data-slider-slide-index="' + t + '"]', $(e)).data(
                                                  "pagination-title"
                                              )}</span>`;
                                          }
                                        : null,
                                },
                                navigation: { nextEl: t + slideshow.selectors.nextEl, prevEl: t + slideshow.selectors.prevEl },
                                scrollbar: { el: t + slideshow.selectors.scrollbarEl, draggable: !0 },
                                autoplay: $(e).data("autorotate") && { delay: $(e).data("speed") },
                                on: {
                                    slideChangeTransitionEnd: function () {
                                        let e = $(slideshow.selectors.activeEl, $(t)).data("slider-slide-index");
                                        $(slideshow.selectors.activeElMobil).removeClass(slideshow.selectors.activeElMobil.replace(".", "")),
                                            $(`[data-slider-mobile-content-index="${e}"]`).addClass(slideshow.selectors.activeElMobil.replace(".", ""));
                                    },
                                },
                            }),
                                $(e).data("autorotate") &&
                                    $(slideshow.selectors.paused, $(e)).on("click", function () {
                                        $(this).toggleClass("is-paused"), $(this).hasClass("is-paused") ? $(e)[0].swiper.autoplay.stop() : $(e)[0].swiper.autoplay.start();
                                    });
                        },
                        _init: () => {
                            if ($(slideshow.selectors.container).length > 0) {
                                let e = $("#shopify-section-announcement-bar")[0].offsetHeight + $("#shopify-section-header")[0].offsetHeight;
                                document.documentElement.style.setProperty("--header-height", e + "px"),
                                    $.each($(slideshow.selectors.container), function () {
                                        let e = "#" + $(this).attr("id"),
                                            t = `#shopify-section-${$(e).data("section-id")} `,
                                            n = setInterval(async function () {
                                                (await slideshow._isBackgrounImage(e)) && (slideshow._initSwiper(e, t), clearInterval(n));
                                            });
                                    });
                            }
                        },
                        _run: () => slideshow._init(),
                    }),
                    (globalThis.headers = {
                        _sticky: () => {
                            $(window)[0].scrollY > 0 ? $("#shopify-section-header").addClass("sticky-installed-m") : $("#shopify-section-header").removeClass("sticky-installed");
                        },
                        _init: () => {
                            let e = $(`#${$("[data-sticky]").attr("id")}`);
                            e.length > 0 && (e.data("sticky") ? $("#shopify-section-header").addClass("shopify-section-header--sticky") : $("#shopify-section-header").removeClass("shopify-section-header--sticky")),
                                headers._sticky(),
                                $(window).on("scroll", function (e) {
                                    headers._sticky();
                                });
                        },
                        _run: () => headers._init(),
                    }),
                    (globalThis.cookies = {
                        _init: () => {
                            _getCookie("page-cookies") === $("#shopify-section-cookies [data-cookies-version]").data("cookies-version") ? $("#shopify-section-cookies").addClass("hide") : $("#shopify-section-cookies").addClass("installed"),
                                $(document).on("click", ".cookies__btn-close", function () {
                                    _setCookie("page-cookies", $("#shopify-section-cookies [data-cookies-version]").data("cookies-version"), 30), $("#shopify-section-cookies").hide("slow");
                                });
                        },
                        _run: () => cookies._init(),
                    }),
                    (globalThis.checkbox = {
                        _template: (e, t) => `<div class="checkbox--xBox" id="checkbox-${t}"><label for="${e}">${theme.iconCheck}${theme.iconChecked}</label></div>`,
                        _init: (e) => {
                            let t = e ? $('input[type="checkbox"]', $(e)) : $('input[type="checkbox"]');
                            $.each(t, (e, t) => {
                                let n = $(t),
                                    i = $(t).attr("id"),
                                    a = $(t).attr("name");
                                i ? 0 == $(`#checkbox-${e}`).length && n.after(checkbox._template(i, e)) : (n.attr("id", a + e), 0 == $(`#checkbox-${a + e}`).length && n.after(checkbox._template(a + e, e))),
                                    n.prependTo(`#checkbox-${e}`),
                                    0 == $(t, $(`#checkbox-${e}`)).length && n.prependTo(`#checkbox-${e}`);
                            });
                        },
                        _run: () => checkbox._init(),
                    }),
                    (globalThis.quotes = {
                        selectors: { section: ".shopify-section", wrapper: ".quotes-wrapper", next: ".quotes__arrow-next", next: ".quotes__arrow-next", active: ".slick-active" },
                        _init: () => {
                            $(quotes.selectors.wrapper).length > 0 &&
                                $(quotes.selectors.next + "[next]").on("click", () => {
                                    !$(quotes.selectors.active).is(":nth-last-child(3)") && $("+ li > button", $(quotes.selectors.active)).trigger("click");
                                });
                        },
                        _run: () => {
                            quotes._init();
                        },
                    }),
                    (globalThis.snize = {
                        selectors: {
                            templateCollection: ".template-collection",
                            templatePage: ".template-page",
                            bestsellers: ".snize--bestsellers",
                            productTitle: ".snize-title",
                            arrow: ".snize-recommendation-arrow",
                            templateCollectionAlternative: "#shopify-section-collection-template-alternative",
                            mainContent: "#MainContent",
                            snizeResults: "#snize_results",
                        },
                        _collection: () => {
                            new MutationObserver(function (e) {
                                e.length > 0 && 0 === $(".checkbox--xBox", $(snize.selectors.snizeResults)).length && checkbox._init(".snize-filter-checkbox"),
                                    e.length > 0 && !$(snize.selectors.productTitle, $(snize.selectors.snizeResults)).hasClass("snize-title--style") && snize._styleProductTitle($(snize.selectors.snizeResults));
                            }).observe($(snize.selectors.mainContent)[0], { attributes: !0, childList: !0, characterData: !0, subtree: !0 });
                        },
                        _styleArrow: () => {
                            $.each($(snize.selectors.arrow, $(snize.selectors.bestsellers)), function () {
                                let e = $(this),
                                    t = e.closest(".buttons").hasClass("prev") ? theme.iconChevronLeft : theme.iconChevronRight;
                                e.html(t).addClass("snize-arrow--style");
                            });
                        },
                        _styleProductTitle: (e) => {
                            $.each($(snize.selectors.productTitle, e), function () {
                                let e = $(this),
                                    t = `<span>${e.text().replace("-", '</span><span class="last">')}</span>`;
                                e.html(t).addClass("snize-title--style");
                            });
                        },
                        _bestsellers: () => {
                            new MutationObserver(function (e) {
                                e.length > 0 && !$(snize.selectors.productTitle, $(snize.selectors.bestsellers)).hasClass("snize-title--style") && snize._styleProductTitle($(snize.selectors.bestsellers)),
                                    e.length > 0 && !$(snize.selectors.arrow, $(snize.selectors.bestsellers)).hasClass("snize-arrow--style") && snize._styleArrow();
                            }).observe($(snize.selectors.bestsellers)[0], { attributes: !0, childList: !0, characterData: !0, subtree: !0 });
                        },
                        _init: () => {
                            $(snize.selectors.bestsellers).length > 0 && snize._bestsellers(),
                                ($(snize.selectors.snizeResults, $(snize.selectors.templateCollection)).length > 0 || $(snize.selectors.snizeResults, $(snize.selectors.templatePage)).length > 0) && snize._collection();
                        },
                        _run: () => snize._init(),
                    }),
                    (globalThis.product = {
                        selectors: {
                            templateProduct: ".template-product",
                            form: ".product-form",
                            optionBtn: ".js-variant-changer",
                            optionBtnActive: ".js-variant-changer.m-current",
                            quantity: ".product-form__input--quantity",
                            btnUp: ".quantity__btn-up",
                            btnDown: ".quantity__btn-down",
                            productFormSubmit: "[data-product-form-submit]",
                            productFormQuantity: ".product-form__controls-group--quantity",
                            productFormVariantAvailable: ".product-form__variant-available",
                            productFormVariantAvailableInput: "[data-product-form-variant-input]",
                            micromodalBtn: "[data-micromodal-btn]",
                            productThumbnail: "[data-thumbnail-swiper]",
                            productThumbnailSlide: ".thumbnail-swiper__slide",
                            faqItem: ".shopify_explorer_faq__item",
                            faqQuestion: ".shopify_explorer_faq__question",
                            faqAnswer: ".shopify_explorer_faq__answer",
                            micromodal: "#micromodal-product-content",
                            micromodalContent: "#micromodal-product-content",
                            micromodalTitle: "#micromodal-product-title",
                            galerry: "[data-x]",
                            variantAvailableStatus: ".product__posted-status",
                        },
                        _rvp: (e) => `xRecentlyViewedProduct${e}`,
                        _setRecentlyViewed: () => {
                            let e = document.getElementById("ProductJson-product-template");
                            if (!e || !e.innerHTML.length) return;

                           //  console.log('JSON.parse(e.innerHTML)', JSON.parse(e.innerHTML))

                            // var variantsVar = JSON.parse(e.innerHTML);

                            // variantsVar = variantsVar.variants;

                            // console.log('variantsVar', variantsVar)

                            let {
                                id: id,
                                // variants = [JSON.parse(e.innerHTML.variants)],
                                featured_image: t,
                                description : ds,
                                handle: n, 
                                price: i, 
                                price_max: a, 
                                title: o } = JSON.parse(e.innerHTML),
                                r = JSON.stringify({
                                    id: id,
                                    // variants: variants,
                                    description: ds,
                                    featured_image: t, 
                                    handle: n, 
                                    price: i, 
                                    price_max: a, 
                                    title: o });
                            // console.log('type of variants', typeof variants)
                            // console.log('type of description', typeof description)
                            // console.log('r', r)
                            if ("" === _getCookie(product._rvp(1))) _setCookie(product._rvp(), 1), _setCookie(product._rvp(1), r);
                            else if ("" === _getCookie(product._rvp(2))) _setCookie(product._rvp(), 2), _setCookie(product._rvp(2), r);
                            else if ("" === _getCookie(product._rvp(3))) _setCookie(product._rvp(), 3), _setCookie(product._rvp(3), r);
                            else if ("" === _getCookie(product._rvp(4))) _setCookie(product._rvp(), 4), _setCookie(product._rvp(4), r);
                            else if (-1 === _getCookie(product._rvp(1)).indexOf(n) && -1 === _getCookie(product._rvp(2)).indexOf(n) && -1 === _getCookie(product._rvp(4)).indexOf(n))
                                switch (_getCookie(product._rvp())) {
                                    case "4":
                                        _setCookie(product._rvp(), 4), _setCookie(product._rvp(1), r);
                                        break;
                                    case "3":
                                        _setCookie(product._rvp(), 3), _setCookie(product._rvp(3), r);
                                        break;
                                    case "2":
                                        _setCookie(product._rvp(), 2), _setCookie(product._rvp(2), r);
                                        break;
                                    case "1":
                                        _setCookie(product._rvp(), 1), _setCookie(product._rvp(1), r);
                                        break;
                                    default:
                                        _setCookie(product._rvp(), 1), _setCookie(product._rvp(1), r);
                                }
                            return _getCookie(product._rvp());
                        },
                        _templateQuantity: (e, t) =>
                            `<div data-quantity-box class="quantity--xBox" id="quantity-${t}"><div class="quantity__btn quantity__btn-up">${theme.iconChevronDown}</div><div class="quantity__btn quantity__btn-down">${theme.iconChevronDown}</div></div>`,
                        _initQuantityArrows: () => {
                            $.each($(product.selectors.quantity), async (e, t) => {
                                let n = $(t),
                                    i = $(t).attr("id");
                                n.after(product._templateQuantity(i, e)),
                                    n.addClass("quantity__input").prependTo(`#quantity-${e}`),
                                    n.on("keydown", function (e) {
                                        if (!((e.keyCode > 95 && e.keyCode < 106) || (e.keyCode > 47 && e.keyCode < 58) || 8 == e.keyCode)) return !1;
                                    }),
                                    n.on("keyup", function (e) {
                                        let t = $(this),
                                            n = parseInt(t.val()),
                                            i = t.closest("[data-product-id]").data("product-id"),
                                            a = $(product.selectors.optionBtnActive).data("value"),
                                            o = product._getInventoryQuantity(i, a);
                                        void 0 !== i && n > product._getInventoryQuantity(i, a) && t.val(o);
                                    });
                            }),
                                $(product.selectors.btnUp).on("click", function () {
                                    let e = $(this).closest("[data-quantity-box]"),
                                        t = $(product.selectors.quantity, e),
                                        n = parseInt(t.val()),
                                        i = t.closest("[data-product-id]").data("product-id"),
                                        a = $(product.selectors.optionBtnActive).data("value");
                                    (n >= 1 && void 0 === i) || (n >= 1 && n < product._getInventoryQuantity(i, a)) ? t.val(n + 1) : ("" == t.val() || n <= 0) && t.val(1);
                                    console.log(t)
                                }),
                                $(product.selectors.btnDown).on("click", function () {
                                    let e = $(this).closest("[data-quantity-box]"),
                                        t = $(product.selectors.quantity, e),
                                        n = parseInt(t.val());
                                    n > 1 ? t.val(n - 1) : ("" == t.val() || n <= 0) && t.val(1);
                                });
                        },
                        _getInventoryQuantity: (e, t) => {
                            let n = document.getElementById("InventoryJson-" + e);
                            if (n && n.innerHTML.length) return JSON.parse(n.innerHTML)[t];
                        },
                        _getNameInventory: (e) => (0 === e ? theme.strings.out_of_stock : e >= 1 && e <= 20 ? theme.strings.running_out : e >= 21 && e <= 50 ? theme.strings.average : e > 50 ? theme.strings.large : void 0),
                        _setInventory: (e) => {
                            let t = $(product.selectors.form).closest("[data-product-id]"),
                                n = t.data("product-id"),
                                i = product._getInventoryQuantity(n, e),
                                a = $(product.selectors.quantity, t).val();
                            $("[data-inventory-quantity] dd", t).text(product._getNameInventory(i)), $(product.selectors.quantity, t).val(a <= i ? a : 1);
                        },
                        _setVariantAvailable: (e) => {
                            let t = $(product.selectors.form).closest("[data-product-id]").data("product-id"),
                                n = product._getInventoryQuantity(t, e),
                                i = `${product.selectors.productFormSubmit}, ${product.selectors.productFormQuantity}`;
                            0 === n
                                ? ($(i).addClass("hide"), $(product.selectors.micromodalBtn).removeClass("hide"), $(product.selectors.productFormVariantAvailableInput).val(e))
                                : ($(i).removeClass("hide"), $(product.selectors.micromodalBtn).addClass("hide"));
                        },
                        _initOption: () => {

                            $(document).on("click", product.selectors.optionBtn, function() {
                                let e = $(this),
                                    t = e.data("value"),
                                    n = e.data("id");
                                $(product.selectors.optionBtn, $(product.selectors.form)).removeClass("active"),
                                e.addClass("active"),
                                product._setInventory(t),
                                product._setVariantAvailable(t),
                                $(n).val(t),
                                $(n)[0].dispatchEvent(new Event("change"));
                            });

                            // $(product.selectors.optionBtn, $(product.selectors.form)).on("click", function () {
                            //     console.log(product.selectors.optionBtn)
                            //     console.log($(product.selectors.form))
                            //     let e = $(this),
                            //         t = e.data("value"),
                            //         n = e.data("id");
                            //     $(product.selectors.optionBtn, $(product.selectors.form)).removeClass("active"),
                            //     e.addClass("active"),
                            //     product._setInventory(t),
                            //     product._setVariantAvailable(t),
                            //     $(n).val(t),
                            //     $(n)[0].dispatchEvent(new Event("change"));
                            // });
                        },
                        _initSectionTabs: () => {

                            $(document).on("click","[data-section-to]:not(.m-off)",function() {
                                let e = $(this).data("section-to");
                                $("html, body").animate({ scrollTop: $(`[data-section-tab="${e}"]`).offset().top - $("#shopify-section-header").height() }, 800);
                            });

                        },
                        _initThumbnailSwiper: () => {
                            $.each($(product.selectors.productThumbnail), function () {
                                let e = `#${$(this).attr("id")}`;
                                new i.default(e, { slidesPerView: 4, spaceBetween: 12 }),
                                    $(product.selectors.productThumbnailSlide).on("click", function () {
                                        $(product.selectors.productThumbnailSlide).removeClass("active"), $(this).addClass("active");
                                    });
                            });
                        },
                        _initFAQ: () => {
                            $(product.selectors.faqQuestion, $(product.selectors.faqItem, $(product.selectors.templateProduct)).first()).addClass("active"),
                                $(product.selectors.faqQuestion, $(product.selectors.templateProduct)).on("click", function () {
                                    $(this).next(product.selectors.faqAnswer).slideToggle(150).toggleClass("active"), $(this).toggleClass("active");
                                });
                        },
                        _initMicroModal: () => {
                            $(product.selectors.micromodal).length > 0
                                ? l.default.init({
                                      onShow: (e) => {
                                          let t = $(product.selectors.productFormVariantAvailable).clone();
                                          $('[id="form-va-custom"]', t).attr("id", "form-va"),
                                              $('[name="contact[email]"]', t).attr("type", "email"),
                                              $('[id="regulationsInfo"]', t).attr("id", "regulations"),
                                              $('[for="regulationsInfo"]', t).attr("for", "regulations"),
                                              t.appendTo(product.selectors.micromodalContent),
                                              $(product.selectors.micromodalTitle).text(theme.strings.notify_ailability_title),
                                              $(product.selectors.micromodalTitle).after(`<p class="subtitle">${theme.strings.notify_ailability_subtitle}</p>`);
                                      },
                                      onClose: (e) => {
                                          $("#micromodal-product-content").html(""), $(product.selectors.micromodalTitle).text(""), $("+ .subtitle", $(product.selectors.micromodalTitle)).remove();
                                      },
                                      openTrigger: "data-custom-open",
                                      closeTrigger: "data-custom-close",
                                      openClass: "is-open",
                                  })
                                : console.log("micromodal null");
                        },
                        _initGalerry: async () => {
                            jQuery(product.selectors.galerry).fancybox({ infobar: !0, toolbar: !0, arrows: !0, loop: !0, touch: !0, thumbs: { autoStart: !0, axis: "x" }, buttons: ["thumbs", "close"], wheel: "auto" });
                        },
                        _initContactPosted: (e) => {
                            let t = $(product.selectors.variantAvailableStatus);
                            t.attr("variant-available-status");
                            t.hasClass("hide") || t.addClass("hide"), $(product.selectors.variantAvailableStatus + `[variant-available-status="${e}"]`).removeClass("hide");
                        },
                        _init: () => {
                            $(product.selectors.form).length > 0 && product._initOption(),
                                $(product.selectors.quantity).length > 0 && product._initQuantityArrows(),
                                $(product.selectors.templateProduct).length > 0 && product._setRecentlyViewed(),
                                $("[data-section-to]").length > 0 && product._initSectionTabs(),
                                $(product.selectors.productThumbnail).length && product._initThumbnailSwiper(),
                                $(product.selectors.faqQuestion, $(product.selectors.templateProduct)).length > 0 && product._initFAQ(),
                                $(product.selectors.productFormVariantAvailable).length > 0 && product._initMicroModal(),
                                $(product.selectors.galerry).length > 0 && product._initGalerry(),
                                -1 != location.search.indexOf("contact_posted=") && product._initContactPosted(-1 != location.search.indexOf("contact_posted=true"));
                        },
                        _run: () => product._init(),
                    }),
                    (globalThis.collection = {
                        selectors: { templateCollection: ".template-collection", blockName: ".recently-viewed-products", block: ".recently-viewed-products > .grid" },
                        _destroyRecentlyViewed: () => {
                            _setCookie(product._rvp(1), ""), _setCookie(product._rvp(2), ""), _setCookie(product._rvp(3), ""), _setCookie(product._rvp(4), "");
                        },
                        _initToTemplate: (e, t) => {

                            let n = -1 === _getCookie(product._rvp(t)).lastIndexOf('"}') ? JSON.parse(_getCookie(product._rvp(t)) + '"}') : JSON.parse(_getCookie(product._rvp(t))),
                                i = "";
                            n?.price_max && n.price < n.price_max && (i = theme.strings.fromLowestPrice.replace("[price]", "")),
                                0 === $(`.grid__item .grid-view-item__link[href="/products/${n.handle}"]`, e).length
                                    ? ($(`.grid__item[data-item="${t}"] .grid-view-item__link`, e)
                                          .prop("href", `/products/${n.handle}`)
                                          .on("click", function () {
                                              location.pathname = `/products/${n.handle}`; 
                                          }),
                                    //   $(`.grid__item[data-item="${t}"] .ajx-products__image`, e).html(`<img src="${n.featured_image}" alt="${n.title}" />`),
                                    //   $(`.grid__item[data-item="${t}"] .ajx-products__title`, e).html(`${n.title}`),
                                    //   $(`.grid__item[data-item="${t}"] .ajx-products__description`, e).html(`${n.description}`),
                                    //   $(`.grid__item[data-item="${t}"] .ajx-products__price-sc strong`, e).text(i + theme.Currency.formatMoney(n.price, theme.moneyFormat)),
                                      

                                    $(`.grid__item[data-item="${t}"] .grid-view-item__meta`, e).text(i + theme.Currency.formatMoney(n.price, theme.moneyFormat)))
                                    : $(`.grid__item[data-item="${t}"]`, e).remove();
                        },
                        _initRecentlyViewed: () => {
                            $.each($(collection.selectors.block), function () {
                                let e = $(this);
                                "" !== _getCookie(product._rvp(1)) ? collection._initToTemplate(e, 1) : $('.grid__item[data-item="1"]').hide(),
                                    "" !== _getCookie(product._rvp(2)) ? collection._initToTemplate(e, 2) : $('.grid__item[data-item="2"]').hide(),
                                    "" !== _getCookie(product._rvp(3)) ? collection._initToTemplate(e, 3) : $('.grid__item[data-item="3"]').hide(),
                                    "" !== _getCookie(product._rvp(4)) ? collection._initToTemplate(e, 4) : $('.grid__item[data-item="4"]').hide(),
                                    "" === _getCookie(product._rvp(1)) && "" === _getCookie(product._rvp(2)) && "" === _getCookie(product._rvp(3)) && "" === _getCookie(product._rvp(4)) && $(collection.selectors.blockName).hide();
                            });
                        },
                        _init: () => {
                            $(collection.selectors.block).length > 0 && collection._initRecentlyViewed();
                        },
                        _run: () => collection._init(),
                    }),
                    (globalThis.average_link = {
                        reviewCounter: () => {
                            new MutationObserver(function (e) {
                                $.each(e, (e, t) => {
                                    "childList" == t.type && average_link.activeReview();
                                });
                            }).observe($("#wc_review_section .wc_overall_review")[0], { attributes: !0, childList: !0, characterData: !0, subtree: !0 });
                        },
                        activeReview: () => {
                            $('a[average-link] [name="rating_test"][value="' + $(".wc_review_count .wc_icon_color:not(.wc_icon_empty)").length + '"]').prop("checked", !0);
                        },
                        init: () => {
                            if (
                                $("a[average-link]").length > 0 &&
                                ($("a[average-link]").on("click", function (e) {
                                    if ("" !== this.hash) {
                                        e.preventDefault();
                                        let t = this.hash;
                                        $("html, body").animate({ scrollTop: $(t).offset().top }, 800, function () {
                                            (window.location.hash = t), $("#wc_product_review_form").length > 0 && $("#wc_product_review_form").slideDown("slow");
                                        });
                                    }
                                }),
                                $("#wc_review_section").length > 0)
                            ) {
                                let e = setInterval(() => {
                                    $(".wc_review_count").length > 0 && (average_link.activeReview(), average_link.reviewCounter(), clearInterval(e));
                                });
                            }
                        },
                        run: () => {
                            average_link.init();
                        },
                    }),
                    $(async function () {
                        await slideshow._run(),
                            await headers._run(),
                            await cookies._run(),
                            await checkbox._run(),
                            Shopify.designMode && mutationMain(),
                            await quotes._run(),
                            await snize._run(),
                            await product._run(),
                            await collection._run(),
                            await average_link.run();
                    }),
                    $(function () {
                        if ($(".template-cart").length > 0) {
                            $('input[name="rolnik-platnik"]').on("change", function () {
                                $(".nip-container, .pesel-container").toggleClass("active"),
                                    $("#input-nip, #input-pesel").attr("required"),
                                    $("#input-nip, #input-pesel").val(""),
                                    $("#rolnik").attr("checked")
                                        ? ($("#rolnik").removeAttr("checked"),
                                          $("#rolnik").prop("checked", !1),
                                          $("#platnik").attr("checked", "checked"),
                                          $("#platnik").prop("checked", !0),
                                          $("#input-pesel").removeAttr("required"),
                                          $("#input-nip").attr("required", "required"))
                                        : ($("#platnik").removeAttr("checked"),
                                          $("#platnik").prop("checked", !1),
                                          $("#rolnik").attr("checked", "checked"),
                                          $("#rolnik").prop("checked", !0),
                                          $("#input-nip").removeAttr("required"),
                                          $("#input-pesel").attr("required", "required"));
                            }),
                                $("#input-pesel").on("keyup", function () {
                                    $(".pesel-container").hasClass("active") &&
                                        (1 ==
                                        (function (e) {
                                            let t = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3],
                                                n = 0,
                                                i = parseInt(e.substring(10, 11));
                                            for (let i = 0; i < t.length; i++) n += parseInt(e.substring(i, i + 1)) * t[i];
                                            return (n %= 10), (10 - n) % 10 === i;
                                        })($("#input-pesel").val())
                                            ? ($("#checkout").removeAttr("disabled"), $("#input-pesel").css("border", "3px solid green"), $(".input-pesel__text--warning").css("display", "none"))
                                            : ($("#checkout").prop("disabled", !0), $("#input-pesel").css("border", "3px solid red"), $(".input-pesel__text--warning").css("display", "block")));
                                }),
                                $("#input-nip").on("keyup", function () {
                                    $(".nip-container").hasClass("active") &&
                                        (1 ==
                                        (function (e) {
                                            if ("string" != typeof e) return !1;
                                            e = e.replace(/[\ \-]/gi, "");
                                            let t = [6, 5, 7, 2, 3, 4, 5, 6, 7],
                                                n = 0,
                                                i = parseInt(e.substring(9, 10)),
                                                a = t.length;
                                            for (let i = 0; i < a; i++) n += parseInt(e.substr(i, 1)) * t[i];
                                            return n % 11 === i;
                                        })($("#input-nip").val())
                                            ? ($("#checkout").removeAttr("disabled"), $("#input-nip").css("border", "3px solid green"), $(".input-nip__text--warning").css("display", "none"))
                                            : ($("#checkout").prop("disabled", !0), $("#input-nip").css("border", "3px solid red"), $(".input-nip__text--warning").css("display", "block")));
                                });
                            const e = document.querySelector(".cart-subtotal__price");
                            const t = { childList: !0 };
                            new MutationObserver(function (e, t) {
                                $(".cart-info__maxprice, .cart-info__remainingProductsForPromo").empty(), $(".cart-modal-container, .cart-modal, .cart-header__info").empty(), $(".cart-info__link").remove(), c();
                            }).observe(e, t),
                                c();
                        }
                    });
            },
            (e, t, n) => {
                "use strict";
                n.r(t), n.d(t, { default: () => P });
                var i = n(2),
                    a = n(6),
                    o = n(66),
                    r = n(67),
                    s = n(68),
                    l = n(70),
                    c = n(71),
                    d = n(5),
                    u = n(7),
                    p = n(8),
                    f = n(18),
                    h = n(24),
                    g = n(28),
                    v = n(36),
                    m = n(40),
                    b = n(43),
                    w = n(49),
                    y = n(56),
                    x = n(60),
                    C = n(63),
                    T = n(59),
                    S = n(69);
                function A(e, t) {
                    for (var n = 0; n < t.length; n++) {
                        var i = t[n];
                        (i.enumerable = i.enumerable || !1), (i.configurable = !0), "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
                    }
                }
                var $ = {
                        modular: d.default,
                        eventsEmitter: u.default,
                        update: p.default,
                        translate: f.default,
                        transition: h.default,
                        slide: g.default,
                        loop: v.default,
                        grabCursor: m.default,
                        manipulation: b.default,
                        events: w.default,
                        breakpoints: y.default,
                        checkOverflow: T.default,
                        classes: x.default,
                        images: C.default,
                    },
                    E = {},
                    k = (function () {
                        function e() {
                            for (var t, n, l = arguments.length, c = new Array(l), d = 0; d < l; d++) c[d] = arguments[d];
                            1 === c.length && c[0].constructor && c[0].constructor === Object ? (n = c[0]) : ((t = c[0]), (n = c[1])), n || (n = {}), (n = (0, a.extend)({}, n)), t && !n.el && (n.el = t);
                            var u = this;
                            (u.support = (0, o.getSupport)()),
                                (u.device = (0, r.getDevice)({ userAgent: n.userAgent })),
                                (u.browser = (0, s.getBrowser)()),
                                (u.eventsListeners = {}),
                                (u.eventsAnyListeners = []),
                                void 0 === u.modules && (u.modules = {}),
                                Object.keys(u.modules).forEach(function (e) {
                                    var t = u.modules[e];
                                    if (t.params) {
                                        var i = Object.keys(t.params)[0],
                                            a = t.params[i];
                                        if ("object" != typeof a || null === a) return;
                                        if (!(i in n) || !("enabled" in a)) return;
                                        !0 === n[i] && (n[i] = { enabled: !0 }), "object" != typeof n[i] || "enabled" in n[i] || (n[i].enabled = !0), n[i] || (n[i] = { enabled: !1 });
                                    }
                                });
                            var p = (0, a.extend)({}, S.default);
                            u.useParams(p),
                                (u.params = (0, a.extend)({}, p, E, n)),
                                (u.originalParams = (0, a.extend)({}, u.params)),
                                (u.passedParams = (0, a.extend)({}, n)),
                                u.params &&
                                    u.params.on &&
                                    Object.keys(u.params.on).forEach(function (e) {
                                        u.on(e, u.params.on[e]);
                                    }),
                                u.params && u.params.onAny && u.onAny(u.params.onAny),
                                (u.$ = i.default);
                            var f = (0, i.default)(u.params.el);
                            if ((t = f[0])) {
                                if (f.length > 1) {
                                    var h = [];
                                    return (
                                        f.each(function (t) {
                                            var i = (0, a.extend)({}, n, { el: t });
                                            h.push(new e(i));
                                        }),
                                        h
                                    );
                                }
                                var g, v, m;
                                return (
                                    (t.swiper = u),
                                    t && t.shadowRoot && t.shadowRoot.querySelector
                                        ? ((g = (0, i.default)(t.shadowRoot.querySelector("." + u.params.wrapperClass))).children = function (e) {
                                              return f.children(e);
                                          })
                                        : (g = f.children("." + u.params.wrapperClass)),
                                    (0, a.extend)(u, {
                                        $el: f,
                                        el: t,
                                        $wrapperEl: g,
                                        wrapperEl: g[0],
                                        classNames: [],
                                        slides: (0, i.default)(),
                                        slidesGrid: [],
                                        snapGrid: [],
                                        slidesSizesGrid: [],
                                        isHorizontal: function () {
                                            return "horizontal" === u.params.direction;
                                        },
                                        isVertical: function () {
                                            return "vertical" === u.params.direction;
                                        },
                                        rtl: "rtl" === t.dir.toLowerCase() || "rtl" === f.css("direction"),
                                        rtlTranslate: "horizontal" === u.params.direction && ("rtl" === t.dir.toLowerCase() || "rtl" === f.css("direction")),
                                        wrongRTL: "-webkit-box" === g.css("display"),
                                        activeIndex: 0,
                                        realIndex: 0,
                                        isBeginning: !0,
                                        isEnd: !1,
                                        translate: 0,
                                        previousTranslate: 0,
                                        progress: 0,
                                        velocity: 0,
                                        animating: !1,
                                        allowSlideNext: u.params.allowSlideNext,
                                        allowSlidePrev: u.params.allowSlidePrev,
                                        touchEvents:
                                            ((v = ["touchstart", "touchmove", "touchend", "touchcancel"]),
                                            (m = ["mousedown", "mousemove", "mouseup"]),
                                            u.support.pointerEvents && (m = ["pointerdown", "pointermove", "pointerup"]),
                                            (u.touchEventsTouch = { start: v[0], move: v[1], end: v[2], cancel: v[3] }),
                                            (u.touchEventsDesktop = { start: m[0], move: m[1], end: m[2] }),
                                            u.support.touch || !u.params.simulateTouch ? u.touchEventsTouch : u.touchEventsDesktop),
                                        touchEventsData: {
                                            isTouched: void 0,
                                            isMoved: void 0,
                                            allowTouchCallbacks: void 0,
                                            touchStartTime: void 0,
                                            isScrolling: void 0,
                                            currentTranslate: void 0,
                                            startTranslate: void 0,
                                            allowThresholdMove: void 0,
                                            formElements: "input, select, option, textarea, button, video, label",
                                            lastClickTime: (0, a.now)(),
                                            clickTimeout: void 0,
                                            velocities: [],
                                            allowMomentumBounce: void 0,
                                            isTouchEvent: void 0,
                                            startMoving: void 0,
                                        },
                                        allowClick: !0,
                                        allowTouchMove: u.params.allowTouchMove,
                                        touches: { startX: 0, startY: 0, currentX: 0, currentY: 0, diff: 0 },
                                        imagesToLoad: [],
                                        imagesLoaded: 0,
                                    }),
                                    u.useModules(),
                                    u.emit("_swiper"),
                                    u.params.init && u.init(),
                                    u
                                );
                            }
                        }
                        var t,
                            n,
                            l,
                            c = e.prototype;
                        return (
                            (c.emitContainerClasses = function () {
                                var e = this;
                                if (e.params._emitClasses && e.el) {
                                    var t = e.el.className.split(" ").filter(function (t) {
                                        return 0 === t.indexOf("swiper-container") || 0 === t.indexOf(e.params.containerModifierClass);
                                    });
                                    e.emit("_containerClasses", t.join(" "));
                                }
                            }),
                            (c.getSlideClasses = function (e) {
                                var t = this;
                                return e.className
                                    .split(" ")
                                    .filter(function (e) {
                                        return 0 === e.indexOf("swiper-slide") || 0 === e.indexOf(t.params.slideClass);
                                    })
                                    .join(" ");
                            }),
                            (c.emitSlidesClasses = function () {
                                var e = this;
                                e.params._emitClasses &&
                                    e.el &&
                                    e.slides.each(function (t) {
                                        var n = e.getSlideClasses(t);
                                        e.emit("_slideClass", t, n);
                                    });
                            }),
                            (c.slidesPerViewDynamic = function () {
                                var e = this,
                                    t = e.params,
                                    n = e.slides,
                                    i = e.slidesGrid,
                                    a = e.size,
                                    o = e.activeIndex,
                                    r = 1;
                                if (t.centeredSlides) {
                                    for (var s, l = n[o].swiperSlideSize, c = o + 1; c < n.length; c += 1) n[c] && !s && ((r += 1), (l += n[c].swiperSlideSize) > a && (s = !0));
                                    for (var d = o - 1; d >= 0; d -= 1) n[d] && !s && ((r += 1), (l += n[d].swiperSlideSize) > a && (s = !0));
                                } else for (var u = o + 1; u < n.length; u += 1) i[u] - i[o] < a && (r += 1);
                                return r;
                            }),
                            (c.update = function () {
                                var e = this;
                                if (e && !e.destroyed) {
                                    var t = e.snapGrid,
                                        n = e.params;
                                    n.breakpoints && e.setBreakpoint(),
                                        e.updateSize(),
                                        e.updateSlides(),
                                        e.updateProgress(),
                                        e.updateSlidesClasses(),
                                        e.params.freeMode
                                            ? (i(), e.params.autoHeight && e.updateAutoHeight())
                                            : (("auto" === e.params.slidesPerView || e.params.slidesPerView > 1) && e.isEnd && !e.params.centeredSlides ? e.slideTo(e.slides.length - 1, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0)) ||
                                              i(),
                                        n.watchOverflow && t !== e.snapGrid && e.checkOverflow(),
                                        e.emit("update");
                                }
                                function i() {
                                    var t = e.rtlTranslate ? -1 * e.translate : e.translate,
                                        n = Math.min(Math.max(t, e.maxTranslate()), e.minTranslate());
                                    e.setTranslate(n), e.updateActiveIndex(), e.updateSlidesClasses();
                                }
                            }),
                            (c.changeDirection = function (e, t) {
                                void 0 === t && (t = !0);
                                var n = this,
                                    i = n.params.direction;
                                return (
                                    e || (e = "horizontal" === i ? "vertical" : "horizontal"),
                                    e === i ||
                                        ("horizontal" !== e && "vertical" !== e) ||
                                        (n.$el.removeClass("" + n.params.containerModifierClass + i).addClass("" + n.params.containerModifierClass + e),
                                        n.emitContainerClasses(),
                                        (n.params.direction = e),
                                        n.slides.each(function (t) {
                                            "vertical" === e ? (t.style.width = "") : (t.style.height = "");
                                        }),
                                        n.emit("changeDirection"),
                                        t && n.update()),
                                    n
                                );
                            }),
                            (c.init = function () {
                                var e = this;
                                e.initialized ||
                                    (e.emit("beforeInit"),
                                    e.params.breakpoints && e.setBreakpoint(),
                                    e.addClasses(),
                                    e.params.loop && e.loopCreate(),
                                    e.updateSize(),
                                    e.updateSlides(),
                                    e.params.watchOverflow && e.checkOverflow(),
                                    e.params.grabCursor && e.setGrabCursor(),
                                    e.params.preloadImages && e.preloadImages(),
                                    e.params.loop ? e.slideTo(e.params.initialSlide + e.loopedSlides, 0, e.params.runCallbacksOnInit) : e.slideTo(e.params.initialSlide, 0, e.params.runCallbacksOnInit),
                                    e.attachEvents(),
                                    (e.initialized = !0),
                                    e.emit("init"),
                                    e.emit("afterInit"));
                            }),
                            (c.destroy = function (e, t) {
                                void 0 === e && (e = !0), void 0 === t && (t = !0);
                                var n = this,
                                    i = n.params,
                                    o = n.$el,
                                    r = n.$wrapperEl,
                                    s = n.slides;
                                return (
                                    void 0 === n.params ||
                                        n.destroyed ||
                                        (n.emit("beforeDestroy"),
                                        (n.initialized = !1),
                                        n.detachEvents(),
                                        i.loop && n.loopDestroy(),
                                        t &&
                                            (n.removeClasses(),
                                            o.removeAttr("style"),
                                            r.removeAttr("style"),
                                            s && s.length && s.removeClass([i.slideVisibleClass, i.slideActiveClass, i.slideNextClass, i.slidePrevClass].join(" ")).removeAttr("style").removeAttr("data-swiper-slide-index")),
                                        n.emit("destroy"),
                                        Object.keys(n.eventsListeners).forEach(function (e) {
                                            n.off(e);
                                        }),
                                        !1 !== e && ((n.$el[0].swiper = null), (0, a.deleteProps)(n)),
                                        (n.destroyed = !0)),
                                    null
                                );
                            }),
                            (e.extendDefaults = function (e) {
                                (0, a.extend)(E, e);
                            }),
                            (e.installModule = function (t) {
                                e.prototype.modules || (e.prototype.modules = {});
                                var n = t.name || Object.keys(e.prototype.modules).length + "_" + (0, a.now)();
                                e.prototype.modules[n] = t;
                            }),
                            (e.use = function (t) {
                                return Array.isArray(t)
                                    ? (t.forEach(function (t) {
                                          return e.installModule(t);
                                      }),
                                      e)
                                    : (e.installModule(t), e);
                            }),
                            (t = e),
                            (l = [
                                {
                                    key: "extendedDefaults",
                                    get: function () {
                                        return E;
                                    },
                                },
                                {
                                    key: "defaults",
                                    get: function () {
                                        return S.default;
                                    },
                                },
                            ]),
                            (n = null) && A(t.prototype, n),
                            l && A(t, l),
                            e
                        );
                    })();
                Object.keys($).forEach(function (e) {
                    Object.keys($[e]).forEach(function (t) {
                        k.prototype[t] = $[e][t];
                    });
                }),
                    k.use([l.default, c.default]);
                const P = k;
            },
            (e, t, n) => {
                "use strict";
                n.r(t), n.d(t, { default: () => o });
                var i = n(3),
                    a = {
                        addClass: i.addClass,
                        removeClass: i.removeClass,
                        hasClass: i.hasClass,
                        toggleClass: i.toggleClass,
                        attr: i.attr,
                        removeAttr: i.removeAttr,
                        transform: i.transform,
                        transition: i.transition,
                        on: i.on,
                        off: i.off,
                        trigger: i.trigger,
                        transitionEnd: i.transitionEnd,
                        outerWidth: i.outerWidth,
                        outerHeight: i.outerHeight,
                        styles: i.styles,
                        offset: i.offset,
                        css: i.css,
                        each: i.each,
                        html: i.html,
                        text: i.text,
                        is: i.is,
                        index: i.index,
                        eq: i.eq,
                        append: i.append,
                        prepend: i.prepend,
                        next: i.next,
                        nextAll: i.nextAll,
                        prev: i.prev,
                        prevAll: i.prevAll,
                        parent: i.parent,
                        parents: i.parents,
                        closest: i.closest,
                        find: i.find,
                        children: i.children,
                        filter: i.filter,
                        remove: i.remove,
                    };
                Object.keys(a).forEach(function (e) {
                    i.$.fn[e] = a[e];
                });
                const o = i.$;
            },
            (e, t, n) => {
                "use strict";
                n.r(t),
                    n.d(t, {
                        default: () => Ye,
                        $: () => p,
                        add: () => fe,
                        addClass: () => f,
                        animate: () => be,
                        animationEnd: () => L,
                        append: () => U,
                        appendTo: () => Q,
                        attr: () => m,
                        blur: () => Te,
                        change: () => _e,
                        children: () => de,
                        click: () => Ce,
                        closest: () => le,
                        css: () => q,
                        data: () => y,
                        dataset: () => C,
                        detach: () => pe,
                        each: () => N,
                        empty: () => he,
                        eq: () => X,
                        filter: () => R,
                        find: () => ce,
                        focus: () => Se,
                        focusin: () => Ae,
                        focusout: () => $e,
                        hasClass: () => v,
                        height: () => O,
                        hide: () => F,
                        html: () => Y,
                        index: () => W,
                        insertAfter: () => ee,
                        insertBefore: () => J,
                        is: () => G,
                        keydown: () => ke,
                        keypress: () => Pe,
                        keyup: () => Ee,
                        mousedown: () => Le,
                        mouseenter: () => Oe,
                        mouseleave: () => De,
                        mousemove: () => ze,
                        mouseout: () => Be,
                        mouseover: () => Fe,
                        mouseup: () => Ie,
                        next: () => te,
                        nextAll: () => ne,
                        off: () => k,
                        offset: () => B,
                        on: () => E,
                        once: () => P,
                        outerHeight: () => D,
                        outerWidth: () => I,
                        parent: () => re,
                        parents: () => se,
                        prepend: () => Z,
                        prependTo: () => K,
                        prev: () => ie,
                        prevAll: () => ae,
                        prop: () => w,
                        remove: () => ue,
                        removeAttr: () => b,
                        removeClass: () => h,
                        removeData: () => x,
                        resize: () => Ne,
                        scroll: () => Re,
                        scrollLeft: () => me,
                        scrollTo: () => ge,
                        scrollTop: () => ve,
                        show: () => j,
                        siblings: () => oe,
                        stop: () => we,
                        styles: () => H,
                        submit: () => Me,
                        text: () => V,
                        toggleClass: () => g,
                        touchend: () => He,
                        touchmove: () => qe,
                        touchstart: () => je,
                        transform: () => A,
                        transition: () => $,
                        transitionEnd: () => _,
                        trigger: () => M,
                        val: () => T,
                        value: () => S,
                        width: () => z,
                    });
                var i = n(4);
                function a(e) {
                    return (a = Object.setPrototypeOf
                        ? Object.getPrototypeOf
                        : function (e) {
                              return e.__proto__ || Object.getPrototypeOf(e);
                          })(e);
                }
                function o(e, t) {
                    return (o =
                        Object.setPrototypeOf ||
                        function (e, t) {
                            return (e.__proto__ = t), e;
                        })(e, t);
                }
                function r() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }
                function s(e, t, n) {
                    return (s = r()
                        ? Reflect.construct
                        : function (e, t, n) {
                              var i = [null];
                              i.push.apply(i, t);
                              var a = new (Function.bind.apply(e, i))();
                              return n && o(a, n.prototype), a;
                          }).apply(null, arguments);
                }
                function l(e) {
                    var t = "function" == typeof Map ? new Map() : void 0;
                    return (l = function (e) {
                        if (null === e || ((n = e), -1 === Function.toString.call(n).indexOf("[native code]"))) return e;
                        var n;
                        if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                        if (void 0 !== t) {
                            if (t.has(e)) return t.get(e);
                            t.set(e, i);
                        }
                        function i() {
                            return s(e, arguments, a(this).constructor);
                        }
                        return (i.prototype = Object.create(e.prototype, { constructor: { value: i, enumerable: !1, writable: !0, configurable: !0 } })), o(i, e);
                    })(e);
                }
                var c = (function (e) {
                    var t, n;
                    function i(t) {
                        var n, i, a;
                        return (
                            (n = e.call.apply(e, [this].concat(t)) || this),
                            (i = (function (e) {
                                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                                return e;
                            })(n)),
                            (a = i.__proto__),
                            Object.defineProperty(i, "__proto__", {
                                get: function () {
                                    return a;
                                },
                                set: function (e) {
                                    a.__proto__ = e;
                                },
                            }),
                            n
                        );
                    }
                    return (n = e), ((t = i).prototype = Object.create(n.prototype)), (t.prototype.constructor = t), (t.__proto__ = n), i;
                })(l(Array));
                function d(e) {
                    void 0 === e && (e = []);
                    var t = [];
                    return (
                        e.forEach(function (e) {
                            Array.isArray(e) ? t.push.apply(t, d(e)) : t.push(e);
                        }),
                        t
                    );
                }
                function u(e, t) {
                    return Array.prototype.filter.call(e, t);
                }
                function p(e, t) {
                    var n = (0, i.getWindow)(),
                        a = (0, i.getDocument)(),
                        o = [];
                    if (!t && e instanceof c) return e;
                    if (!e) return new c(o);
                    if ("string" == typeof e) {
                        var r = e.trim();
                        if (r.indexOf("<") >= 0 && r.indexOf(">") >= 0) {
                            var s = "div";
                            0 === r.indexOf("<li") && (s = "ul"),
                                0 === r.indexOf("<tr") && (s = "tbody"),
                                (0 !== r.indexOf("<td") && 0 !== r.indexOf("<th")) || (s = "tr"),
                                0 === r.indexOf("<tbody") && (s = "table"),
                                0 === r.indexOf("<option") && (s = "select");
                            var l = a.createElement(s);
                            l.innerHTML = r;
                            for (var d = 0; d < l.childNodes.length; d += 1) o.push(l.childNodes[d]);
                        } else
                            o = (function (e, t) {
                                if ("string" != typeof e) return [e];
                                for (var n = [], i = t.querySelectorAll(e), a = 0; a < i.length; a += 1) n.push(i[a]);
                                return n;
                            })(e.trim(), t || a);
                    } else if (e.nodeType || e === n || e === a) o.push(e);
                    else if (Array.isArray(e)) {
                        if (e instanceof c) return e;
                        o = e;
                    }
                    return new c(
                        (function (e) {
                            for (var t = [], n = 0; n < e.length; n += 1) -1 === t.indexOf(e[n]) && t.push(e[n]);
                            return t;
                        })(o)
                    );
                }
                function f() {
                    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
                    var i = d(
                        t.map(function (e) {
                            return e.split(" ");
                        })
                    );
                    return (
                        this.forEach(function (e) {
                            var t;
                            (t = e.classList).add.apply(t, i);
                        }),
                        this
                    );
                }
                function h() {
                    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
                    var i = d(
                        t.map(function (e) {
                            return e.split(" ");
                        })
                    );
                    return (
                        this.forEach(function (e) {
                            var t;
                            (t = e.classList).remove.apply(t, i);
                        }),
                        this
                    );
                }
                function g() {
                    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
                    var i = d(
                        t.map(function (e) {
                            return e.split(" ");
                        })
                    );
                    this.forEach(function (e) {
                        i.forEach(function (t) {
                            e.classList.toggle(t);
                        });
                    });
                }
                function v() {
                    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
                    var i = d(
                        t.map(function (e) {
                            return e.split(" ");
                        })
                    );
                    return (
                        u(this, function (e) {
                            return (
                                i.filter(function (t) {
                                    return e.classList.contains(t);
                                }).length > 0
                            );
                        }).length > 0
                    );
                }
                function m(e, t) {
                    if (1 === arguments.length && "string" == typeof e) return this[0] ? this[0].getAttribute(e) : void 0;
                    for (var n = 0; n < this.length; n += 1)
                        if (2 === arguments.length) this[n].setAttribute(e, t);
                        else for (var i in e) (this[n][i] = e[i]), this[n].setAttribute(i, e[i]);
                    return this;
                }
                function b(e) {
                    for (var t = 0; t < this.length; t += 1) this[t].removeAttribute(e);
                    return this;
                }
                function w(e, t) {
                    if (1 !== arguments.length || "string" != typeof e) {
                        for (var n = 0; n < this.length; n += 1)
                            if (2 === arguments.length) this[n][e] = t;
                            else for (var i in e) this[n][i] = e[i];
                        return this;
                    }
                    return this[0] ? this[0][e] : this;
                }
                function y(e, t) {
                    var n;
                    if (void 0 === t) {
                        if (!(n = this[0])) return;
                        if (n.dom7ElementDataStorage && e in n.dom7ElementDataStorage) return n.dom7ElementDataStorage[e];
                        var i = n.getAttribute("data-" + e);
                        return i || void 0;
                    }
                    for (var a = 0; a < this.length; a += 1) (n = this[a]).dom7ElementDataStorage || (n.dom7ElementDataStorage = {}), (n.dom7ElementDataStorage[e] = t);
                    return this;
                }
                function x(e) {
                    for (var t = 0; t < this.length; t += 1) {
                        var n = this[t];
                        n.dom7ElementDataStorage && n.dom7ElementDataStorage[e] && ((n.dom7ElementDataStorage[e] = null), delete n.dom7ElementDataStorage[e]);
                    }
                }
                function C() {
                    var e = this[0];
                    if (e) {
                        var t,
                            n = {};
                        if (e.dataset) for (var i in e.dataset) n[i] = e.dataset[i];
                        else
                            for (var a = 0; a < e.attributes.length; a += 1) {
                                var o = e.attributes[a];
                                o.name.indexOf("data-") >= 0 &&
                                    (n[
                                        ((t = o.name.split("data-")[1]),
                                        t.toLowerCase().replace(/-(.)/g, function (e, t) {
                                            return t.toUpperCase();
                                        }))
                                    ] = o.value);
                            }
                        for (var r in n) "false" === n[r] ? (n[r] = !1) : "true" === n[r] ? (n[r] = !0) : parseFloat(n[r]) === 1 * n[r] && (n[r] *= 1);
                        return n;
                    }
                }
                function T(e) {
                    if (void 0 === e) {
                        var t = this[0];
                        if (!t) return;
                        if (t.multiple && "select" === t.nodeName.toLowerCase()) {
                            for (var n = [], i = 0; i < t.selectedOptions.length; i += 1) n.push(t.selectedOptions[i].value);
                            return n;
                        }
                        return t.value;
                    }
                    for (var a = 0; a < this.length; a += 1) {
                        var o = this[a];
                        if (Array.isArray(e) && o.multiple && "select" === o.nodeName.toLowerCase()) for (var r = 0; r < o.options.length; r += 1) o.options[r].selected = e.indexOf(o.options[r].value) >= 0;
                        else o.value = e;
                    }
                    return this;
                }
                function S(e) {
                    return this.val(e);
                }
                function A(e) {
                    for (var t = 0; t < this.length; t += 1) this[t].style.transform = e;
                    return this;
                }
                function $(e) {
                    for (var t = 0; t < this.length; t += 1) this[t].style.transitionDuration = "string" != typeof e ? e + "ms" : e;
                    return this;
                }
                function E() {
                    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
                    var i = t[0],
                        a = t[1],
                        o = t[2],
                        r = t[3];
                    function s(e) {
                        var t = e.target;
                        if (t) {
                            var n = e.target.dom7EventData || [];
                            if ((n.indexOf(e) < 0 && n.unshift(e), p(t).is(a))) o.apply(t, n);
                            else for (var i = p(t).parents(), r = 0; r < i.length; r += 1) p(i[r]).is(a) && o.apply(i[r], n);
                        }
                    }
                    function l(e) {
                        var t = (e && e.target && e.target.dom7EventData) || [];
                        t.indexOf(e) < 0 && t.unshift(e), o.apply(this, t);
                    }
                    "function" == typeof t[1] && ((i = t[0]), (o = t[1]), (r = t[2]), (a = void 0)), r || (r = !1);
                    for (var c, d = i.split(" "), u = 0; u < this.length; u += 1) {
                        var f = this[u];
                        if (a)
                            for (c = 0; c < d.length; c += 1) {
                                var h = d[c];
                                f.dom7LiveListeners || (f.dom7LiveListeners = {}), f.dom7LiveListeners[h] || (f.dom7LiveListeners[h] = []), f.dom7LiveListeners[h].push({ listener: o, proxyListener: s }), f.addEventListener(h, s, r);
                            }
                        else
                            for (c = 0; c < d.length; c += 1) {
                                var g = d[c];
                                f.dom7Listeners || (f.dom7Listeners = {}), f.dom7Listeners[g] || (f.dom7Listeners[g] = []), f.dom7Listeners[g].push({ listener: o, proxyListener: l }), f.addEventListener(g, l, r);
                            }
                    }
                    return this;
                }
                function k() {
                    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
                    var i = t[0],
                        a = t[1],
                        o = t[2],
                        r = t[3];
                    "function" == typeof t[1] && ((i = t[0]), (o = t[1]), (r = t[2]), (a = void 0)), r || (r = !1);
                    for (var s = i.split(" "), l = 0; l < s.length; l += 1)
                        for (var c = s[l], d = 0; d < this.length; d += 1) {
                            var u = this[d],
                                p = void 0;
                            if ((!a && u.dom7Listeners ? (p = u.dom7Listeners[c]) : a && u.dom7LiveListeners && (p = u.dom7LiveListeners[c]), p && p.length))
                                for (var f = p.length - 1; f >= 0; f -= 1) {
                                    var h = p[f];
                                    (o && h.listener === o) || (o && h.listener && h.listener.dom7proxy && h.listener.dom7proxy === o)
                                        ? (u.removeEventListener(c, h.proxyListener, r), p.splice(f, 1))
                                        : o || (u.removeEventListener(c, h.proxyListener, r), p.splice(f, 1));
                                }
                        }
                    return this;
                }
                function P() {
                    for (var e = this, t = arguments.length, n = new Array(t), i = 0; i < t; i++) n[i] = arguments[i];
                    var a = n[0],
                        o = n[1],
                        r = n[2],
                        s = n[3];
                    function l() {
                        for (var t = arguments.length, n = new Array(t), i = 0; i < t; i++) n[i] = arguments[i];
                        r.apply(this, n), e.off(a, o, l, s), l.dom7proxy && delete l.dom7proxy;
                    }
                    return "function" == typeof n[1] && ((a = n[0]), (r = n[1]), (s = n[2]), (o = void 0)), (l.dom7proxy = r), e.on(a, o, l, s);
                }
                function M() {
                    for (var e = (0, i.getWindow)(), t = arguments.length, n = new Array(t), a = 0; a < t; a++) n[a] = arguments[a];
                    for (var o = n[0].split(" "), r = n[1], s = 0; s < o.length; s += 1)
                        for (var l = o[s], c = 0; c < this.length; c += 1) {
                            var d = this[c];
                            if (e.CustomEvent) {
                                var u = new e.CustomEvent(l, { detail: r, bubbles: !0, cancelable: !0 });
                                (d.dom7EventData = n.filter(function (e, t) {
                                    return t > 0;
                                })),
                                    d.dispatchEvent(u),
                                    (d.dom7EventData = []),
                                    delete d.dom7EventData;
                            }
                        }
                    return this;
                }
                function _(e) {
                    var t = this;
                    return (
                        e &&
                            t.on("transitionend", function n(i) {
                                i.target === this && (e.call(this, i), t.off("transitionend", n));
                            }),
                        this
                    );
                }
                function L(e) {
                    var t = this;
                    return (
                        e &&
                            t.on("animationend", function n(i) {
                                i.target === this && (e.call(this, i), t.off("animationend", n));
                            }),
                        this
                    );
                }
                function z() {
                    var e = (0, i.getWindow)();
                    return this[0] === e ? e.innerWidth : this.length > 0 ? parseFloat(this.css("width")) : null;
                }
                function I(e) {
                    if (this.length > 0) {
                        if (e) {
                            var t = this.styles();
                            return this[0].offsetWidth + parseFloat(t.getPropertyValue("margin-right")) + parseFloat(t.getPropertyValue("margin-left"));
                        }
                        return this[0].offsetWidth;
                    }
                    return null;
                }
                function O() {
                    var e = (0, i.getWindow)();
                    return this[0] === e ? e.innerHeight : this.length > 0 ? parseFloat(this.css("height")) : null;
                }
                function D(e) {
                    if (this.length > 0) {
                        if (e) {
                            var t = this.styles();
                            return this[0].offsetHeight + parseFloat(t.getPropertyValue("margin-top")) + parseFloat(t.getPropertyValue("margin-bottom"));
                        }
                        return this[0].offsetHeight;
                    }
                    return null;
                }
                function B() {
                    if (this.length > 0) {
                        var e = (0, i.getWindow)(),
                            t = (0, i.getDocument)(),
                            n = this[0],
                            a = n.getBoundingClientRect(),
                            o = t.body,
                            r = n.clientTop || o.clientTop || 0,
                            s = n.clientLeft || o.clientLeft || 0,
                            l = n === e ? e.scrollY : n.scrollTop,
                            c = n === e ? e.scrollX : n.scrollLeft;
                        return { top: a.top + l - r, left: a.left + c - s };
                    }
                    return null;
                }
                function F() {
                    for (var e = 0; e < this.length; e += 1) this[e].style.display = "none";
                    return this;
                }
                function j() {
                    for (var e = (0, i.getWindow)(), t = 0; t < this.length; t += 1) {
                        var n = this[t];
                        "none" === n.style.display && (n.style.display = ""), "none" === e.getComputedStyle(n, null).getPropertyValue("display") && (n.style.display = "block");
                    }
                    return this;
                }
                function H() {
                    var e = (0, i.getWindow)();
                    return this[0] ? e.getComputedStyle(this[0], null) : {};
                }
                function q(e, t) {
                    var n,
                        a = (0, i.getWindow)();
                    if (1 === arguments.length) {
                        if ("string" != typeof e) {
                            for (n = 0; n < this.length; n += 1) for (var o in e) this[n].style[o] = e[o];
                            return this;
                        }
                        if (this[0]) return a.getComputedStyle(this[0], null).getPropertyValue(e);
                    }
                    if (2 === arguments.length && "string" == typeof e) {
                        for (n = 0; n < this.length; n += 1) this[n].style[e] = t;
                        return this;
                    }
                    return this;
                }
                function N(e) {
                    return e
                        ? (this.forEach(function (t, n) {
                              e.apply(t, [t, n]);
                          }),
                          this)
                        : this;
                }
                function R(e) {
                    return p(u(this, e));
                }
                function Y(e) {
                    if (void 0 === e) return this[0] ? this[0].innerHTML : null;
                    for (var t = 0; t < this.length; t += 1) this[t].innerHTML = e;
                    return this;
                }
                function V(e) {
                    if (void 0 === e) return this[0] ? this[0].textContent.trim() : null;
                    for (var t = 0; t < this.length; t += 1) this[t].textContent = e;
                    return this;
                }
                function G(e) {
                    var t,
                        n,
                        a = (0, i.getWindow)(),
                        o = (0, i.getDocument)(),
                        r = this[0];
                    if (!r || void 0 === e) return !1;
                    if ("string" == typeof e) {
                        if (r.matches) return r.matches(e);
                        if (r.webkitMatchesSelector) return r.webkitMatchesSelector(e);
                        if (r.msMatchesSelector) return r.msMatchesSelector(e);
                        for (t = p(e), n = 0; n < t.length; n += 1) if (t[n] === r) return !0;
                        return !1;
                    }
                    if (e === o) return r === o;
                    if (e === a) return r === a;
                    if (e.nodeType || e instanceof c) {
                        for (t = e.nodeType ? [e] : e, n = 0; n < t.length; n += 1) if (t[n] === r) return !0;
                        return !1;
                    }
                    return !1;
                }
                function W() {
                    var e,
                        t = this[0];
                    if (t) {
                        for (e = 0; null !== (t = t.previousSibling); ) 1 === t.nodeType && (e += 1);
                        return e;
                    }
                }
                function X(e) {
                    if (void 0 === e) return this;
                    var t = this.length;
                    if (e > t - 1) return p([]);
                    if (e < 0) {
                        var n = t + e;
                        return p(n < 0 ? [] : [this[n]]);
                    }
                    return p([this[e]]);
                }
                function U() {
                    for (var e, t = (0, i.getDocument)(), n = 0; n < arguments.length; n += 1) {
                        e = n < 0 || arguments.length <= n ? void 0 : arguments[n];
                        for (var a = 0; a < this.length; a += 1)
                            if ("string" == typeof e) {
                                var o = t.createElement("div");
                                for (o.innerHTML = e; o.firstChild; ) this[a].appendChild(o.firstChild);
                            } else if (e instanceof c) for (var r = 0; r < e.length; r += 1) this[a].appendChild(e[r]);
                            else this[a].appendChild(e);
                    }
                    return this;
                }
                function Q(e) {
                    return p(e).append(this), this;
                }
                function Z(e) {
                    var t,
                        n,
                        a = (0, i.getDocument)();
                    for (t = 0; t < this.length; t += 1)
                        if ("string" == typeof e) {
                            var o = a.createElement("div");
                            for (o.innerHTML = e, n = o.childNodes.length - 1; n >= 0; n -= 1) this[t].insertBefore(o.childNodes[n], this[t].childNodes[0]);
                        } else if (e instanceof c) for (n = 0; n < e.length; n += 1) this[t].insertBefore(e[n], this[t].childNodes[0]);
                        else this[t].insertBefore(e, this[t].childNodes[0]);
                    return this;
                }
                function K(e) {
                    return p(e).prepend(this), this;
                }
                function J(e) {
                    for (var t = p(e), n = 0; n < this.length; n += 1)
                        if (1 === t.length) t[0].parentNode.insertBefore(this[n], t[0]);
                        else if (t.length > 1) for (var i = 0; i < t.length; i += 1) t[i].parentNode.insertBefore(this[n].cloneNode(!0), t[i]);
                }
                function ee(e) {
                    for (var t = p(e), n = 0; n < this.length; n += 1)
                        if (1 === t.length) t[0].parentNode.insertBefore(this[n], t[0].nextSibling);
                        else if (t.length > 1) for (var i = 0; i < t.length; i += 1) t[i].parentNode.insertBefore(this[n].cloneNode(!0), t[i].nextSibling);
                }
                function te(e) {
                    return this.length > 0 ? (e ? (this[0].nextElementSibling && p(this[0].nextElementSibling).is(e) ? p([this[0].nextElementSibling]) : p([])) : this[0].nextElementSibling ? p([this[0].nextElementSibling]) : p([])) : p([]);
                }
                function ne(e) {
                    var t = [],
                        n = this[0];
                    if (!n) return p([]);
                    for (; n.nextElementSibling; ) {
                        var i = n.nextElementSibling;
                        e ? p(i).is(e) && t.push(i) : t.push(i), (n = i);
                    }
                    return p(t);
                }
                function ie(e) {
                    if (this.length > 0) {
                        var t = this[0];
                        return e ? (t.previousElementSibling && p(t.previousElementSibling).is(e) ? p([t.previousElementSibling]) : p([])) : t.previousElementSibling ? p([t.previousElementSibling]) : p([]);
                    }
                    return p([]);
                }
                function ae(e) {
                    var t = [],
                        n = this[0];
                    if (!n) return p([]);
                    for (; n.previousElementSibling; ) {
                        var i = n.previousElementSibling;
                        e ? p(i).is(e) && t.push(i) : t.push(i), (n = i);
                    }
                    return p(t);
                }
                function oe(e) {
                    return this.nextAll(e).add(this.prevAll(e));
                }
                function re(e) {
                    for (var t = [], n = 0; n < this.length; n += 1) null !== this[n].parentNode && (e ? p(this[n].parentNode).is(e) && t.push(this[n].parentNode) : t.push(this[n].parentNode));
                    return p(t);
                }
                function se(e) {
                    for (var t = [], n = 0; n < this.length; n += 1) for (var i = this[n].parentNode; i; ) e ? p(i).is(e) && t.push(i) : t.push(i), (i = i.parentNode);
                    return p(t);
                }
                function le(e) {
                    var t = this;
                    return void 0 === e ? p([]) : (t.is(e) || (t = t.parents(e).eq(0)), t);
                }
                function ce(e) {
                    for (var t = [], n = 0; n < this.length; n += 1) for (var i = this[n].querySelectorAll(e), a = 0; a < i.length; a += 1) t.push(i[a]);
                    return p(t);
                }
                function de(e) {
                    for (var t = [], n = 0; n < this.length; n += 1) for (var i = this[n].children, a = 0; a < i.length; a += 1) (e && !p(i[a]).is(e)) || t.push(i[a]);
                    return p(t);
                }
                function ue() {
                    for (var e = 0; e < this.length; e += 1) this[e].parentNode && this[e].parentNode.removeChild(this[e]);
                    return this;
                }
                function pe() {
                    return this.remove();
                }
                function fe() {
                    for (var e, t, n = this, i = arguments.length, a = new Array(i), o = 0; o < i; o++) a[o] = arguments[o];
                    for (e = 0; e < a.length; e += 1) {
                        var r = p(a[e]);
                        for (t = 0; t < r.length; t += 1) n.push(r[t]);
                    }
                    return n;
                }
                function he() {
                    for (var e = 0; e < this.length; e += 1) {
                        var t = this[e];
                        if (1 === t.nodeType) {
                            for (var n = 0; n < t.childNodes.length; n += 1) t.childNodes[n].parentNode && t.childNodes[n].parentNode.removeChild(t.childNodes[n]);
                            t.textContent = "";
                        }
                    }
                    return this;
                }
                function ge() {
                    for (var e = (0, i.getWindow)(), t = arguments.length, n = new Array(t), a = 0; a < t; a++) n[a] = arguments[a];
                    var o = n[0],
                        r = n[1],
                        s = n[2],
                        l = n[3],
                        c = n[4];
                    return (
                        4 === n.length && "function" == typeof l && ((c = l), (o = n[0]), (r = n[1]), (s = n[2]), (c = n[3]), (l = n[4])),
                        void 0 === l && (l = "swing"),
                        this.each(function () {
                            var t,
                                n,
                                i,
                                a,
                                d,
                                u,
                                p,
                                f,
                                h = this,
                                g = r > 0 || 0 === r,
                                v = o > 0 || 0 === o;
                            if ((void 0 === l && (l = "swing"), g && ((t = h.scrollTop), s || (h.scrollTop = r)), v && ((n = h.scrollLeft), s || (h.scrollLeft = o)), s)) {
                                g && ((i = h.scrollHeight - h.offsetHeight), (d = Math.max(Math.min(r, i), 0))), v && ((a = h.scrollWidth - h.offsetWidth), (u = Math.max(Math.min(o, a), 0)));
                                var m = null;
                                g && d === t && (g = !1),
                                    v && u === n && (v = !1),
                                    e.requestAnimationFrame(function i(a) {
                                        void 0 === a && (a = new Date().getTime()), null === m && (m = a);
                                        var o,
                                            r = Math.max(Math.min((a - m) / s, 1), 0),
                                            b = "linear" === l ? r : 0.5 - Math.cos(r * Math.PI) / 2;
                                        g && (p = t + b * (d - t)),
                                            v && (f = n + b * (u - n)),
                                            g && d > t && p >= d && ((h.scrollTop = d), (o = !0)),
                                            g && d < t && p <= d && ((h.scrollTop = d), (o = !0)),
                                            v && u > n && f >= u && ((h.scrollLeft = u), (o = !0)),
                                            v && u < n && f <= u && ((h.scrollLeft = u), (o = !0)),
                                            o ? c && c() : (g && (h.scrollTop = p), v && (h.scrollLeft = f), e.requestAnimationFrame(i));
                                    });
                            }
                        })
                    );
                }
                function ve() {
                    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
                    var i = t[0],
                        a = t[1],
                        o = t[2],
                        r = t[3];
                    3 === t.length && "function" == typeof o && ((i = t[0]), (a = t[1]), (r = t[2]), (o = t[3]));
                    var s = this;
                    return void 0 === i ? (s.length > 0 ? s[0].scrollTop : null) : s.scrollTo(void 0, i, a, o, r);
                }
                function me() {
                    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
                    var i = t[0],
                        a = t[1],
                        o = t[2],
                        r = t[3];
                    3 === t.length && "function" == typeof o && ((i = t[0]), (a = t[1]), (r = t[2]), (o = t[3]));
                    var s = this;
                    return void 0 === i ? (s.length > 0 ? s[0].scrollLeft : null) : s.scrollTo(i, void 0, a, o, r);
                }
                function be(e, t) {
                    var n,
                        a = (0, i.getWindow)(),
                        o = this,
                        r = {
                            props: Object.assign({}, e),
                            params: Object.assign({ duration: 300, easing: "swing" }, t),
                            elements: o,
                            animating: !1,
                            que: [],
                            easingProgress: function (e, t) {
                                return "swing" === e ? 0.5 - Math.cos(t * Math.PI) / 2 : "function" == typeof e ? e(t) : t;
                            },
                            stop: function () {
                                r.frameId && a.cancelAnimationFrame(r.frameId),
                                    (r.animating = !1),
                                    r.elements.each(function (e) {
                                        delete e.dom7AnimateInstance;
                                    }),
                                    (r.que = []);
                            },
                            done: function (e) {
                                if (
                                    ((r.animating = !1),
                                    r.elements.each(function (e) {
                                        delete e.dom7AnimateInstance;
                                    }),
                                    e && e(o),
                                    r.que.length > 0)
                                ) {
                                    var t = r.que.shift();
                                    r.animate(t[0], t[1]);
                                }
                            },
                            animate: function (e, t) {
                                if (r.animating) return r.que.push([e, t]), r;
                                var n = [];
                                r.elements.each(function (t, i) {
                                    var o, s, l, c, d;
                                    t.dom7AnimateInstance || (r.elements[i].dom7AnimateInstance = r),
                                        (n[i] = { container: t }),
                                        Object.keys(e).forEach(function (r) {
                                            (o = a.getComputedStyle(t, null).getPropertyValue(r).replace(",", ".")),
                                                (s = parseFloat(o)),
                                                (l = o.replace(s, "")),
                                                (c = parseFloat(e[r])),
                                                (d = e[r] + l),
                                                (n[i][r] = { initialFullValue: o, initialValue: s, unit: l, finalValue: c, finalFullValue: d, currentValue: s });
                                        });
                                });
                                var i,
                                    s,
                                    l = null,
                                    c = 0,
                                    d = 0,
                                    u = !1;
                                return (
                                    (r.animating = !0),
                                    (r.frameId = a.requestAnimationFrame(function p() {
                                        var f, h;
                                        (i = new Date().getTime()),
                                            u || ((u = !0), t.begin && t.begin(o)),
                                            null === l && (l = i),
                                            t.progress && t.progress(o, Math.max(Math.min((i - l) / t.duration, 1), 0), l + t.duration - i < 0 ? 0 : l + t.duration - i, l),
                                            n.forEach(function (a) {
                                                var o = a;
                                                s ||
                                                    o.done ||
                                                    Object.keys(e).forEach(function (a) {
                                                        if (!s && !o.done) {
                                                            (f = Math.max(Math.min((i - l) / t.duration, 1), 0)), (h = r.easingProgress(t.easing, f));
                                                            var u = o[a],
                                                                p = u.initialValue,
                                                                g = u.finalValue,
                                                                v = u.unit;
                                                            o[a].currentValue = p + h * (g - p);
                                                            var m = o[a].currentValue;
                                                            ((g > p && m >= g) || (g < p && m <= g)) && ((o.container.style[a] = g + v), (d += 1) === Object.keys(e).length && ((o.done = !0), (c += 1)), c === n.length && (s = !0)),
                                                                s ? r.done(t.complete) : (o.container.style[a] = m + v);
                                                        }
                                                    });
                                            }),
                                            s || (r.frameId = a.requestAnimationFrame(p));
                                    })),
                                    r
                                );
                            },
                        };
                    if (0 === r.elements.length) return o;
                    for (var s = 0; s < r.elements.length; s += 1) r.elements[s].dom7AnimateInstance ? (n = r.elements[s].dom7AnimateInstance) : (r.elements[s].dom7AnimateInstance = r);
                    return n || (n = r), "stop" === e ? n.stop() : n.animate(r.props, r.params), o;
                }
                function we() {
                    for (var e = this, t = 0; t < e.length; t += 1) e[t].dom7AnimateInstance && e[t].dom7AnimateInstance.stop();
                }
                p.fn = c.prototype;
                var ye = "resize scroll".split(" ");
                function xe(e) {
                    return function () {
                        for (var t = arguments.length, n = new Array(t), i = 0; i < t; i++) n[i] = arguments[i];
                        if (void 0 === n[0]) {
                            for (var a = 0; a < this.length; a += 1) ye.indexOf(e) < 0 && (e in this[a] ? this[a][e]() : p(this[a]).trigger(e));
                            return this;
                        }
                        return this.on.apply(this, [e].concat(n));
                    };
                }
                var Ce = xe("click"),
                    Te = xe("blur"),
                    Se = xe("focus"),
                    Ae = xe("focusin"),
                    $e = xe("focusout"),
                    Ee = xe("keyup"),
                    ke = xe("keydown"),
                    Pe = xe("keypress"),
                    Me = xe("submit"),
                    _e = xe("change"),
                    Le = xe("mousedown"),
                    ze = xe("mousemove"),
                    Ie = xe("mouseup"),
                    Oe = xe("mouseenter"),
                    De = xe("mouseleave"),
                    Be = xe("mouseout"),
                    Fe = xe("mouseover"),
                    je = xe("touchstart"),
                    He = xe("touchend"),
                    qe = xe("touchmove"),
                    Ne = xe("resize"),
                    Re = xe("scroll");
                const Ye = p;
            },
            (e, t, n) => {
                "use strict";
                function i(e) {
                    return null !== e && "object" == typeof e && "constructor" in e && e.constructor === Object;
                }
                function a(e, t) {
                    void 0 === e && (e = {}),
                        void 0 === t && (t = {}),
                        Object.keys(t).forEach(function (n) {
                            void 0 === e[n] ? (e[n] = t[n]) : i(t[n]) && i(e[n]) && Object.keys(t[n]).length > 0 && a(e[n], t[n]);
                        });
                }
                n.r(t), n.d(t, { extend: () => a, getDocument: () => r, getWindow: () => l, ssrDocument: () => o, ssrWindow: () => s });
                var o = {
                    body: {},
                    addEventListener: function () {},
                    removeEventListener: function () {},
                    activeElement: { blur: function () {}, nodeName: "" },
                    querySelector: function () {
                        return null;
                    },
                    querySelectorAll: function () {
                        return [];
                    },
                    getElementById: function () {
                        return null;
                    },
                    createEvent: function () {
                        return { initEvent: function () {} };
                    },
                    createElement: function () {
                        return {
                            children: [],
                            childNodes: [],
                            style: {},
                            setAttribute: function () {},
                            getElementsByTagName: function () {
                                return [];
                            },
                        };
                    },
                    createElementNS: function () {
                        return {};
                    },
                    importNode: function () {
                        return null;
                    },
                    location: { hash: "", host: "", hostname: "", href: "", origin: "", pathname: "", protocol: "", search: "" },
                };
                function r() {
                    var e = "undefined" != typeof document ? document : {};
                    return a(e, o), e;
                }
                var s = {
                    document: o,
                    navigator: { userAgent: "" },
                    location: { hash: "", host: "", hostname: "", href: "", origin: "", pathname: "", protocol: "", search: "" },
                    history: { replaceState: function () {}, pushState: function () {}, go: function () {}, back: function () {} },
                    CustomEvent: function () {
                        return this;
                    },
                    addEventListener: function () {},
                    removeEventListener: function () {},
                    getComputedStyle: function () {
                        return {
                            getPropertyValue: function () {
                                return "";
                            },
                        };
                    },
                    Image: function () {},
                    Date: function () {},
                    screen: {},
                    setTimeout: function () {},
                    clearTimeout: function () {},
                    matchMedia: function () {
                        return {};
                    },
                    requestAnimationFrame: function (e) {
                        return "undefined" == typeof setTimeout ? (e(), null) : setTimeout(e, 0);
                    },
                    cancelAnimationFrame: function (e) {
                        "undefined" != typeof setTimeout && clearTimeout(e);
                    },
                };
                function l() {
                    var e = "undefined" != typeof window ? window : {};
                    return a(e, s), e;
                }
            },
            (e, t, n) => {
                "use strict";
                n.r(t), n.d(t, { default: () => a });
                var i = n(6);
                const a = {
                    useParams: function (e) {
                        var t = this;
                        t.modules &&
                            Object.keys(t.modules).forEach(function (n) {
                                var a = t.modules[n];
                                a.params && (0, i.extend)(e, a.params);
                            });
                    },
                    useModules: function (e) {
                        void 0 === e && (e = {});
                        var t = this;
                        t.modules &&
                            Object.keys(t.modules).forEach(function (n) {
                                var i = t.modules[n],
                                    a = e[n] || {};
                                i.on &&
                                    t.on &&
                                    Object.keys(i.on).forEach(function (e) {
                                        t.on(e, i.on[e]);
                                    }),
                                    i.create && i.create.bind(t)(a);
                            });
                    },
                };
            },
            (e, t, n) => {
                "use strict";
                n.r(t), n.d(t, { deleteProps: () => a, nextTick: () => o, now: () => r, getTranslate: () => s, isObject: () => l, extend: () => c, bindModuleMethods: () => d });
                var i = n(4);
                function a(e) {
                    var t = e;
                    Object.keys(t).forEach(function (e) {
                        try {
                            t[e] = null;
                        } catch (e) {}
                        try {
                            delete t[e];
                        } catch (e) {}
                    });
                }
                function o(e, t) {
                    return void 0 === t && (t = 0), setTimeout(e, t);
                }
                function r() {
                    return Date.now();
                }
                function s(e, t) {
                    void 0 === t && (t = "x");
                    var n,
                        a,
                        o,
                        r = (0, i.getWindow)(),
                        s = r.getComputedStyle(e, null);
                    return (
                        r.WebKitCSSMatrix
                            ? ((a = s.transform || s.webkitTransform).split(",").length > 6 &&
                                  (a = a
                                      .split(", ")
                                      .map(function (e) {
                                          return e.replace(",", ".");
                                      })
                                      .join(", ")),
                              (o = new r.WebKitCSSMatrix("none" === a ? "" : a)))
                            : (n = (o = s.MozTransform || s.OTransform || s.MsTransform || s.msTransform || s.transform || s.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,")).toString().split(",")),
                        "x" === t && (a = r.WebKitCSSMatrix ? o.m41 : 16 === n.length ? parseFloat(n[12]) : parseFloat(n[4])),
                        "y" === t && (a = r.WebKitCSSMatrix ? o.m42 : 16 === n.length ? parseFloat(n[13]) : parseFloat(n[5])),
                        a || 0
                    );
                }
                function l(e) {
                    return "object" == typeof e && null !== e && e.constructor && e.constructor === Object;
                }
                function c() {
                    for (var e = Object(arguments.length <= 0 ? void 0 : arguments[0]), t = 1; t < arguments.length; t += 1) {
                        var n = t < 0 || arguments.length <= t ? void 0 : arguments[t];
                        if (null != n)
                            for (var i = Object.keys(Object(n)), a = 0, o = i.length; a < o; a += 1) {
                                var r = i[a],
                                    s = Object.getOwnPropertyDescriptor(n, r);
                                void 0 !== s && s.enumerable && (l(e[r]) && l(n[r]) ? c(e[r], n[r]) : !l(e[r]) && l(n[r]) ? ((e[r] = {}), c(e[r], n[r])) : (e[r] = n[r]));
                            }
                    }
                    return e;
                }
                function d(e, t) {
                    Object.keys(t).forEach(function (n) {
                        l(t[n]) &&
                            Object.keys(t[n]).forEach(function (i) {
                                "function" == typeof t[n][i] && (t[n][i] = t[n][i].bind(e));
                            }),
                            (e[n] = t[n]);
                    });
                }
            },
            (e, t, n) => {
                "use strict";
                n.r(t), n.d(t, { default: () => i });
                const i = {
                    on: function (e, t, n) {
                        var i = this;
                        if ("function" != typeof t) return i;
                        var a = n ? "unshift" : "push";
                        return (
                            e.split(" ").forEach(function (e) {
                                i.eventsListeners[e] || (i.eventsListeners[e] = []), i.eventsListeners[e][a](t);
                            }),
                            i
                        );
                    },
                    once: function (e, t, n) {
                        var i = this;
                        if ("function" != typeof t) return i;
                        function a() {
                            i.off(e, a), a.__emitterProxy && delete a.__emitterProxy;
                            for (var n = arguments.length, o = new Array(n), r = 0; r < n; r++) o[r] = arguments[r];
                            t.apply(i, o);
                        }
                        return (a.__emitterProxy = t), i.on(e, a, n);
                    },
                    onAny: function (e, t) {
                        var n = this;
                        if ("function" != typeof e) return n;
                        var i = t ? "unshift" : "push";
                        return n.eventsAnyListeners.indexOf(e) < 0 && n.eventsAnyListeners[i](e), n;
                    },
                    offAny: function (e) {
                        var t = this;
                        if (!t.eventsAnyListeners) return t;
                        var n = t.eventsAnyListeners.indexOf(e);
                        return n >= 0 && t.eventsAnyListeners.splice(n, 1), t;
                    },
                    off: function (e, t) {
                        var n = this;
                        return n.eventsListeners
                            ? (e.split(" ").forEach(function (e) {
                                  void 0 === t
                                      ? (n.eventsListeners[e] = [])
                                      : n.eventsListeners[e] &&
                                        n.eventsListeners[e].forEach(function (i, a) {
                                            (i === t || (i.__emitterProxy && i.__emitterProxy === t)) && n.eventsListeners[e].splice(a, 1);
                                        });
                              }),
                              n)
                            : n;
                    },
                    emit: function () {
                        var e,
                            t,
                            n,
                            i = this;
                        if (!i.eventsListeners) return i;
                        for (var a = arguments.length, o = new Array(a), r = 0; r < a; r++) o[r] = arguments[r];
                        "string" == typeof o[0] || Array.isArray(o[0]) ? ((e = o[0]), (t = o.slice(1, o.length)), (n = i)) : ((e = o[0].events), (t = o[0].data), (n = o[0].context || i)), t.unshift(n);
                        var s = Array.isArray(e) ? e : e.split(" ");
                        return (
                            s.forEach(function (e) {
                                i.eventsAnyListeners &&
                                    i.eventsAnyListeners.length &&
                                    i.eventsAnyListeners.forEach(function (i) {
                                        i.apply(n, [e].concat(t));
                                    }),
                                    i.eventsListeners &&
                                        i.eventsListeners[e] &&
                                        i.eventsListeners[e].forEach(function (e) {
                                            e.apply(n, t);
                                        });
                            }),
                            i
                        );
                    },
                };
            },
            (e, t, n) => {
                "use strict";
                n.r(t), n.d(t, { default: () => p });
                var i = n(9),
                    a = n(10),
                    o = n(11),
                    r = n(12),
                    s = n(13),
                    l = n(14),
                    c = n(15),
                    d = n(16),
                    u = n(17);
                const p = {
                    updateSize: i.default,
                    updateSlides: a.default,
                    updateAutoHeight: o.default,
                    updateSlidesOffset: r.default,
                    updateSlidesProgress: s.default,
                    updateProgress: l.default,
                    updateSlidesClasses: c.default,
                    updateActiveIndex: d.default,
                    updateClickedSlide: u.default,
                };
            },
            (e, t, n) => {
                "use strict";
                n.r(t), n.d(t, { default: () => a });
                var i = n(6);
                function a() {
                    var e,
                        t,
                        n = this,
                        a = n.$el;
                    (e = void 0 !== n.params.width && null !== n.params.width ? n.params.width : a[0].clientWidth),
                        (t = void 0 !== n.params.height && null !== n.params.height ? n.params.height : a[0].clientHeight),
                        (0 === e && n.isHorizontal()) ||
                            (0 === t && n.isVertical()) ||
                            ((e = e - parseInt(a.css("padding-left") || 0, 10) - parseInt(a.css("padding-right") || 0, 10)),
                            (t = t - parseInt(a.css("padding-top") || 0, 10) - parseInt(a.css("padding-bottom") || 0, 10)),
                            Number.isNaN(e) && (e = 0),
                            Number.isNaN(t) && (t = 0),
                            (0, i.extend)(n, { width: e, height: t, size: n.isHorizontal() ? e : t }));
                }
            },
            (e, t, n) => {
                "use strict";
                n.r(t), n.d(t, { default: () => o });
                var i = n(4),
                    a = n(6);
                function o() {
                    var e = this,
                        t = (0, i.getWindow)(),
                        n = e.params,
                        o = e.$wrapperEl,
                        r = e.size,
                        s = e.rtlTranslate,
                        l = e.wrongRTL,
                        c = e.virtual && n.virtual.enabled,
                        d = c ? e.virtual.slides.length : e.slides.length,
                        u = o.children("." + e.params.slideClass),
                        p = c ? e.virtual.slides.length : u.length,
                        f = [],
                        h = [],
                        g = [];
                    function v(e, t) {
                        return !n.cssMode || t !== u.length - 1;
                    }
                    var m = n.slidesOffsetBefore;
                    "function" == typeof m && (m = n.slidesOffsetBefore.call(e));
                    var b = n.slidesOffsetAfter;
                    "function" == typeof b && (b = n.slidesOffsetAfter.call(e));
                    var w = e.snapGrid.length,
                        y = e.snapGrid.length,
                        x = n.spaceBetween,
                        C = -m,
                        T = 0,
                        S = 0;
                    if (void 0 !== r) {
                        var A, $;
                        "string" == typeof x && x.indexOf("%") >= 0 && (x = (parseFloat(x.replace("%", "")) / 100) * r),
                            (e.virtualSize = -x),
                            s ? u.css({ marginLeft: "", marginTop: "" }) : u.css({ marginRight: "", marginBottom: "" }),
                            n.slidesPerColumn > 1 &&
                                ((A = Math.floor(p / n.slidesPerColumn) === p / e.params.slidesPerColumn ? p : Math.ceil(p / n.slidesPerColumn) * n.slidesPerColumn),
                                "auto" !== n.slidesPerView && "row" === n.slidesPerColumnFill && (A = Math.max(A, n.slidesPerView * n.slidesPerColumn)));
                        for (var E, k = n.slidesPerColumn, P = A / k, M = Math.floor(p / n.slidesPerColumn), _ = 0; _ < p; _ += 1) {
                            $ = 0;
                            var L = u.eq(_);
                            if (n.slidesPerColumn > 1) {
                                var z = void 0,
                                    I = void 0,
                                    O = void 0;
                                if ("row" === n.slidesPerColumnFill && n.slidesPerGroup > 1) {
                                    var D = Math.floor(_ / (n.slidesPerGroup * n.slidesPerColumn)),
                                        B = _ - n.slidesPerColumn * n.slidesPerGroup * D,
                                        F = 0 === D ? n.slidesPerGroup : Math.min(Math.ceil((p - D * k * n.slidesPerGroup) / k), n.slidesPerGroup);
                                    (z = (I = B - (O = Math.floor(B / F)) * F + D * n.slidesPerGroup) + (O * A) / k), L.css({ "-webkit-box-ordinal-group": z, "-moz-box-ordinal-group": z, "-ms-flex-order": z, "-webkit-order": z, order: z });
                                } else "column" === n.slidesPerColumnFill ? ((O = _ - (I = Math.floor(_ / k)) * k), (I > M || (I === M && O === k - 1)) && (O += 1) >= k && ((O = 0), (I += 1))) : (I = _ - (O = Math.floor(_ / P)) * P);
                                L.css("margin-" + (e.isHorizontal() ? "top" : "left"), 0 !== O && n.spaceBetween && n.spaceBetween + "px");
                            }
                            if ("none" !== L.css("display")) {
                                if ("auto" === n.slidesPerView) {
                                    var j = t.getComputedStyle(L[0], null),
                                        H = L[0].style.transform,
                                        q = L[0].style.webkitTransform;
                                    if ((H && (L[0].style.transform = "none"), q && (L[0].style.webkitTransform = "none"), n.roundLengths)) $ = e.isHorizontal() ? L.outerWidth(!0) : L.outerHeight(!0);
                                    else if (e.isHorizontal()) {
                                        var N = parseFloat(j.getPropertyValue("width") || 0),
                                            R = parseFloat(j.getPropertyValue("padding-left") || 0),
                                            Y = parseFloat(j.getPropertyValue("padding-right") || 0),
                                            V = parseFloat(j.getPropertyValue("margin-left") || 0),
                                            G = parseFloat(j.getPropertyValue("margin-right") || 0),
                                            W = j.getPropertyValue("box-sizing");
                                        if (W && "border-box" === W) $ = N + V + G;
                                        else {
                                            var X = L[0],
                                                U = X.clientWidth;
                                            $ = N + R + Y + V + G + (X.offsetWidth - U);
                                        }
                                    } else {
                                        var Q = parseFloat(j.getPropertyValue("height") || 0),
                                            Z = parseFloat(j.getPropertyValue("padding-top") || 0),
                                            K = parseFloat(j.getPropertyValue("padding-bottom") || 0),
                                            J = parseFloat(j.getPropertyValue("margin-top") || 0),
                                            ee = parseFloat(j.getPropertyValue("margin-bottom") || 0),
                                            te = j.getPropertyValue("box-sizing");
                                        if (te && "border-box" === te) $ = Q + J + ee;
                                        else {
                                            var ne = L[0],
                                                ie = ne.clientHeight;
                                            $ = Q + Z + K + J + ee + (ne.offsetHeight - ie);
                                        }
                                    }
                                    H && (L[0].style.transform = H), q && (L[0].style.webkitTransform = q), n.roundLengths && ($ = Math.floor($));
                                } else ($ = (r - (n.slidesPerView - 1) * x) / n.slidesPerView), n.roundLengths && ($ = Math.floor($)), u[_] && (e.isHorizontal() ? (u[_].style.width = $ + "px") : (u[_].style.height = $ + "px"));
                                u[_] && (u[_].swiperSlideSize = $),
                                    g.push($),
                                    n.centeredSlides
                                        ? ((C = C + $ / 2 + T / 2 + x),
                                          0 === T && 0 !== _ && (C = C - r / 2 - x),
                                          0 === _ && (C = C - r / 2 - x),
                                          Math.abs(C) < 0.001 && (C = 0),
                                          n.roundLengths && (C = Math.floor(C)),
                                          S % n.slidesPerGroup == 0 && f.push(C),
                                          h.push(C))
                                        : (n.roundLengths && (C = Math.floor(C)), (S - Math.min(e.params.slidesPerGroupSkip, S)) % e.params.slidesPerGroup == 0 && f.push(C), h.push(C), (C = C + $ + x)),
                                    (e.virtualSize += $ + x),
                                    (T = $),
                                    (S += 1);
                            }
                        }
                        if (
                            ((e.virtualSize = Math.max(e.virtualSize, r) + b),
                            s && l && ("slide" === n.effect || "coverflow" === n.effect) && o.css({ width: e.virtualSize + n.spaceBetween + "px" }),
                            n.setWrapperSize && (e.isHorizontal() ? o.css({ width: e.virtualSize + n.spaceBetween + "px" }) : o.css({ height: e.virtualSize + n.spaceBetween + "px" })),
                            n.slidesPerColumn > 1 &&
                                ((e.virtualSize = ($ + n.spaceBetween) * A),
                                (e.virtualSize = Math.ceil(e.virtualSize / n.slidesPerColumn) - n.spaceBetween),
                                e.isHorizontal() ? o.css({ width: e.virtualSize + n.spaceBetween + "px" }) : o.css({ height: e.virtualSize + n.spaceBetween + "px" }),
                                n.centeredSlides))
                        ) {
                            E = [];
                            for (var ae = 0; ae < f.length; ae += 1) {
                                var oe = f[ae];
                                n.roundLengths && (oe = Math.floor(oe)), f[ae] < e.virtualSize + f[0] && E.push(oe);
                            }
                            f = E;
                        }
                        if (!n.centeredSlides) {
                            E = [];
                            for (var re = 0; re < f.length; re += 1) {
                                var se = f[re];
                                n.roundLengths && (se = Math.floor(se)), f[re] <= e.virtualSize - r && E.push(se);
                            }
                            (f = E), Math.floor(e.virtualSize - r) - Math.floor(f[f.length - 1]) > 1 && f.push(e.virtualSize - r);
                        }
                        if (
                            (0 === f.length && (f = [0]),
                            0 !== n.spaceBetween && (e.isHorizontal() ? (s ? u.filter(v).css({ marginLeft: x + "px" }) : u.filter(v).css({ marginRight: x + "px" })) : u.filter(v).css({ marginBottom: x + "px" })),
                            n.centeredSlides && n.centeredSlidesBounds)
                        ) {
                            var le = 0;
                            g.forEach(function (e) {
                                le += e + (n.spaceBetween ? n.spaceBetween : 0);
                            });
                            var ce = (le -= n.spaceBetween) - r;
                            f = f.map(function (e) {
                                return e < 0 ? -m : e > ce ? ce + b : e;
                            });
                        }
                        if (n.centerInsufficientSlides) {
                            var de = 0;
                            if (
                                (g.forEach(function (e) {
                                    de += e + (n.spaceBetween ? n.spaceBetween : 0);
                                }),
                                (de -= n.spaceBetween) < r)
                            ) {
                                var ue = (r - de) / 2;
                                f.forEach(function (e, t) {
                                    f[t] = e - ue;
                                }),
                                    h.forEach(function (e, t) {
                                        h[t] = e + ue;
                                    });
                            }
                        }
                        (0, a.extend)(e, { slides: u, snapGrid: f, slidesGrid: h, slidesSizesGrid: g }),
                            p !== d && e.emit("slidesLengthChange"),
                            f.length !== w && (e.params.watchOverflow && e.checkOverflow(), e.emit("snapGridLengthChange")),
                            h.length !== y && e.emit("slidesGridLengthChange"),
                            (n.watchSlidesProgress || n.watchSlidesVisibility) && e.updateSlidesOffset();
                    }
                }
            },
            (e, t, n) => {
                "use strict";
                function i(e) {
                    var t,
                        n = this,
                        i = [],
                        a = 0;
                    if (("number" == typeof e ? n.setTransition(e) : !0 === e && n.setTransition(n.params.speed), "auto" !== n.params.slidesPerView && n.params.slidesPerView > 1))
                        if (n.params.centeredSlides)
                            n.visibleSlides.each(function (e) {
                                i.push(e);
                            });
                        else
                            for (t = 0; t < Math.ceil(n.params.slidesPerView); t += 1) {
                                var o = n.activeIndex + t;
                                if (o > n.slides.length) break;
                                i.push(n.slides.eq(o)[0]);
                            }
                    else i.push(n.slides.eq(n.activeIndex)[0]);
                    for (t = 0; t < i.length; t += 1)
                        if (void 0 !== i[t]) {
                            var r = i[t].offsetHeight;
                            a = r > a ? r : a;
                        }
                    a && n.$wrapperEl.css("height", a + "px");
                }
                n.r(t), n.d(t, { default: () => i });
            },
            (e, t, n) => {
                "use strict";
                function i() {
                    for (var e = this.slides, t = 0; t < e.length; t += 1) e[t].swiperSlideOffset = this.isHorizontal() ? e[t].offsetLeft : e[t].offsetTop;
                }
                n.r(t), n.d(t, { default: () => i });
            },
            (e, t, n) => {
                "use strict";
                n.r(t), n.d(t, { default: () => a });
                var i = n(2);
                function a(e) {
                    void 0 === e && (e = (this && this.translate) || 0);
                    var t = this,
                        n = t.params,
                        a = t.slides,
                        o = t.rtlTranslate;
                    if (0 !== a.length) {
                        void 0 === a[0].swiperSlideOffset && t.updateSlidesOffset();
                        var r = -e;
                        o && (r = e), a.removeClass(n.slideVisibleClass), (t.visibleSlidesIndexes = []), (t.visibleSlides = []);
                        for (var s = 0; s < a.length; s += 1) {
                            var l = a[s],
                                c = (r + (n.centeredSlides ? t.minTranslate() : 0) - l.swiperSlideOffset) / (l.swiperSlideSize + n.spaceBetween);
                            if (n.watchSlidesVisibility || (n.centeredSlides && n.autoHeight)) {
                                var d = -(r - l.swiperSlideOffset),
                                    u = d + t.slidesSizesGrid[s];
                                ((d >= 0 && d < t.size - 1) || (u > 1 && u <= t.size) || (d <= 0 && u >= t.size)) && (t.visibleSlides.push(l), t.visibleSlidesIndexes.push(s), a.eq(s).addClass(n.slideVisibleClass));
                            }
                            l.progress = o ? -c : c;
                        }
                        t.visibleSlides = (0, i.default)(t.visibleSlides);
                    }
                }
            },
            (e, t, n) => {
                "use strict";
                n.r(t), n.d(t, { default: () => a });
                var i = n(6);
                function a(e) {
                    var t = this;
                    if (void 0 === e) {
                        var n = t.rtlTranslate ? -1 : 1;
                        e = (t && t.translate && t.translate * n) || 0;
                    }
                    var a = t.params,
                        o = t.maxTranslate() - t.minTranslate(),
                        r = t.progress,
                        s = t.isBeginning,
                        l = t.isEnd,
                        c = s,
                        d = l;
                    0 === o ? ((r = 0), (s = !0), (l = !0)) : ((s = (r = (e - t.minTranslate()) / o) <= 0), (l = r >= 1)),
                        (0, i.extend)(t, { progress: r, isBeginning: s, isEnd: l }),
                        (a.watchSlidesProgress || a.watchSlidesVisibility || (a.centeredSlides && a.autoHeight)) && t.updateSlidesProgress(e),
                        s && !c && t.emit("reachBeginning toEdge"),
                        l && !d && t.emit("reachEnd toEdge"),
                        ((c && !s) || (d && !l)) && t.emit("fromEdge"),
                        t.emit("progress", r);
                }
            },
            (e, t, n) => {
                "use strict";
                function i() {
                    var e,
                        t = this,
                        n = t.slides,
                        i = t.params,
                        a = t.$wrapperEl,
                        o = t.activeIndex,
                        r = t.realIndex,
                        s = t.virtual && i.virtual.enabled;
                    n.removeClass(i.slideActiveClass + " " + i.slideNextClass + " " + i.slidePrevClass + " " + i.slideDuplicateActiveClass + " " + i.slideDuplicateNextClass + " " + i.slideDuplicatePrevClass),
                        (e = s ? t.$wrapperEl.find("." + i.slideClass + '[data-swiper-slide-index="' + o + '"]') : n.eq(o)).addClass(i.slideActiveClass),
                        i.loop &&
                            (e.hasClass(i.slideDuplicateClass)
                                ? a.children("." + i.slideClass + ":not(." + i.slideDuplicateClass + ')[data-swiper-slide-index="' + r + '"]').addClass(i.slideDuplicateActiveClass)
                                : a.children("." + i.slideClass + "." + i.slideDuplicateClass + '[data-swiper-slide-index="' + r + '"]').addClass(i.slideDuplicateActiveClass));
                    var l = e
                        .nextAll("." + i.slideClass)
                        .eq(0)
                        .addClass(i.slideNextClass);
                    i.loop && 0 === l.length && (l = n.eq(0)).addClass(i.slideNextClass);
                    var c = e
                        .prevAll("." + i.slideClass)
                        .eq(0)
                        .addClass(i.slidePrevClass);
                    i.loop && 0 === c.length && (c = n.eq(-1)).addClass(i.slidePrevClass),
                        i.loop &&
                            (l.hasClass(i.slideDuplicateClass)
                                ? a.children("." + i.slideClass + ":not(." + i.slideDuplicateClass + ')[data-swiper-slide-index="' + l.attr("data-swiper-slide-index") + '"]').addClass(i.slideDuplicateNextClass)
                                : a.children("." + i.slideClass + "." + i.slideDuplicateClass + '[data-swiper-slide-index="' + l.attr("data-swiper-slide-index") + '"]').addClass(i.slideDuplicateNextClass),
                            c.hasClass(i.slideDuplicateClass)
                                ? a.children("." + i.slideClass + ":not(." + i.slideDuplicateClass + ')[data-swiper-slide-index="' + c.attr("data-swiper-slide-index") + '"]').addClass(i.slideDuplicatePrevClass)
                                : a.children("." + i.slideClass + "." + i.slideDuplicateClass + '[data-swiper-slide-index="' + c.attr("data-swiper-slide-index") + '"]').addClass(i.slideDuplicatePrevClass)),
                        t.emitSlidesClasses();
                }
                n.r(t), n.d(t, { default: () => i });
            },
            (e, t, n) => {
                "use strict";
                n.r(t), n.d(t, { default: () => a });
                var i = n(6);
                function a(e) {
                    var t,
                        n = this,
                        a = n.rtlTranslate ? n.translate : -n.translate,
                        o = n.slidesGrid,
                        r = n.snapGrid,
                        s = n.params,
                        l = n.activeIndex,
                        c = n.realIndex,
                        d = n.snapIndex,
                        u = e;
                    if (void 0 === u) {
                        for (var p = 0; p < o.length; p += 1) void 0 !== o[p + 1] ? (a >= o[p] && a < o[p + 1] - (o[p + 1] - o[p]) / 2 ? (u = p) : a >= o[p] && a < o[p + 1] && (u = p + 1)) : a >= o[p] && (u = p);
                        s.normalizeSlideIndex && (u < 0 || void 0 === u) && (u = 0);
                    }
                    if (r.indexOf(a) >= 0) t = r.indexOf(a);
                    else {
                        var f = Math.min(s.slidesPerGroupSkip, u);
                        t = f + Math.floor((u - f) / s.slidesPerGroup);
                    }
                    if ((t >= r.length && (t = r.length - 1), u !== l)) {
                        var h = parseInt(n.slides.eq(u).attr("data-swiper-slide-index") || u, 10);
                        (0, i.extend)(n, { snapIndex: t, realIndex: h, previousIndex: l, activeIndex: u }),
                            n.emit("activeIndexChange"),
                            n.emit("snapIndexChange"),
                            c !== h && n.emit("realIndexChange"),
                            (n.initialized || n.params.runCallbacksOnInit) && n.emit("slideChange");
                    } else t !== d && ((n.snapIndex = t), n.emit("snapIndexChange"));
                }
            },
            (e, t, n) => {
                "use strict";
                n.r(t), n.d(t, { default: () => a });
                var i = n(2);
                function a(e) {
                    var t = this,
                        n = t.params,
                        a = (0, i.default)(e.target).closest("." + n.slideClass)[0],
                        o = !1;
                    if (a) for (var r = 0; r < t.slides.length; r += 1) t.slides[r] === a && (o = !0);
                    if (!a || !o) return (t.clickedSlide = void 0), void (t.clickedIndex = void 0);
                    (t.clickedSlide = a),
                        t.virtual && t.params.virtual.enabled ? (t.clickedIndex = parseInt((0, i.default)(a).attr("data-swiper-slide-index"), 10)) : (t.clickedIndex = (0, i.default)(a).index()),
                        n.slideToClickedSlide && void 0 !== t.clickedIndex && t.clickedIndex !== t.activeIndex && t.slideToClickedSlide();
                }
            },
            (e, t, n) => {
                "use strict";
                n.r(t), n.d(t, { default: () => l });
                var i = n(19),
                    a = n(20),
                    o = n(21),
                    r = n(22),
                    s = n(23);
                const l = { getTranslate: i.default, setTranslate: a.default, minTranslate: o.default, maxTranslate: r.default, translateTo: s.default };
            },
            (e, t, n) => {
                "use strict";
                n.r(t), n.d(t, { default: () => a });
                var i = n(6);
                function a(e) {
                    void 0 === e && (e = this.isHorizontal() ? "x" : "y");
                    var t = this,
                        n = t.params,
                        a = t.rtlTranslate,
                        o = t.translate,
                        r = t.$wrapperEl;
                    if (n.virtualTranslate) return a ? -o : o;
                    if (n.cssMode) return o;
                    var s = (0, i.getTranslate)(r[0], e);
                    return a && (s = -s), s || 0;
                }
            },
            (e, t, n) => {
                "use strict";
                function i(e, t) {
                    var n = this,
                        i = n.rtlTranslate,
                        a = n.params,
                        o = n.$wrapperEl,
                        r = n.wrapperEl,
                        s = n.progress,
                        l = 0,
                        c = 0;
                    n.isHorizontal() ? (l = i ? -e : e) : (c = e),
                        a.roundLengths && ((l = Math.floor(l)), (c = Math.floor(c))),
                        a.cssMode ? (r[n.isHorizontal() ? "scrollLeft" : "scrollTop"] = n.isHorizontal() ? -l : -c) : a.virtualTranslate || o.transform("translate3d(" + l + "px, " + c + "px, 0px)"),
                        (n.previousTranslate = n.translate),
                        (n.translate = n.isHorizontal() ? l : c);
                    var d = n.maxTranslate() - n.minTranslate();
                    (0 === d ? 0 : (e - n.minTranslate()) / d) !== s && n.updateProgress(e), n.emit("setTranslate", n.translate, t);
                }
                n.r(t), n.d(t, { default: () => i });
            },
            (e, t, n) => {
                "use strict";
                function i() {
                    return -this.snapGrid[0];
                }
                n.r(t), n.d(t, { default: () => i });
            },
            (e, t, n) => {
                "use strict";
                function i() {
                    return -this.snapGrid[this.snapGrid.length - 1];
                }
                n.r(t), n.d(t, { default: () => i });
            },
            (e, t, n) => {
                "use strict";
                function i(e, t, n, i, a) {
                    void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === n && (n = !0), void 0 === i && (i = !0);
                    var o = this,
                        r = o.params,
                        s = o.wrapperEl;
                    if (o.animating && r.preventInteractionOnTransition) return !1;
                    var l,
                        c = o.minTranslate(),
                        d = o.maxTranslate();
                    if (((l = i && e > c ? c : i && e < d ? d : e), o.updateProgress(l), r.cssMode)) {
                        var u,
                            p = o.isHorizontal();
                        if (0 === t) s[p ? "scrollLeft" : "scrollTop"] = -l;
                        else if (s.scrollTo) s.scrollTo((((u = {})[p ? "left" : "top"] = -l), (u.behavior = "smooth"), u));
                        else s[p ? "scrollLeft" : "scrollTop"] = -l;
                        return !0;
                    }
                    return (
                        0 === t
                            ? (o.setTransition(0), o.setTranslate(l), n && (o.emit("beforeTransitionStart", t, a), o.emit("transitionEnd")))
                            : (o.setTransition(t),
                              o.setTranslate(l),
                              n && (o.emit("beforeTransitionStart", t, a), o.emit("transitionStart")),
                              o.animating ||
                                  ((o.animating = !0),
                                  o.onTranslateToWrapperTransitionEnd ||
                                      (o.onTranslateToWrapperTransitionEnd = function (e) {
                                          o &&
                                              !o.destroyed &&
                                              e.target === this &&
                                              (o.$wrapperEl[0].removeEventListener("transitionend", o.onTranslateToWrapperTransitionEnd),
                                              o.$wrapperEl[0].removeEventListener("webkitTransitionEnd", o.onTranslateToWrapperTransitionEnd),
                                              (o.onTranslateToWrapperTransitionEnd = null),
                                              delete o.onTranslateToWrapperTransitionEnd,
                                              n && o.emit("transitionEnd"));
                                      }),
                                  o.$wrapperEl[0].addEventListener("transitionend", o.onTranslateToWrapperTransitionEnd),
                                  o.$wrapperEl[0].addEventListener("webkitTransitionEnd", o.onTranslateToWrapperTransitionEnd))),
                        !0
                    );
                }
                n.r(t), n.d(t, { default: () => i });
            },
            (e, t, n) => {
                "use strict";
                n.r(t), n.d(t, { default: () => r });
                var i = n(25),
                    a = n(26),
                    o = n(27);
                const r = { setTransition: i.default, transitionStart: a.default, transitionEnd: o.default };
            },
            (e, t, n) => {
                "use strict";
                function i(e, t) {
                    var n = this;
                    n.params.cssMode || n.$wrapperEl.transition(e), n.emit("setTransition", e, t);
                }
                n.r(t), n.d(t, { default: () => i });
            },
            (e, t, n) => {
                "use strict";
                function i(e, t) {
                    void 0 === e && (e = !0);
                    var n = this,
                        i = n.activeIndex,
                        a = n.params,
                        o = n.previousIndex;
                    if (!a.cssMode) {
                        a.autoHeight && n.updateAutoHeight();
                        var r = t;
                        if ((r || (r = i > o ? "next" : i < o ? "prev" : "reset"), n.emit("transitionStart"), e && i !== o)) {
                            if ("reset" === r) return void n.emit("slideResetTransitionStart");
                            n.emit("slideChangeTransitionStart"), "next" === r ? n.emit("slideNextTransitionStart") : n.emit("slidePrevTransitionStart");
                        }
                    }
                }
                n.r(t), n.d(t, { default: () => i });
            },
            (e, t, n) => {
                "use strict";
                function i(e, t) {
                    void 0 === e && (e = !0);
                    var n = this,
                        i = n.activeIndex,
                        a = n.previousIndex,
                        o = n.params;
                    if (((n.animating = !1), !o.cssMode)) {
                        n.setTransition(0);
                        var r = t;
                        if ((r || (r = i > a ? "next" : i < a ? "prev" : "reset"), n.emit("transitionEnd"), e && i !== a)) {
                            if ("reset" === r) return void n.emit("slideResetTransitionEnd");
                            n.emit("slideChangeTransitionEnd"), "next" === r ? n.emit("slideNextTransitionEnd") : n.emit("slidePrevTransitionEnd");
                        }
                    }
                }
                n.r(t), n.d(t, { default: () => i });
            },
            (e, t, n) => {
                "use strict";
                n.r(t), n.d(t, { default: () => d });
                var i = n(29),
                    a = n(30),
                    o = n(31),
                    r = n(32),
                    s = n(33),
                    l = n(34),
                    c = n(35);
                const d = { slideTo: i.default, slideToLoop: a.default, slideNext: o.default, slidePrev: r.default, slideReset: s.default, slideToClosest: l.default, slideToClickedSlide: c.default };
            },
            (e, t, n) => {
                "use strict";
                function i(e, t, n, i) {
                    if ((void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === n && (n = !0), "number" != typeof e && "string" != typeof e))
                        throw new Error("The 'index' argument cannot have type other than 'number' or 'string'. [" + typeof e + "] given.");
                    if ("string" == typeof e) {
                        var a = parseInt(e, 10);
                        if (!isFinite(a)) throw new Error("The passed-in 'index' (string) couldn't be converted to 'number'. [" + e + "] given.");
                        e = a;
                    }
                    var o = this,
                        r = e;
                    r < 0 && (r = 0);
                    var s = o.params,
                        l = o.snapGrid,
                        c = o.slidesGrid,
                        d = o.previousIndex,
                        u = o.activeIndex,
                        p = o.rtlTranslate,
                        f = o.wrapperEl;
                    if (o.animating && s.preventInteractionOnTransition) return !1;
                    var h = Math.min(o.params.slidesPerGroupSkip, r),
                        g = h + Math.floor((r - h) / o.params.slidesPerGroup);
                    g >= l.length && (g = l.length - 1), (u || s.initialSlide || 0) === (d || 0) && n && o.emit("beforeSlideChangeStart");
                    var v,
                        m = -l[g];
                    if ((o.updateProgress(m), s.normalizeSlideIndex)) for (var b = 0; b < c.length; b += 1) -Math.floor(100 * m) >= Math.floor(100 * c[b]) && (r = b);
                    if (o.initialized && r !== u) {
                        if (!o.allowSlideNext && m < o.translate && m < o.minTranslate()) return !1;
                        if (!o.allowSlidePrev && m > o.translate && m > o.maxTranslate() && (u || 0) !== r) return !1;
                    }
                    if (((v = r > u ? "next" : r < u ? "prev" : "reset"), (p && -m === o.translate) || (!p && m === o.translate)))
                        return o.updateActiveIndex(r), s.autoHeight && o.updateAutoHeight(), o.updateSlidesClasses(), "slide" !== s.effect && o.setTranslate(m), "reset" !== v && (o.transitionStart(n, v), o.transitionEnd(n, v)), !1;
                    if (s.cssMode) {
                        var w,
                            y = o.isHorizontal(),
                            x = -m;
                        if ((p && (x = f.scrollWidth - f.offsetWidth - x), 0 === t)) f[y ? "scrollLeft" : "scrollTop"] = x;
                        else if (f.scrollTo) f.scrollTo((((w = {})[y ? "left" : "top"] = x), (w.behavior = "smooth"), w));
                        else f[y ? "scrollLeft" : "scrollTop"] = x;
                        return !0;
                    }
                    return (
                        0 === t
                            ? (o.setTransition(0), o.setTranslate(m), o.updateActiveIndex(r), o.updateSlidesClasses(), o.emit("beforeTransitionStart", t, i), o.transitionStart(n, v), o.transitionEnd(n, v))
                            : (o.setTransition(t),
                              o.setTranslate(m),
                              o.updateActiveIndex(r),
                              o.updateSlidesClasses(),
                              o.emit("beforeTransitionStart", t, i),
                              o.transitionStart(n, v),
                              o.animating ||
                                  ((o.animating = !0),
                                  o.onSlideToWrapperTransitionEnd ||
                                      (o.onSlideToWrapperTransitionEnd = function (e) {
                                          o &&
                                              !o.destroyed &&
                                              e.target === this &&
                                              (o.$wrapperEl[0].removeEventListener("transitionend", o.onSlideToWrapperTransitionEnd),
                                              o.$wrapperEl[0].removeEventListener("webkitTransitionEnd", o.onSlideToWrapperTransitionEnd),
                                              (o.onSlideToWrapperTransitionEnd = null),
                                              delete o.onSlideToWrapperTransitionEnd,
                                              o.transitionEnd(n, v));
                                      }),
                                  o.$wrapperEl[0].addEventListener("transitionend", o.onSlideToWrapperTransitionEnd),
                                  o.$wrapperEl[0].addEventListener("webkitTransitionEnd", o.onSlideToWrapperTransitionEnd))),
                        !0
                    );
                }
                n.r(t), n.d(t, { default: () => i });
            },
            (e, t, n) => {
                "use strict";
                function i(e, t, n, i) {
                    void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === n && (n = !0);
                    var a = this,
                        o = e;
                    return a.params.loop && (o += a.loopedSlides), a.slideTo(o, t, n, i);
                }
                n.r(t), n.d(t, { default: () => i });
            },
            (e, t, n) => {
                "use strict";
                function i(e, t, n) {
                    void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
                    var i = this,
                        a = i.params,
                        o = i.animating,
                        r = i.activeIndex < a.slidesPerGroupSkip ? 1 : a.slidesPerGroup;
                    if (a.loop) {
                        if (o && a.loopPreventsSlide) return !1;
                        i.loopFix(), (i._clientLeft = i.$wrapperEl[0].clientLeft);
                    }
                    return i.slideTo(i.activeIndex + r, e, t, n);
                }
                n.r(t), n.d(t, { default: () => i });
            },
            (e, t, n) => {
                "use strict";
                function i(e, t, n) {
                    void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
                    var i = this,
                        a = i.params,
                        o = i.animating,
                        r = i.snapGrid,
                        s = i.slidesGrid,
                        l = i.rtlTranslate;
                    if (a.loop) {
                        if (o && a.loopPreventsSlide) return !1;
                        i.loopFix(), (i._clientLeft = i.$wrapperEl[0].clientLeft);
                    }
                    function c(e) {
                        return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e);
                    }
                    var d,
                        u = c(l ? i.translate : -i.translate),
                        p = r.map(function (e) {
                            return c(e);
                        }),
                        f = (r[p.indexOf(u)], r[p.indexOf(u) - 1]);
                    return (
                        void 0 === f &&
                            a.cssMode &&
                            r.forEach(function (e) {
                                !f && u >= e && (f = e);
                            }),
                        void 0 !== f && (d = s.indexOf(f)) < 0 && (d = i.activeIndex - 1),
                        i.slideTo(d, e, t, n)
                    );
                }
                n.r(t), n.d(t, { default: () => i });
            },
            (e, t, n) => {
                "use strict";
                function i(e, t, n) {
                    void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
                    return this.slideTo(this.activeIndex, e, t, n);
                }
                n.r(t), n.d(t, { default: () => i });
            },
            (e, t, n) => {
                "use strict";
                function i(e, t, n, i) {
                    void 0 === e && (e = this.params.speed), void 0 === t && (t = !0), void 0 === i && (i = 0.5);
                    var a = this,
                        o = a.activeIndex,
                        r = Math.min(a.params.slidesPerGroupSkip, o),
                        s = r + Math.floor((o - r) / a.params.slidesPerGroup),
                        l = a.rtlTranslate ? a.translate : -a.translate;
                    if (l >= a.snapGrid[s]) {
                        var c = a.snapGrid[s];
                        l - c > (a.snapGrid[s + 1] - c) * i && (o += a.params.slidesPerGroup);
                    } else {
                        var d = a.snapGrid[s - 1];
                        l - d <= (a.snapGrid[s] - d) * i && (o -= a.params.slidesPerGroup);
                    }
                    return (o = Math.max(o, 0)), (o = Math.min(o, a.slidesGrid.length - 1)), a.slideTo(o, e, t, n);
                }
                n.r(t), n.d(t, { default: () => i });
            },
            (e, t, n) => {
                "use strict";
                n.r(t), n.d(t, { default: () => o });
                var i = n(2),
                    a = n(6);
                function o() {
                    var e,
                        t = this,
                        n = t.params,
                        o = t.$wrapperEl,
                        r = "auto" === n.slidesPerView ? t.slidesPerViewDynamic() : n.slidesPerView,
                        s = t.clickedIndex;
                    if (n.loop) {
                        if (t.animating) return;
                        (e = parseInt((0, i.default)(t.clickedSlide).attr("data-swiper-slide-index"), 10)),
                            n.centeredSlides
                                ? s < t.loopedSlides - r / 2 || s > t.slides.length - t.loopedSlides + r / 2
                                    ? (t.loopFix(),
                                      (s = o
                                          .children("." + n.slideClass + '[data-swiper-slide-index="' + e + '"]:not(.' + n.slideDuplicateClass + ")")
                                          .eq(0)
                                          .index()),
                                      (0, a.nextTick)(function () {
                                          t.slideTo(s);
                                      }))
                                    : t.slideTo(s)
                                : s > t.slides.length - r
                                ? (t.loopFix(),
                                  (s = o
                                      .children("." + n.slideClass + '[data-swiper-slide-index="' + e + '"]:not(.' + n.slideDuplicateClass + ")")
                                      .eq(0)
                                      .index()),
                                  (0, a.nextTick)(function () {
                                      t.slideTo(s);
                                  }))
                                : t.slideTo(s);
                    } else t.slideTo(s);
                }
            },
            (e, t, n) => {
                "use strict";
                n.r(t), n.d(t, { default: () => r });
                var i = n(37),
                    a = n(38),
                    o = n(39);
                const r = { loopCreate: i.default, loopFix: a.default, loopDestroy: o.default };
            },
            (e, t, n) => {
                "use strict";
                n.r(t), n.d(t, { default: () => o });
                var i = n(4),
                    a = n(2);
                function o() {
                    var e = this,
                        t = (0, i.getDocument)(),
                        n = e.params,
                        o = e.$wrapperEl;
                    o.children("." + n.slideClass + "." + n.slideDuplicateClass).remove();
                    var r = o.children("." + n.slideClass);
                    if (n.loopFillGroupWithBlank) {
                        var s = n.slidesPerGroup - (r.length % n.slidesPerGroup);
                        if (s !== n.slidesPerGroup) {
                            for (var l = 0; l < s; l += 1) {
                                var c = (0, a.default)(t.createElement("div")).addClass(n.slideClass + " " + n.slideBlankClass);
                                o.append(c);
                            }
                            r = o.children("." + n.slideClass);
                        }
                    }
                    "auto" !== n.slidesPerView || n.loopedSlides || (n.loopedSlides = r.length),
                        (e.loopedSlides = Math.ceil(parseFloat(n.loopedSlides || n.slidesPerView, 10))),
                        (e.loopedSlides += n.loopAdditionalSlides),
                        e.loopedSlides > r.length && (e.loopedSlides = r.length);
                    var d = [],
                        u = [];
                    r.each(function (t, n) {
                        var i = (0, a.default)(t);
                        n < e.loopedSlides && u.push(t), n < r.length && n >= r.length - e.loopedSlides && d.push(t), i.attr("data-swiper-slide-index", n);
                    });
                    for (var p = 0; p < u.length; p += 1) o.append((0, a.default)(u[p].cloneNode(!0)).addClass(n.slideDuplicateClass));
                    for (var f = d.length - 1; f >= 0; f -= 1) o.prepend((0, a.default)(d[f].cloneNode(!0)).addClass(n.slideDuplicateClass));
                }
            },
            (e, t, n) => {
                "use strict";
                function i() {
                    var e = this;
                    e.emit("beforeLoopFix");
                    var t,
                        n = e.activeIndex,
                        i = e.slides,
                        a = e.loopedSlides,
                        o = e.allowSlidePrev,
                        r = e.allowSlideNext,
                        s = e.snapGrid,
                        l = e.rtlTranslate;
                    (e.allowSlidePrev = !0), (e.allowSlideNext = !0);
                    var c = -s[n] - e.getTranslate();
                    if (n < a) (t = i.length - 3 * a + n), (t += a), e.slideTo(t, 0, !1, !0) && 0 !== c && e.setTranslate((l ? -e.translate : e.translate) - c);
                    else if (n >= i.length - a) {
                        (t = -i.length + n + a), (t += a), e.slideTo(t, 0, !1, !0) && 0 !== c && e.setTranslate((l ? -e.translate : e.translate) - c);
                    }
                    (e.allowSlidePrev = o), (e.allowSlideNext = r), e.emit("loopFix");
                }
                n.r(t), n.d(t, { default: () => i });
            },
            (e, t, n) => {
                "use strict";
                function i() {
                    var e = this,
                        t = e.$wrapperEl,
                        n = e.params,
                        i = e.slides;
                    t.children("." + n.slideClass + "." + n.slideDuplicateClass + ",." + n.slideClass + "." + n.slideBlankClass).remove(), i.removeAttr("data-swiper-slide-index");
                }
                n.r(t), n.d(t, { default: () => i });
            },
            (e, t, n) => {
                "use strict";
                n.r(t), n.d(t, { default: () => o });
                var i = n(41),
                    a = n(42);
                const o = { setGrabCursor: i.default, unsetGrabCursor: a.default };
            },
            (e, t, n) => {
                "use strict";
                function i(e) {
                    var t = this;
                    if (!(t.support.touch || !t.params.simulateTouch || (t.params.watchOverflow && t.isLocked) || t.params.cssMode)) {
                        var n = t.el;
                        (n.style.cursor = "move"), (n.style.cursor = e ? "-webkit-grabbing" : "-webkit-grab"), (n.style.cursor = e ? "-moz-grabbin" : "-moz-grab"), (n.style.cursor = e ? "grabbing" : "grab");
                    }
                }
                n.r(t), n.d(t, { default: () => i });
            },
            (e, t, n) => {
                "use strict";
                function i() {
                    var e = this;
                    e.support.touch || (e.params.watchOverflow && e.isLocked) || e.params.cssMode || (e.el.style.cursor = "");
                }
                n.r(t), n.d(t, { default: () => i });
            },
            (e, t, n) => {
                "use strict";
                n.r(t), n.d(t, { default: () => l });
                var i = n(44),
                    a = n(45),
                    o = n(46),
                    r = n(47),
                    s = n(48);
                const l = { appendSlide: i.default, prependSlide: a.default, addSlide: o.default, removeSlide: r.default, removeAllSlides: s.default };
            },
            (e, t, n) => {
                "use strict";
                function i(e) {
                    var t = this,
                        n = t.$wrapperEl,
                        i = t.params;
                    if ((i.loop && t.loopDestroy(), "object" == typeof e && "length" in e)) for (var a = 0; a < e.length; a += 1) e[a] && n.append(e[a]);
                    else n.append(e);
                    i.loop && t.loopCreate(), (i.observer && t.support.observer) || t.update();
                }
                n.r(t), n.d(t, { default: () => i });
            },
            (e, t, n) => {
                "use strict";
                function i(e) {
                    var t = this,
                        n = t.params,
                        i = t.$wrapperEl,
                        a = t.activeIndex;
                    n.loop && t.loopDestroy();
                    var o = a + 1;
                    if ("object" == typeof e && "length" in e) {
                        for (var r = 0; r < e.length; r += 1) e[r] && i.prepend(e[r]);
                        o = a + e.length;
                    } else i.prepend(e);
                    n.loop && t.loopCreate(), (n.observer && t.support.observer) || t.update(), t.slideTo(o, 0, !1);
                }
                n.r(t), n.d(t, { default: () => i });
            },
            (e, t, n) => {
                "use strict";
                function i(e, t) {
                    var n = this,
                        i = n.$wrapperEl,
                        a = n.params,
                        o = n.activeIndex;
                    a.loop && ((o -= n.loopedSlides), n.loopDestroy(), (n.slides = i.children("." + a.slideClass)));
                    var r = n.slides.length;
                    if (e <= 0) n.prependSlide(t);
                    else if (e >= r) n.appendSlide(t);
                    else {
                        for (var s = o > e ? o + 1 : o, l = [], c = r - 1; c >= e; c -= 1) {
                            var d = n.slides.eq(c);
                            d.remove(), l.unshift(d);
                        }
                        if ("object" == typeof t && "length" in t) {
                            for (var u = 0; u < t.length; u += 1) t[u] && i.append(t[u]);
                            s = o > e ? o + t.length : o;
                        } else i.append(t);
                        for (var p = 0; p < l.length; p += 1) i.append(l[p]);
                        a.loop && n.loopCreate(), (a.observer && n.support.observer) || n.update(), a.loop ? n.slideTo(s + n.loopedSlides, 0, !1) : n.slideTo(s, 0, !1);
                    }
                }
                n.r(t), n.d(t, { default: () => i });
            },
            (e, t, n) => {
                "use strict";
                function i(e) {
                    var t = this,
                        n = t.params,
                        i = t.$wrapperEl,
                        a = t.activeIndex;
                    n.loop && ((a -= t.loopedSlides), t.loopDestroy(), (t.slides = i.children("." + n.slideClass)));
                    var o,
                        r = a;
                    if ("object" == typeof e && "length" in e) {
                        for (var s = 0; s < e.length; s += 1) (o = e[s]), t.slides[o] && t.slides.eq(o).remove(), o < r && (r -= 1);
                        r = Math.max(r, 0);
                    } else (o = e), t.slides[o] && t.slides.eq(o).remove(), o < r && (r -= 1), (r = Math.max(r, 0));
                    n.loop && t.loopCreate(), (n.observer && t.support.observer) || t.update(), n.loop ? t.slideTo(r + t.loopedSlides, 0, !1) : t.slideTo(r, 0, !1);
                }
                n.r(t), n.d(t, { default: () => i });
            },
            (e, t, n) => {
                "use strict";
                function i() {
                    for (var e = [], t = 0; t < this.slides.length; t += 1) e.push(t);
                    this.removeSlide(e);
                }
                n.r(t), n.d(t, { default: () => i });
            },
            (e, t, n) => {
                "use strict";
                n.r(t), n.d(t, { default: () => p });
                var i = n(4),
                    a = n(50),
                    o = n(51),
                    r = n(52),
                    s = n(55),
                    l = n(54),
                    c = n(53),
                    d = !1;
                function u() {}
                const p = {
                    attachEvents: function () {
                        var e = this,
                            t = (0, i.getDocument)(),
                            n = e.params,
                            p = e.touchEvents,
                            f = e.el,
                            h = e.wrapperEl,
                            g = e.device,
                            v = e.support;
                        (e.onTouchStart = a.default.bind(e)), (e.onTouchMove = o.default.bind(e)), (e.onTouchEnd = r.default.bind(e)), n.cssMode && (e.onScroll = c.default.bind(e)), (e.onClick = l.default.bind(e));
                        var m = !!n.nested;
                        if (!v.touch && v.pointerEvents) f.addEventListener(p.start, e.onTouchStart, !1), t.addEventListener(p.move, e.onTouchMove, m), t.addEventListener(p.end, e.onTouchEnd, !1);
                        else {
                            if (v.touch) {
                                var b = !("touchstart" !== p.start || !v.passiveListener || !n.passiveListeners) && { passive: !0, capture: !1 };
                                f.addEventListener(p.start, e.onTouchStart, b),
                                    f.addEventListener(p.move, e.onTouchMove, v.passiveListener ? { passive: !1, capture: m } : m),
                                    f.addEventListener(p.end, e.onTouchEnd, b),
                                    p.cancel && f.addEventListener(p.cancel, e.onTouchEnd, b),
                                    d || (t.addEventListener("touchstart", u), (d = !0));
                            }
                            ((n.simulateTouch && !g.ios && !g.android) || (n.simulateTouch && !v.touch && g.ios)) &&
                                (f.addEventListener("mousedown", e.onTouchStart, !1), t.addEventListener("mousemove", e.onTouchMove, m), t.addEventListener("mouseup", e.onTouchEnd, !1));
                        }
                        (n.preventClicks || n.preventClicksPropagation) && f.addEventListener("click", e.onClick, !0),
                            n.cssMode && h.addEventListener("scroll", e.onScroll),
                            n.updateOnWindowResize ? e.on(g.ios || g.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", s.default, !0) : e.on("observerUpdate", s.default, !0);
                    },
                    detachEvents: function () {
                        var e = this,
                            t = (0, i.getDocument)(),
                            n = e.params,
                            a = e.touchEvents,
                            o = e.el,
                            r = e.wrapperEl,
                            l = e.device,
                            c = e.support,
                            d = !!n.nested;
                        if (!c.touch && c.pointerEvents) o.removeEventListener(a.start, e.onTouchStart, !1), t.removeEventListener(a.move, e.onTouchMove, d), t.removeEventListener(a.end, e.onTouchEnd, !1);
                        else {
                            if (c.touch) {
                                var u = !("onTouchStart" !== a.start || !c.passiveListener || !n.passiveListeners) && { passive: !0, capture: !1 };
                                o.removeEventListener(a.start, e.onTouchStart, u), o.removeEventListener(a.move, e.onTouchMove, d), o.removeEventListener(a.end, e.onTouchEnd, u), a.cancel && o.removeEventListener(a.cancel, e.onTouchEnd, u);
                            }
                            ((n.simulateTouch && !l.ios && !l.android) || (n.simulateTouch && !c.touch && l.ios)) &&
                                (o.removeEventListener("mousedown", e.onTouchStart, !1), t.removeEventListener("mousemove", e.onTouchMove, d), t.removeEventListener("mouseup", e.onTouchEnd, !1));
                        }
                        (n.preventClicks || n.preventClicksPropagation) && o.removeEventListener("click", e.onClick, !0),
                            n.cssMode && r.removeEventListener("scroll", e.onScroll),
                            e.off(l.ios || l.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", s.default);
                    },
                };
            },
            (e, t, n) => {
                "use strict";
                n.r(t), n.d(t, { default: () => r });
                var i = n(4),
                    a = n(2),
                    o = n(6);
                function r(e) {
                    var t = this,
                        n = (0, i.getDocument)(),
                        r = (0, i.getWindow)(),
                        s = t.touchEventsData,
                        l = t.params,
                        c = t.touches;
                    if (!t.animating || !l.preventInteractionOnTransition) {
                        var d = e;
                        d.originalEvent && (d = d.originalEvent);
                        var u = (0, a.default)(d.target);
                        if ("wrapper" !== l.touchEventsTarget || u.closest(t.wrapperEl).length)
                            if (((s.isTouchEvent = "touchstart" === d.type), s.isTouchEvent || !("which" in d) || 3 !== d.which))
                                if (!(!s.isTouchEvent && "button" in d && d.button > 0))
                                    if (!s.isTouched || !s.isMoved)
                                        if (
                                            (!!l.noSwipingClass && "" !== l.noSwipingClass && d.target && d.target.shadowRoot && e.path && e.path[0] && (u = (0, a.default)(e.path[0])),
                                            l.noSwiping && u.closest(l.noSwipingSelector ? l.noSwipingSelector : "." + l.noSwipingClass)[0])
                                        )
                                            t.allowClick = !0;
                                        else if (!l.swipeHandler || u.closest(l.swipeHandler)[0]) {
                                            (c.currentX = "touchstart" === d.type ? d.targetTouches[0].pageX : d.pageX), (c.currentY = "touchstart" === d.type ? d.targetTouches[0].pageY : d.pageY);
                                            var p = c.currentX,
                                                f = c.currentY,
                                                h = l.edgeSwipeDetection || l.iOSEdgeSwipeDetection,
                                                g = l.edgeSwipeThreshold || l.iOSEdgeSwipeThreshold;
                                            if (!h || !(p <= g || p >= r.innerWidth - g)) {
                                                if (
                                                    ((0, o.extend)(s, { isTouched: !0, isMoved: !1, allowTouchCallbacks: !0, isScrolling: void 0, startMoving: void 0 }),
                                                    (c.startX = p),
                                                    (c.startY = f),
                                                    (s.touchStartTime = (0, o.now)()),
                                                    (t.allowClick = !0),
                                                    t.updateSize(),
                                                    (t.swipeDirection = void 0),
                                                    l.threshold > 0 && (s.allowThresholdMove = !1),
                                                    "touchstart" !== d.type)
                                                ) {
                                                    var v = !0;
                                                    u.is(s.formElements) && (v = !1), n.activeElement && (0, a.default)(n.activeElement).is(s.formElements) && n.activeElement !== u[0] && n.activeElement.blur();
                                                    var m = v && t.allowTouchMove && l.touchStartPreventDefault;
                                                    (!l.touchStartForcePreventDefault && !m) || u[0].isContentEditable || d.preventDefault();
                                                }
                                                t.emit("touchStart", d);
                                            }
                                        }
                    }
                }
            },
            (e, t, n) => {
                "use strict";
                n.r(t), n.d(t, { default: () => r });
                var i = n(4),
                    a = n(2),
                    o = n(6);
                function r(e) {
                    var t = (0, i.getDocument)(),
                        n = this,
                        r = n.touchEventsData,
                        s = n.params,
                        l = n.touches,
                        c = n.rtlTranslate,
                        d = e;
                    if ((d.originalEvent && (d = d.originalEvent), r.isTouched)) {
                        if (!r.isTouchEvent || "touchmove" === d.type) {
                            var u = "touchmove" === d.type && d.targetTouches && (d.targetTouches[0] || d.changedTouches[0]),
                                p = "touchmove" === d.type ? u.pageX : d.pageX,
                                f = "touchmove" === d.type ? u.pageY : d.pageY;
                            if (d.preventedByNestedSwiper) return (l.startX = p), void (l.startY = f);
                            if (!n.allowTouchMove) return (n.allowClick = !1), void (r.isTouched && ((0, o.extend)(l, { startX: p, startY: f, currentX: p, currentY: f }), (r.touchStartTime = (0, o.now)())));
                            if (r.isTouchEvent && s.touchReleaseOnEdges && !s.loop)
                                if (n.isVertical()) {
                                    if ((f < l.startY && n.translate <= n.maxTranslate()) || (f > l.startY && n.translate >= n.minTranslate())) return (r.isTouched = !1), void (r.isMoved = !1);
                                } else if ((p < l.startX && n.translate <= n.maxTranslate()) || (p > l.startX && n.translate >= n.minTranslate())) return;
                            if (r.isTouchEvent && t.activeElement && d.target === t.activeElement && (0, a.default)(d.target).is(r.formElements)) return (r.isMoved = !0), void (n.allowClick = !1);
                            if ((r.allowTouchCallbacks && n.emit("touchMove", d), !(d.targetTouches && d.targetTouches.length > 1))) {
                                (l.currentX = p), (l.currentY = f);
                                var h = l.currentX - l.startX,
                                    g = l.currentY - l.startY;
                                if (!(n.params.threshold && Math.sqrt(Math.pow(h, 2) + Math.pow(g, 2)) < n.params.threshold)) {
                                    var v;
                                    if (void 0 === r.isScrolling)
                                        (n.isHorizontal() && l.currentY === l.startY) || (n.isVertical() && l.currentX === l.startX)
                                            ? (r.isScrolling = !1)
                                            : h * h + g * g >= 25 && ((v = (180 * Math.atan2(Math.abs(g), Math.abs(h))) / Math.PI), (r.isScrolling = n.isHorizontal() ? v > s.touchAngle : 90 - v > s.touchAngle));
                                    if ((r.isScrolling && n.emit("touchMoveOpposite", d), void 0 === r.startMoving && ((l.currentX === l.startX && l.currentY === l.startY) || (r.startMoving = !0)), r.isScrolling)) r.isTouched = !1;
                                    else if (r.startMoving) {
                                        (n.allowClick = !1),
                                            !s.cssMode && d.cancelable && d.preventDefault(),
                                            s.touchMoveStopPropagation && !s.nested && d.stopPropagation(),
                                            r.isMoved ||
                                                (s.loop && n.loopFix(),
                                                (r.startTranslate = n.getTranslate()),
                                                n.setTransition(0),
                                                n.animating && n.$wrapperEl.trigger("webkitTransitionEnd transitionend"),
                                                (r.allowMomentumBounce = !1),
                                                !s.grabCursor || (!0 !== n.allowSlideNext && !0 !== n.allowSlidePrev) || n.setGrabCursor(!0),
                                                n.emit("sliderFirstMove", d)),
                                            n.emit("sliderMove", d),
                                            (r.isMoved = !0);
                                        var m = n.isHorizontal() ? h : g;
                                        (l.diff = m), (m *= s.touchRatio), c && (m = -m), (n.swipeDirection = m > 0 ? "prev" : "next"), (r.currentTranslate = m + r.startTranslate);
                                        var b = !0,
                                            w = s.resistanceRatio;
                                        if (
                                            (s.touchReleaseOnEdges && (w = 0),
                                            m > 0 && r.currentTranslate > n.minTranslate()
                                                ? ((b = !1), s.resistance && (r.currentTranslate = n.minTranslate() - 1 + Math.pow(-n.minTranslate() + r.startTranslate + m, w)))
                                                : m < 0 && r.currentTranslate < n.maxTranslate() && ((b = !1), s.resistance && (r.currentTranslate = n.maxTranslate() + 1 - Math.pow(n.maxTranslate() - r.startTranslate - m, w))),
                                            b && (d.preventedByNestedSwiper = !0),
                                            !n.allowSlideNext && "next" === n.swipeDirection && r.currentTranslate < r.startTranslate && (r.currentTranslate = r.startTranslate),
                                            !n.allowSlidePrev && "prev" === n.swipeDirection && r.currentTranslate > r.startTranslate && (r.currentTranslate = r.startTranslate),
                                            s.threshold > 0)
                                        ) {
                                            if (!(Math.abs(m) > s.threshold || r.allowThresholdMove)) return void (r.currentTranslate = r.startTranslate);
                                            if (!r.allowThresholdMove)
                                                return (
                                                    (r.allowThresholdMove = !0),
                                                    (l.startX = l.currentX),
                                                    (l.startY = l.currentY),
                                                    (r.currentTranslate = r.startTranslate),
                                                    void (l.diff = n.isHorizontal() ? l.currentX - l.startX : l.currentY - l.startY)
                                                );
                                        }
                                        s.followFinger &&
                                            !s.cssMode &&
                                            ((s.freeMode || s.watchSlidesProgress || s.watchSlidesVisibility) && (n.updateActiveIndex(), n.updateSlidesClasses()),
                                            s.freeMode &&
                                                (0 === r.velocities.length && r.velocities.push({ position: l[n.isHorizontal() ? "startX" : "startY"], time: r.touchStartTime }),
                                                r.velocities.push({ position: l[n.isHorizontal() ? "currentX" : "currentY"], time: (0, o.now)() })),
                                            n.updateProgress(r.currentTranslate),
                                            n.setTranslate(r.currentTranslate));
                                    }
                                }
                            }
                        }
                    } else r.startMoving && r.isScrolling && n.emit("touchMoveOpposite", d);
                }
            },
            (e, t, n) => {
                "use strict";
                n.r(t), n.d(t, { default: () => a });
                var i = n(6);
                function a(e) {
                    var t = this,
                        n = t.touchEventsData,
                        a = t.params,
                        o = t.touches,
                        r = t.rtlTranslate,
                        s = t.$wrapperEl,
                        l = t.slidesGrid,
                        c = t.snapGrid,
                        d = e;
                    if ((d.originalEvent && (d = d.originalEvent), n.allowTouchCallbacks && t.emit("touchEnd", d), (n.allowTouchCallbacks = !1), !n.isTouched))
                        return n.isMoved && a.grabCursor && t.setGrabCursor(!1), (n.isMoved = !1), void (n.startMoving = !1);
                    a.grabCursor && n.isMoved && n.isTouched && (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) && t.setGrabCursor(!1);
                    var u,
                        p = (0, i.now)(),
                        f = p - n.touchStartTime;
                    if (
                        (t.allowClick && (t.updateClickedSlide(d), t.emit("tap click", d), f < 300 && p - n.lastClickTime < 300 && t.emit("doubleTap doubleClick", d)),
                        (n.lastClickTime = (0, i.now)()),
                        (0, i.nextTick)(function () {
                            t.destroyed || (t.allowClick = !0);
                        }),
                        !n.isTouched || !n.isMoved || !t.swipeDirection || 0 === o.diff || n.currentTranslate === n.startTranslate)
                    )
                        return (n.isTouched = !1), (n.isMoved = !1), void (n.startMoving = !1);
                    if (((n.isTouched = !1), (n.isMoved = !1), (n.startMoving = !1), (u = a.followFinger ? (r ? t.translate : -t.translate) : -n.currentTranslate), !a.cssMode))
                        if (a.freeMode) {
                            if (u < -t.minTranslate()) return void t.slideTo(t.activeIndex);
                            if (u > -t.maxTranslate()) return void (t.slides.length < c.length ? t.slideTo(c.length - 1) : t.slideTo(t.slides.length - 1));
                            if (a.freeModeMomentum) {
                                if (n.velocities.length > 1) {
                                    var h = n.velocities.pop(),
                                        g = n.velocities.pop(),
                                        v = h.position - g.position,
                                        m = h.time - g.time;
                                    (t.velocity = v / m), (t.velocity /= 2), Math.abs(t.velocity) < a.freeModeMinimumVelocity && (t.velocity = 0), (m > 150 || (0, i.now)() - h.time > 300) && (t.velocity = 0);
                                } else t.velocity = 0;
                                (t.velocity *= a.freeModeMomentumVelocityRatio), (n.velocities.length = 0);
                                var b = 1e3 * a.freeModeMomentumRatio,
                                    w = t.velocity * b,
                                    y = t.translate + w;
                                r && (y = -y);
                                var x,
                                    C,
                                    T = !1,
                                    S = 20 * Math.abs(t.velocity) * a.freeModeMomentumBounceRatio;
                                if (y < t.maxTranslate())
                                    a.freeModeMomentumBounce ? (y + t.maxTranslate() < -S && (y = t.maxTranslate() - S), (x = t.maxTranslate()), (T = !0), (n.allowMomentumBounce = !0)) : (y = t.maxTranslate()),
                                        a.loop && a.centeredSlides && (C = !0);
                                else if (y > t.minTranslate())
                                    a.freeModeMomentumBounce ? (y - t.minTranslate() > S && (y = t.minTranslate() + S), (x = t.minTranslate()), (T = !0), (n.allowMomentumBounce = !0)) : (y = t.minTranslate()),
                                        a.loop && a.centeredSlides && (C = !0);
                                else if (a.freeModeSticky) {
                                    for (var A, $ = 0; $ < c.length; $ += 1)
                                        if (c[$] > -y) {
                                            A = $;
                                            break;
                                        }
                                    y = -(y = Math.abs(c[A] - y) < Math.abs(c[A - 1] - y) || "next" === t.swipeDirection ? c[A] : c[A - 1]);
                                }
                                if (
                                    (C &&
                                        t.once("transitionEnd", function () {
                                            t.loopFix();
                                        }),
                                    0 !== t.velocity)
                                ) {
                                    if (((b = r ? Math.abs((-y - t.translate) / t.velocity) : Math.abs((y - t.translate) / t.velocity)), a.freeModeSticky)) {
                                        var E = Math.abs((r ? -y : y) - t.translate),
                                            k = t.slidesSizesGrid[t.activeIndex];
                                        b = E < k ? a.speed : E < 2 * k ? 1.5 * a.speed : 2.5 * a.speed;
                                    }
                                } else if (a.freeModeSticky) return void t.slideToClosest();
                                a.freeModeMomentumBounce && T
                                    ? (t.updateProgress(x),
                                      t.setTransition(b),
                                      t.setTranslate(y),
                                      t.transitionStart(!0, t.swipeDirection),
                                      (t.animating = !0),
                                      s.transitionEnd(function () {
                                          t &&
                                              !t.destroyed &&
                                              n.allowMomentumBounce &&
                                              (t.emit("momentumBounce"),
                                              t.setTransition(a.speed),
                                              setTimeout(function () {
                                                  t.setTranslate(x),
                                                      s.transitionEnd(function () {
                                                          t && !t.destroyed && t.transitionEnd();
                                                      });
                                              }, 0));
                                      }))
                                    : t.velocity
                                    ? (t.updateProgress(y),
                                      t.setTransition(b),
                                      t.setTranslate(y),
                                      t.transitionStart(!0, t.swipeDirection),
                                      t.animating ||
                                          ((t.animating = !0),
                                          s.transitionEnd(function () {
                                              t && !t.destroyed && t.transitionEnd();
                                          })))
                                    : t.updateProgress(y),
                                    t.updateActiveIndex(),
                                    t.updateSlidesClasses();
                            } else if (a.freeModeSticky) return void t.slideToClosest();
                            (!a.freeModeMomentum || f >= a.longSwipesMs) && (t.updateProgress(), t.updateActiveIndex(), t.updateSlidesClasses());
                        } else {
                            for (var P = 0, M = t.slidesSizesGrid[0], _ = 0; _ < l.length; _ += _ < a.slidesPerGroupSkip ? 1 : a.slidesPerGroup) {
                                var L = _ < a.slidesPerGroupSkip - 1 ? 1 : a.slidesPerGroup;
                                void 0 !== l[_ + L] ? u >= l[_] && u < l[_ + L] && ((P = _), (M = l[_ + L] - l[_])) : u >= l[_] && ((P = _), (M = l[l.length - 1] - l[l.length - 2]));
                            }
                            var z = (u - l[P]) / M,
                                I = P < a.slidesPerGroupSkip - 1 ? 1 : a.slidesPerGroup;
                            if (f > a.longSwipesMs) {
                                if (!a.longSwipes) return void t.slideTo(t.activeIndex);
                                "next" === t.swipeDirection && (z >= a.longSwipesRatio ? t.slideTo(P + I) : t.slideTo(P)), "prev" === t.swipeDirection && (z > 1 - a.longSwipesRatio ? t.slideTo(P + I) : t.slideTo(P));
                            } else {
                                if (!a.shortSwipes) return void t.slideTo(t.activeIndex);
                                t.navigation && (d.target === t.navigation.nextEl || d.target === t.navigation.prevEl)
                                    ? d.target === t.navigation.nextEl
                                        ? t.slideTo(P + I)
                                        : t.slideTo(P)
                                    : ("next" === t.swipeDirection && t.slideTo(P + I), "prev" === t.swipeDirection && t.slideTo(P));
                            }
                        }
                }
            },
            (e, t, n) => {
                "use strict";
                function i() {
                    var e = this,
                        t = e.wrapperEl,
                        n = e.rtlTranslate;
                    (e.previousTranslate = e.translate),
                        e.isHorizontal() ? (e.translate = n ? t.scrollWidth - t.offsetWidth - t.scrollLeft : -t.scrollLeft) : (e.translate = -t.scrollTop),
                        -0 === e.translate && (e.translate = 0),
                        e.updateActiveIndex(),
                        e.updateSlidesClasses();
                    var i = e.maxTranslate() - e.minTranslate();
                    (0 === i ? 0 : (e.translate - e.minTranslate()) / i) !== e.progress && e.updateProgress(n ? -e.translate : e.translate), e.emit("setTranslate", e.translate, !1);
                }
                n.r(t), n.d(t, { default: () => i });
            },
            (e, t, n) => {
                "use strict";
                function i(e) {
                    var t = this;
                    t.allowClick || (t.params.preventClicks && e.preventDefault(), t.params.preventClicksPropagation && t.animating && (e.stopPropagation(), e.stopImmediatePropagation()));
                }
                n.r(t), n.d(t, { default: () => i });
            },
            (e, t, n) => {
                "use strict";
                function i() {
                    var e = this,
                        t = e.params,
                        n = e.el;
                    if (!n || 0 !== n.offsetWidth) {
                        t.breakpoints && e.setBreakpoint();
                        var i = e.allowSlideNext,
                            a = e.allowSlidePrev,
                            o = e.snapGrid;
                        (e.allowSlideNext = !0),
                            (e.allowSlidePrev = !0),
                            e.updateSize(),
                            e.updateSlides(),
                            e.updateSlidesClasses(),
                            ("auto" === t.slidesPerView || t.slidesPerView > 1) && e.isEnd && !e.isBeginning && !e.params.centeredSlides ? e.slideTo(e.slides.length - 1, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0),
                            e.autoplay && e.autoplay.running && e.autoplay.paused && e.autoplay.run(),
                            (e.allowSlidePrev = a),
                            (e.allowSlideNext = i),
                            e.params.watchOverflow && o !== e.snapGrid && e.checkOverflow();
                    }
                }
                n.r(t), n.d(t, { default: () => i });
            },
            (e, t, n) => {
                "use strict";
                n.r(t), n.d(t, { default: () => o });
                var i = n(57),
                    a = n(58);
                const o = { setBreakpoint: i.default, getBreakpoint: a.default };
            },
            (e, t, n) => {
                "use strict";
                n.r(t), n.d(t, { default: () => a });
                var i = n(6);
                function a() {
                    var e = this,
                        t = e.activeIndex,
                        n = e.initialized,
                        a = e.loopedSlides,
                        o = void 0 === a ? 0 : a,
                        r = e.params,
                        s = e.$el,
                        l = r.breakpoints;
                    if (l && (!l || 0 !== Object.keys(l).length)) {
                        var c = e.getBreakpoint(l);
                        if (c && e.currentBreakpoint !== c) {
                            var d = c in l ? l[c] : void 0;
                            d &&
                                ["slidesPerView", "spaceBetween", "slidesPerGroup", "slidesPerGroupSkip", "slidesPerColumn"].forEach(function (e) {
                                    var t = d[e];
                                    void 0 !== t && (d[e] = "slidesPerView" !== e || ("AUTO" !== t && "auto" !== t) ? ("slidesPerView" === e ? parseFloat(t) : parseInt(t, 10)) : "auto");
                                });
                            var u = d || e.originalParams,
                                p = r.slidesPerColumn > 1,
                                f = u.slidesPerColumn > 1;
                            p && !f
                                ? (s.removeClass(r.containerModifierClass + "multirow " + r.containerModifierClass + "multirow-column"), e.emitContainerClasses())
                                : !p && f && (s.addClass(r.containerModifierClass + "multirow"), "column" === u.slidesPerColumnFill && s.addClass(r.containerModifierClass + "multirow-column"), e.emitContainerClasses());
                            var h = u.direction && u.direction !== r.direction,
                                g = r.loop && (u.slidesPerView !== r.slidesPerView || h);
                            h && n && e.changeDirection(),
                                (0, i.extend)(e.params, u),
                                (0, i.extend)(e, { allowTouchMove: e.params.allowTouchMove, allowSlideNext: e.params.allowSlideNext, allowSlidePrev: e.params.allowSlidePrev }),
                                (e.currentBreakpoint = c),
                                e.emit("_beforeBreakpoint", u),
                                g && n && (e.loopDestroy(), e.loopCreate(), e.updateSlides(), e.slideTo(t - o + e.loopedSlides, 0, !1)),
                                e.emit("breakpoint", u);
                        }
                    }
                }
            },
            (e, t, n) => {
                "use strict";
                n.r(t), n.d(t, { default: () => a });
                var i = n(4);
                function a(e) {
                    var t = (0, i.getWindow)();
                    if (e) {
                        var n = !1,
                            a = Object.keys(e).map(function (e) {
                                if ("string" == typeof e && 0 === e.indexOf("@")) {
                                    var n = parseFloat(e.substr(1));
                                    return { value: t.innerHeight * n, point: e };
                                }
                                return { value: e, point: e };
                            });
                        a.sort(function (e, t) {
                            return parseInt(e.value, 10) - parseInt(t.value, 10);
                        });
                        for (var o = 0; o < a.length; o += 1) {
                            var r = a[o],
                                s = r.point;
                            r.value <= t.innerWidth && (n = s);
                        }
                        return n || "max";
                    }
                }
            },
            (e, t, n) => {
                "use strict";
                n.r(t), n.d(t, { default: () => i });
                const i = {
                    checkOverflow: function () {
                        var e = this,
                            t = e.params,
                            n = e.isLocked,
                            i = e.slides.length > 0 && t.slidesOffsetBefore + t.spaceBetween * (e.slides.length - 1) + e.slides[0].offsetWidth * e.slides.length;
                        t.slidesOffsetBefore && t.slidesOffsetAfter && i ? (e.isLocked = i <= e.size) : (e.isLocked = 1 === e.snapGrid.length),
                            (e.allowSlideNext = !e.isLocked),
                            (e.allowSlidePrev = !e.isLocked),
                            n !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock"),
                            n && n !== e.isLocked && ((e.isEnd = !1), e.navigation && e.navigation.update());
                    },
                };
            },
            (e, t, n) => {
                "use strict";
                n.r(t), n.d(t, { default: () => o });
                var i = n(61),
                    a = n(62);
                const o = { addClasses: i.default, removeClasses: a.default };
            },
            (e, t, n) => {
                "use strict";
                function i() {
                    var e = this,
                        t = e.classNames,
                        n = e.params,
                        i = e.rtl,
                        a = e.$el,
                        o = e.device,
                        r = [];
                    r.push("initialized"),
                        r.push(n.direction),
                        n.freeMode && r.push("free-mode"),
                        n.autoHeight && r.push("autoheight"),
                        i && r.push("rtl"),
                        n.slidesPerColumn > 1 && (r.push("multirow"), "column" === n.slidesPerColumnFill && r.push("multirow-column")),
                        o.android && r.push("android"),
                        o.ios && r.push("ios"),
                        n.cssMode && r.push("css-mode"),
                        r.forEach(function (e) {
                            t.push(n.containerModifierClass + e);
                        }),
                        a.addClass(t.join(" ")),
                        e.emitContainerClasses();
                }
                n.r(t), n.d(t, { default: () => i });
            },
            (e, t, n) => {
                "use strict";
                function i() {
                    var e = this,
                        t = e.$el,
                        n = e.classNames;
                    t.removeClass(n.join(" ")), e.emitContainerClasses();
                }
                n.r(t), n.d(t, { default: () => i });
            },
            (e, t, n) => {
                "use strict";
                n.r(t), n.d(t, { default: () => o });
                var i = n(64),
                    a = n(65);
                const o = { loadImage: i.default, preloadImages: a.default };
            },
            (e, t, n) => {
                "use strict";
                n.r(t), n.d(t, { default: () => o });
                var i = n(4),
                    a = n(2);
                function o(e, t, n, o, r, s) {
                    var l,
                        c = (0, i.getWindow)();
                    function d() {
                        s && s();
                    }
                    (0, a.default)(e).parent("picture")[0] || (e.complete && r) ? d() : t ? (((l = new c.Image()).onload = d), (l.onerror = d), o && (l.sizes = o), n && (l.srcset = n), t && (l.src = t)) : d();
                }
            },
            (e, t, n) => {
                "use strict";
                function i() {
                    var e = this;
                    function t() {
                        null != e && e && !e.destroyed && (void 0 !== e.imagesLoaded && (e.imagesLoaded += 1), e.imagesLoaded === e.imagesToLoad.length && (e.params.updateOnImagesReady && e.update(), e.emit("imagesReady")));
                    }
                    e.imagesToLoad = e.$el.find("img");
                    for (var n = 0; n < e.imagesToLoad.length; n += 1) {
                        var i = e.imagesToLoad[n];
                        e.loadImage(i, i.currentSrc || i.getAttribute("src"), i.srcset || i.getAttribute("srcset"), i.sizes || i.getAttribute("sizes"), !0, t);
                    }
                }
                n.r(t), n.d(t, { default: () => i });
            },
            (e, t, n) => {
                "use strict";
                n.r(t), n.d(t, { getSupport: () => o });
                var i,
                    a = n(4);
                function o() {
                    return (
                        i ||
                            (i = (function () {
                                var e = (0, a.getWindow)(),
                                    t = (0, a.getDocument)();
                                return {
                                    touch: !!("ontouchstart" in e || (e.DocumentTouch && t instanceof e.DocumentTouch)),
                                    pointerEvents: !!e.PointerEvent && "maxTouchPoints" in e.navigator && e.navigator.maxTouchPoints >= 0,
                                    observer: "MutationObserver" in e || "WebkitMutationObserver" in e,
                                    passiveListener: (function () {
                                        var t = !1;
                                        try {
                                            var n = Object.defineProperty({}, "passive", {
                                                get: function () {
                                                    t = !0;
                                                },
                                            });
                                            e.addEventListener("testPassiveListener", null, n);
                                        } catch (e) {}
                                        return t;
                                    })(),
                                    gestures: "ongesturestart" in e,
                                };
                            })()),
                        i
                    );
                }
            },
            (e, t, n) => {
                "use strict";
                n.r(t), n.d(t, { getDevice: () => r });
                var i,
                    a = n(4),
                    o = n(66);
                function r(e) {
                    return (
                        void 0 === e && (e = {}),
                        i ||
                            (i = (function (e) {
                                var t = (void 0 === e ? {} : e).userAgent,
                                    n = (0, o.getSupport)(),
                                    i = (0, a.getWindow)(),
                                    r = i.navigator.platform,
                                    s = t || i.navigator.userAgent,
                                    l = { ios: !1, android: !1 },
                                    c = i.screen.width,
                                    d = i.screen.height,
                                    u = s.match(/(Android);?[\s\/]+([\d.]+)?/),
                                    p = s.match(/(iPad).*OS\s([\d_]+)/),
                                    f = s.match(/(iPod)(.*OS\s([\d_]+))?/),
                                    h = !p && s.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
                                    g = "Win32" === r,
                                    v = "MacIntel" === r;
                                return (
                                    !p &&
                                        v &&
                                        n.touch &&
                                        ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"].indexOf(c + "x" + d) >= 0 &&
                                        ((p = s.match(/(Version)\/([\d.]+)/)) || (p = [0, 1, "13_0_0"]), (v = !1)),
                                    u && !g && ((l.os = "android"), (l.android = !0)),
                                    (p || h || f) && ((l.os = "ios"), (l.ios = !0)),
                                    l
                                );
                            })(e)),
                        i
                    );
                }
            },
            (e, t, n) => {
                "use strict";
                n.r(t), n.d(t, { getBrowser: () => o });
                var i,
                    a = n(4);
                function o() {
                    return (
                        i ||
                            (i = (function () {
                                var e,
                                    t = (0, a.getWindow)();
                                return {
                                    isEdge: !!t.navigator.userAgent.match(/Edge/g),
                                    isSafari: ((e = t.navigator.userAgent.toLowerCase()), e.indexOf("safari") >= 0 && e.indexOf("chrome") < 0 && e.indexOf("android") < 0),
                                    isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(t.navigator.userAgent),
                                };
                            })()),
                        i
                    );
                }
            },
            (e, t, n) => {
                "use strict";
                n.r(t), n.d(t, { default: () => i });
                const i = {
                    init: !0,
                    direction: "horizontal",
                    touchEventsTarget: "container",
                    initialSlide: 0,
                    speed: 300,
                    cssMode: !1,
                    updateOnWindowResize: !0,
                    nested: !1,
                    width: null,
                    height: null,
                    preventInteractionOnTransition: !1,
                    userAgent: null,
                    url: null,
                    edgeSwipeDetection: !1,
                    edgeSwipeThreshold: 20,
                    freeMode: !1,
                    freeModeMomentum: !0,
                    freeModeMomentumRatio: 1,
                    freeModeMomentumBounce: !0,
                    freeModeMomentumBounceRatio: 1,
                    freeModeMomentumVelocityRatio: 1,
                    freeModeSticky: !1,
                    freeModeMinimumVelocity: 0.02,
                    autoHeight: !1,
                    setWrapperSize: !1,
                    virtualTranslate: !1,
                    effect: "slide",
                    breakpoints: void 0,
                    spaceBetween: 0,
                    slidesPerView: 1,
                    slidesPerColumn: 1,
                    slidesPerColumnFill: "column",
                    slidesPerGroup: 1,
                    slidesPerGroupSkip: 0,
                    centeredSlides: !1,
                    centeredSlidesBounds: !1,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                    normalizeSlideIndex: !0,
                    centerInsufficientSlides: !1,
                    watchOverflow: !1,
                    roundLengths: !1,
                    touchRatio: 1,
                    touchAngle: 45,
                    simulateTouch: !0,
                    shortSwipes: !0,
                    longSwipes: !0,
                    longSwipesRatio: 0.5,
                    longSwipesMs: 300,
                    followFinger: !0,
                    allowTouchMove: !0,
                    threshold: 0,
                    touchMoveStopPropagation: !1,
                    touchStartPreventDefault: !0,
                    touchStartForcePreventDefault: !1,
                    touchReleaseOnEdges: !1,
                    uniqueNavElements: !0,
                    resistance: !0,
                    resistanceRatio: 0.85,
                    watchSlidesProgress: !1,
                    watchSlidesVisibility: !1,
                    grabCursor: !1,
                    preventClicks: !0,
                    preventClicksPropagation: !0,
                    slideToClickedSlide: !1,
                    preloadImages: !0,
                    updateOnImagesReady: !0,
                    loop: !1,
                    loopAdditionalSlides: 0,
                    loopedSlides: null,
                    loopFillGroupWithBlank: !1,
                    loopPreventsSlide: !0,
                    allowSlidePrev: !0,
                    allowSlideNext: !0,
                    swipeHandler: null,
                    noSwiping: !0,
                    noSwipingClass: "swiper-no-swiping",
                    noSwipingSelector: null,
                    passiveListeners: !0,
                    containerModifierClass: "swiper-container-",
                    slideClass: "swiper-slide",
                    slideBlankClass: "swiper-slide-invisible-blank",
                    slideActiveClass: "swiper-slide-active",
                    slideDuplicateActiveClass: "swiper-slide-duplicate-active",
                    slideVisibleClass: "swiper-slide-visible",
                    slideDuplicateClass: "swiper-slide-duplicate",
                    slideNextClass: "swiper-slide-next",
                    slideDuplicateNextClass: "swiper-slide-duplicate-next",
                    slidePrevClass: "swiper-slide-prev",
                    slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
                    wrapperClass: "swiper-wrapper",
                    runCallbacksOnInit: !0,
                    _emitClasses: !1,
                };
            },
            (e, t, n) => {
                "use strict";
                n.r(t), n.d(t, { default: () => o });
                var i = n(4),
                    a = n(6);
                const o = {
                    name: "resize",
                    create: function () {
                        var e = this;
                        (0, a.extend)(e, {
                            resize: {
                                resizeHandler: function () {
                                    e && !e.destroyed && e.initialized && (e.emit("beforeResize"), e.emit("resize"));
                                },
                                orientationChangeHandler: function () {
                                    e && !e.destroyed && e.initialized && e.emit("orientationchange");
                                },
                            },
                        });
                    },
                    on: {
                        init: function (e) {
                            var t = (0, i.getWindow)();
                            t.addEventListener("resize", e.resize.resizeHandler), t.addEventListener("orientationchange", e.resize.orientationChangeHandler);
                        },
                        destroy: function (e) {
                            var t = (0, i.getWindow)();
                            t.removeEventListener("resize", e.resize.resizeHandler), t.removeEventListener("orientationchange", e.resize.orientationChangeHandler);
                        },
                    },
                };
            },
            (e, t, n) => {
                "use strict";
                n.r(t), n.d(t, { default: () => s });
                var i = n(4),
                    a = n(6);
                function o() {
                    return (o =
                        Object.assign ||
                        function (e) {
                            for (var t = 1; t < arguments.length; t++) {
                                var n = arguments[t];
                                for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
                            }
                            return e;
                        }).apply(this, arguments);
                }
                var r = {
                    attach: function (e, t) {
                        void 0 === t && (t = {});
                        var n = (0, i.getWindow)(),
                            a = this,
                            o = new (n.MutationObserver || n.WebkitMutationObserver)(function (e) {
                                if (1 !== e.length) {
                                    var t = function () {
                                        a.emit("observerUpdate", e[0]);
                                    };
                                    n.requestAnimationFrame ? n.requestAnimationFrame(t) : n.setTimeout(t, 0);
                                } else a.emit("observerUpdate", e[0]);
                            });
                        o.observe(e, { attributes: void 0 === t.attributes || t.attributes, childList: void 0 === t.childList || t.childList, characterData: void 0 === t.characterData || t.characterData }), a.observer.observers.push(o);
                    },
                    init: function () {
                        var e = this;
                        if (e.support.observer && e.params.observer) {
                            if (e.params.observeParents) for (var t = e.$el.parents(), n = 0; n < t.length; n += 1) e.observer.attach(t[n]);
                            e.observer.attach(e.$el[0], { childList: e.params.observeSlideChildren }), e.observer.attach(e.$wrapperEl[0], { attributes: !1 });
                        }
                    },
                    destroy: function () {
                        this.observer.observers.forEach(function (e) {
                            e.disconnect();
                        }),
                            (this.observer.observers = []);
                    },
                };
                const s = {
                    name: "observer",
                    params: { observer: !1, observeParents: !1, observeSlideChildren: !1 },
                    create: function () {
                        (0, a.bindModuleMethods)(this, { observer: o(o({}, r), {}, { observers: [] }) });
                    },
                    on: {
                        init: function (e) {
                            e.observer.init();
                        },
                        destroy: function (e) {
                            e.observer.destroy();
                        },
                    },
                };
            },
            (e, t, n) => {
                "use strict";
                n.r(t), n.d(t, { default: () => s });
                var i = n(2),
                    a = n(6);
                function o() {
                    return (o =
                        Object.assign ||
                        function (e) {
                            for (var t = 1; t < arguments.length; t++) {
                                var n = arguments[t];
                                for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
                            }
                            return e;
                        }).apply(this, arguments);
                }
                var r = {
                    update: function () {
                        var e = this,
                            t = e.params.navigation;
                        if (!e.params.loop) {
                            var n = e.navigation,
                                i = n.$nextEl,
                                a = n.$prevEl;
                            a && a.length > 0 && (e.isBeginning ? a.addClass(t.disabledClass) : a.removeClass(t.disabledClass), a[e.params.watchOverflow && e.isLocked ? "addClass" : "removeClass"](t.lockClass)),
                                i && i.length > 0 && (e.isEnd ? i.addClass(t.disabledClass) : i.removeClass(t.disabledClass), i[e.params.watchOverflow && e.isLocked ? "addClass" : "removeClass"](t.lockClass));
                        }
                    },
                    onPrevClick: function (e) {
                        var t = this;
                        e.preventDefault(), (t.isBeginning && !t.params.loop) || t.slidePrev();
                    },
                    onNextClick: function (e) {
                        var t = this;
                        e.preventDefault(), (t.isEnd && !t.params.loop) || t.slideNext();
                    },
                    init: function () {
                        var e,
                            t,
                            n = this,
                            o = n.params.navigation;
                        (o.nextEl || o.prevEl) &&
                            (o.nextEl && ((e = (0, i.default)(o.nextEl)), n.params.uniqueNavElements && "string" == typeof o.nextEl && e.length > 1 && 1 === n.$el.find(o.nextEl).length && (e = n.$el.find(o.nextEl))),
                            o.prevEl && ((t = (0, i.default)(o.prevEl)), n.params.uniqueNavElements && "string" == typeof o.prevEl && t.length > 1 && 1 === n.$el.find(o.prevEl).length && (t = n.$el.find(o.prevEl))),
                            e && e.length > 0 && e.on("click", n.navigation.onNextClick),
                            t && t.length > 0 && t.on("click", n.navigation.onPrevClick),
                            (0, a.extend)(n.navigation, { $nextEl: e, nextEl: e && e[0], $prevEl: t, prevEl: t && t[0] }));
                    },
                    destroy: function () {
                        var e = this,
                            t = e.navigation,
                            n = t.$nextEl,
                            i = t.$prevEl;
                        n && n.length && (n.off("click", e.navigation.onNextClick), n.removeClass(e.params.navigation.disabledClass)),
                            i && i.length && (i.off("click", e.navigation.onPrevClick), i.removeClass(e.params.navigation.disabledClass));
                    },
                };
                const s = {
                    name: "navigation",
                    params: { navigation: { nextEl: null, prevEl: null, hideOnClick: !1, disabledClass: "swiper-button-disabled", hiddenClass: "swiper-button-hidden", lockClass: "swiper-button-lock" } },
                    create: function () {
                        (0, a.bindModuleMethods)(this, { navigation: o({}, r) });
                    },
                    on: {
                        init: function (e) {
                            e.navigation.init(), e.navigation.update();
                        },
                        toEdge: function (e) {
                            e.navigation.update();
                        },
                        fromEdge: function (e) {
                            e.navigation.update();
                        },
                        destroy: function (e) {
                            e.navigation.destroy();
                        },
                        click: function (e, t) {
                            var n,
                                a = e.navigation,
                                o = a.$nextEl,
                                r = a.$prevEl;
                            !e.params.navigation.hideOnClick ||
                                (0, i.default)(t.target).is(r) ||
                                (0, i.default)(t.target).is(o) ||
                                (o ? (n = o.hasClass(e.params.navigation.hiddenClass)) : r && (n = r.hasClass(e.params.navigation.hiddenClass)),
                                !0 === n ? e.emit("navigationShow") : e.emit("navigationHide"),
                                o && o.toggleClass(e.params.navigation.hiddenClass),
                                r && r.toggleClass(e.params.navigation.hiddenClass));
                        },
                    },
                };
            },
            (e, t, n) => {
                "use strict";
                n.r(t), n.d(t, { default: () => s });
                var i = n(2),
                    a = n(6);
                function o() {
                    return (o =
                        Object.assign ||
                        function (e) {
                            for (var t = 1; t < arguments.length; t++) {
                                var n = arguments[t];
                                for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
                            }
                            return e;
                        }).apply(this, arguments);
                }
                var r = {
                    update: function () {
                        var e = this,
                            t = e.rtl,
                            n = e.params.pagination;
                        if (n.el && e.pagination.el && e.pagination.$el && 0 !== e.pagination.$el.length) {
                            var a,
                                o = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length,
                                r = e.pagination.$el,
                                s = e.params.loop ? Math.ceil((o - 2 * e.loopedSlides) / e.params.slidesPerGroup) : e.snapGrid.length;
                            if (
                                (e.params.loop
                                    ? ((a = Math.ceil((e.activeIndex - e.loopedSlides) / e.params.slidesPerGroup)) > o - 1 - 2 * e.loopedSlides && (a -= o - 2 * e.loopedSlides),
                                      a > s - 1 && (a -= s),
                                      a < 0 && "bullets" !== e.params.paginationType && (a = s + a))
                                    : (a = void 0 !== e.snapIndex ? e.snapIndex : e.activeIndex || 0),
                                "bullets" === n.type && e.pagination.bullets && e.pagination.bullets.length > 0)
                            ) {
                                var l,
                                    c,
                                    d,
                                    u = e.pagination.bullets;
                                if (
                                    (n.dynamicBullets &&
                                        ((e.pagination.bulletSize = u.eq(0)[e.isHorizontal() ? "outerWidth" : "outerHeight"](!0)),
                                        r.css(e.isHorizontal() ? "width" : "height", e.pagination.bulletSize * (n.dynamicMainBullets + 4) + "px"),
                                        n.dynamicMainBullets > 1 &&
                                            void 0 !== e.previousIndex &&
                                            ((e.pagination.dynamicBulletIndex += a - e.previousIndex),
                                            e.pagination.dynamicBulletIndex > n.dynamicMainBullets - 1
                                                ? (e.pagination.dynamicBulletIndex = n.dynamicMainBullets - 1)
                                                : e.pagination.dynamicBulletIndex < 0 && (e.pagination.dynamicBulletIndex = 0)),
                                        (l = a - e.pagination.dynamicBulletIndex),
                                        (d = ((c = l + (Math.min(u.length, n.dynamicMainBullets) - 1)) + l) / 2)),
                                    u.removeClass(
                                        n.bulletActiveClass + " " + n.bulletActiveClass + "-next " + n.bulletActiveClass + "-next-next " + n.bulletActiveClass + "-prev " + n.bulletActiveClass + "-prev-prev " + n.bulletActiveClass + "-main"
                                    ),
                                    r.length > 1)
                                )
                                    u.each(function (e) {
                                        var t = (0, i.default)(e),
                                            o = t.index();
                                        o === a && t.addClass(n.bulletActiveClass),
                                            n.dynamicBullets &&
                                                (o >= l && o <= c && t.addClass(n.bulletActiveClass + "-main"),
                                                o === l &&
                                                    t
                                                        .prev()
                                                        .addClass(n.bulletActiveClass + "-prev")
                                                        .prev()
                                                        .addClass(n.bulletActiveClass + "-prev-prev"),
                                                o === c &&
                                                    t
                                                        .next()
                                                        .addClass(n.bulletActiveClass + "-next")
                                                        .next()
                                                        .addClass(n.bulletActiveClass + "-next-next"));
                                    });
                                else {
                                    var p = u.eq(a),
                                        f = p.index();
                                    if ((p.addClass(n.bulletActiveClass), n.dynamicBullets)) {
                                        for (var h = u.eq(l), g = u.eq(c), v = l; v <= c; v += 1) u.eq(v).addClass(n.bulletActiveClass + "-main");
                                        if (e.params.loop)
                                            if (f >= u.length - n.dynamicMainBullets) {
                                                for (var m = n.dynamicMainBullets; m >= 0; m -= 1) u.eq(u.length - m).addClass(n.bulletActiveClass + "-main");
                                                u.eq(u.length - n.dynamicMainBullets - 1).addClass(n.bulletActiveClass + "-prev");
                                            } else
                                                h
                                                    .prev()
                                                    .addClass(n.bulletActiveClass + "-prev")
                                                    .prev()
                                                    .addClass(n.bulletActiveClass + "-prev-prev"),
                                                    g
                                                        .next()
                                                        .addClass(n.bulletActiveClass + "-next")
                                                        .next()
                                                        .addClass(n.bulletActiveClass + "-next-next");
                                        else
                                            h
                                                .prev()
                                                .addClass(n.bulletActiveClass + "-prev")
                                                .prev()
                                                .addClass(n.bulletActiveClass + "-prev-prev"),
                                                g
                                                    .next()
                                                    .addClass(n.bulletActiveClass + "-next")
                                                    .next()
                                                    .addClass(n.bulletActiveClass + "-next-next");
                                    }
                                }
                                if (n.dynamicBullets) {
                                    var b = Math.min(u.length, n.dynamicMainBullets + 4),
                                        w = (e.pagination.bulletSize * b - e.pagination.bulletSize) / 2 - d * e.pagination.bulletSize,
                                        y = t ? "right" : "left";
                                    u.css(e.isHorizontal() ? y : "top", w + "px");
                                }
                            }
                            if (("fraction" === n.type && (r.find("." + n.currentClass).text(n.formatFractionCurrent(a + 1)), r.find("." + n.totalClass).text(n.formatFractionTotal(s))), "progressbar" === n.type)) {
                                var x;
                                x = n.progressbarOpposite ? (e.isHorizontal() ? "vertical" : "horizontal") : e.isHorizontal() ? "horizontal" : "vertical";
                                var C = (a + 1) / s,
                                    T = 1,
                                    S = 1;
                                "horizontal" === x ? (T = C) : (S = C),
                                    r
                                        .find("." + n.progressbarFillClass)
                                        .transform("translate3d(0,0,0) scaleX(" + T + ") scaleY(" + S + ")")
                                        .transition(e.params.speed);
                            }
                            "custom" === n.type && n.renderCustom ? (r.html(n.renderCustom(e, a + 1, s)), e.emit("paginationRender", r[0])) : e.emit("paginationUpdate", r[0]),
                                r[e.params.watchOverflow && e.isLocked ? "addClass" : "removeClass"](n.lockClass);
                        }
                    },
                    render: function () {
                        var e = this,
                            t = e.params.pagination;
                        if (t.el && e.pagination.el && e.pagination.$el && 0 !== e.pagination.$el.length) {
                            var n = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length,
                                i = e.pagination.$el,
                                a = "";
                            if ("bullets" === t.type) {
                                for (var o = e.params.loop ? Math.ceil((n - 2 * e.loopedSlides) / e.params.slidesPerGroup) : e.snapGrid.length, r = 0; r < o; r += 1)
                                    t.renderBullet ? (a += t.renderBullet.call(e, r, t.bulletClass)) : (a += "<" + t.bulletElement + ' class="' + t.bulletClass + '"></' + t.bulletElement + ">");
                                i.html(a), (e.pagination.bullets = i.find("." + t.bulletClass.replace(/ /g, ".")));
                            }
                            "fraction" === t.type && ((a = t.renderFraction ? t.renderFraction.call(e, t.currentClass, t.totalClass) : '<span class="' + t.currentClass + '"></span> / <span class="' + t.totalClass + '"></span>'), i.html(a)),
                                "progressbar" === t.type && ((a = t.renderProgressbar ? t.renderProgressbar.call(e, t.progressbarFillClass) : '<span class="' + t.progressbarFillClass + '"></span>'), i.html(a)),
                                "custom" !== t.type && e.emit("paginationRender", e.pagination.$el[0]);
                        }
                    },
                    init: function () {
                        var e = this,
                            t = e.params.pagination;
                        if (t.el) {
                            var n = (0, i.default)(t.el);
                            0 !== n.length &&
                                (e.params.uniqueNavElements && "string" == typeof t.el && n.length > 1 && (n = e.$el.find(t.el)),
                                "bullets" === t.type && t.clickable && n.addClass(t.clickableClass),
                                n.addClass(t.modifierClass + t.type),
                                "bullets" === t.type && t.dynamicBullets && (n.addClass("" + t.modifierClass + t.type + "-dynamic"), (e.pagination.dynamicBulletIndex = 0), t.dynamicMainBullets < 1 && (t.dynamicMainBullets = 1)),
                                "progressbar" === t.type && t.progressbarOpposite && n.addClass(t.progressbarOppositeClass),
                                t.clickable &&
                                    n.on("click", "." + t.bulletClass.replace(/ /g, "."), function (t) {
                                        t.preventDefault();
                                        var n = (0, i.default)(this).index() * e.params.slidesPerGroup;
                                        e.params.loop && (n += e.loopedSlides), e.slideTo(n);
                                    }),
                                (0, a.extend)(e.pagination, { $el: n, el: n[0] }));
                        }
                    },
                    destroy: function () {
                        var e = this,
                            t = e.params.pagination;
                        if (t.el && e.pagination.el && e.pagination.$el && 0 !== e.pagination.$el.length) {
                            var n = e.pagination.$el;
                            n.removeClass(t.hiddenClass),
                                n.removeClass(t.modifierClass + t.type),
                                e.pagination.bullets && e.pagination.bullets.removeClass(t.bulletActiveClass),
                                t.clickable && n.off("click", "." + t.bulletClass.replace(/ /g, "."));
                        }
                    },
                };
                const s = {
                    name: "pagination",
                    params: {
                        pagination: {
                            el: null,
                            bulletElement: "span",
                            clickable: !1,
                            hideOnClick: !1,
                            renderBullet: null,
                            renderProgressbar: null,
                            renderFraction: null,
                            renderCustom: null,
                            progressbarOpposite: !1,
                            type: "bullets",
                            dynamicBullets: !1,
                            dynamicMainBullets: 1,
                            formatFractionCurrent: function (e) {
                                return e;
                            },
                            formatFractionTotal: function (e) {
                                return e;
                            },
                            bulletClass: "swiper-pagination-bullet",
                            bulletActiveClass: "swiper-pagination-bullet-active",
                            modifierClass: "swiper-pagination-",
                            currentClass: "swiper-pagination-current",
                            totalClass: "swiper-pagination-total",
                            hiddenClass: "swiper-pagination-hidden",
                            progressbarFillClass: "swiper-pagination-progressbar-fill",
                            progressbarOppositeClass: "swiper-pagination-progressbar-opposite",
                            clickableClass: "swiper-pagination-clickable",
                            lockClass: "swiper-pagination-lock",
                        },
                    },
                    create: function () {
                        (0, a.bindModuleMethods)(this, { pagination: o({ dynamicBulletIndex: 0 }, r) });
                    },
                    on: {
                        init: function (e) {
                            e.pagination.init(), e.pagination.render(), e.pagination.update();
                        },
                        activeIndexChange: function (e) {
                            (e.params.loop || void 0 === e.snapIndex) && e.pagination.update();
                        },
                        snapIndexChange: function (e) {
                            e.params.loop || e.pagination.update();
                        },
                        slidesLengthChange: function (e) {
                            e.params.loop && (e.pagination.render(), e.pagination.update());
                        },
                        snapGridLengthChange: function (e) {
                            e.params.loop || (e.pagination.render(), e.pagination.update());
                        },
                        destroy: function (e) {
                            e.pagination.destroy();
                        },
                        click: function (e, t) {
                            e.params.pagination.el &&
                                e.params.pagination.hideOnClick &&
                                e.pagination.$el.length > 0 &&
                                !(0, i.default)(t.target).hasClass(e.params.pagination.bulletClass) &&
                                (!0 === e.pagination.$el.hasClass(e.params.pagination.hiddenClass) ? e.emit("paginationShow") : e.emit("paginationHide"), e.pagination.$el.toggleClass(e.params.pagination.hiddenClass));
                        },
                    },
                };
            },
            (e, t, n) => {
                "use strict";
                n.r(t), n.d(t, { default: () => l });
                var i = n(4),
                    a = n(2),
                    o = n(6);
                function r() {
                    return (r =
                        Object.assign ||
                        function (e) {
                            for (var t = 1; t < arguments.length; t++) {
                                var n = arguments[t];
                                for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
                            }
                            return e;
                        }).apply(this, arguments);
                }
                var s = {
                    setTranslate: function () {
                        var e = this;
                        if (e.params.scrollbar.el && e.scrollbar.el) {
                            var t = e.scrollbar,
                                n = e.rtlTranslate,
                                i = e.progress,
                                a = t.dragSize,
                                o = t.trackSize,
                                r = t.$dragEl,
                                s = t.$el,
                                l = e.params.scrollbar,
                                c = a,
                                d = (o - a) * i;
                            n ? ((d = -d) > 0 ? ((c = a - d), (d = 0)) : -d + a > o && (c = o + d)) : d < 0 ? ((c = a + d), (d = 0)) : d + a > o && (c = o - d),
                                e.isHorizontal() ? (r.transform("translate3d(" + d + "px, 0, 0)"), (r[0].style.width = c + "px")) : (r.transform("translate3d(0px, " + d + "px, 0)"), (r[0].style.height = c + "px")),
                                l.hide &&
                                    (clearTimeout(e.scrollbar.timeout),
                                    (s[0].style.opacity = 1),
                                    (e.scrollbar.timeout = setTimeout(function () {
                                        (s[0].style.opacity = 0), s.transition(400);
                                    }, 1e3)));
                        }
                    },
                    setTransition: function (e) {
                        var t = this;
                        t.params.scrollbar.el && t.scrollbar.el && t.scrollbar.$dragEl.transition(e);
                    },
                    updateSize: function () {
                        var e = this;
                        if (e.params.scrollbar.el && e.scrollbar.el) {
                            var t = e.scrollbar,
                                n = t.$dragEl,
                                i = t.$el;
                            (n[0].style.width = ""), (n[0].style.height = "");
                            var a,
                                r = e.isHorizontal() ? i[0].offsetWidth : i[0].offsetHeight,
                                s = e.size / e.virtualSize,
                                l = s * (r / e.size);
                            (a = "auto" === e.params.scrollbar.dragSize ? r * s : parseInt(e.params.scrollbar.dragSize, 10)),
                                e.isHorizontal() ? (n[0].style.width = a + "px") : (n[0].style.height = a + "px"),
                                (i[0].style.display = s >= 1 ? "none" : ""),
                                e.params.scrollbar.hide && (i[0].style.opacity = 0),
                                (0, o.extend)(t, { trackSize: r, divider: s, moveDivider: l, dragSize: a }),
                                t.$el[e.params.watchOverflow && e.isLocked ? "addClass" : "removeClass"](e.params.scrollbar.lockClass);
                        }
                    },
                    getPointerPosition: function (e) {
                        return this.isHorizontal() ? ("touchstart" === e.type || "touchmove" === e.type ? e.targetTouches[0].clientX : e.clientX) : "touchstart" === e.type || "touchmove" === e.type ? e.targetTouches[0].clientY : e.clientY;
                    },
                    setDragPosition: function (e) {
                        var t,
                            n = this,
                            i = n.scrollbar,
                            a = n.rtlTranslate,
                            o = i.$el,
                            r = i.dragSize,
                            s = i.trackSize,
                            l = i.dragStartPos;
                        (t = (i.getPointerPosition(e) - o.offset()[n.isHorizontal() ? "left" : "top"] - (null !== l ? l : r / 2)) / (s - r)), (t = Math.max(Math.min(t, 1), 0)), a && (t = 1 - t);
                        var c = n.minTranslate() + (n.maxTranslate() - n.minTranslate()) * t;
                        n.updateProgress(c), n.setTranslate(c), n.updateActiveIndex(), n.updateSlidesClasses();
                    },
                    onDragStart: function (e) {
                        var t = this,
                            n = t.params.scrollbar,
                            i = t.scrollbar,
                            a = t.$wrapperEl,
                            o = i.$el,
                            r = i.$dragEl;
                        (t.scrollbar.isTouched = !0),
                            (t.scrollbar.dragStartPos = e.target === r[0] || e.target === r ? i.getPointerPosition(e) - e.target.getBoundingClientRect()[t.isHorizontal() ? "left" : "top"] : null),
                            e.preventDefault(),
                            e.stopPropagation(),
                            a.transition(100),
                            r.transition(100),
                            i.setDragPosition(e),
                            clearTimeout(t.scrollbar.dragTimeout),
                            o.transition(0),
                            n.hide && o.css("opacity", 1),
                            t.params.cssMode && t.$wrapperEl.css("scroll-snap-type", "none"),
                            t.emit("scrollbarDragStart", e);
                    },
                    onDragMove: function (e) {
                        var t = this,
                            n = t.scrollbar,
                            i = t.$wrapperEl,
                            a = n.$el,
                            o = n.$dragEl;
                        t.scrollbar.isTouched && (e.preventDefault ? e.preventDefault() : (e.returnValue = !1), n.setDragPosition(e), i.transition(0), a.transition(0), o.transition(0), t.emit("scrollbarDragMove", e));
                    },
                    onDragEnd: function (e) {
                        var t = this,
                            n = t.params.scrollbar,
                            i = t.scrollbar,
                            a = t.$wrapperEl,
                            r = i.$el;
                        t.scrollbar.isTouched &&
                            ((t.scrollbar.isTouched = !1),
                            t.params.cssMode && (t.$wrapperEl.css("scroll-snap-type", ""), a.transition("")),
                            n.hide &&
                                (clearTimeout(t.scrollbar.dragTimeout),
                                (t.scrollbar.dragTimeout = (0, o.nextTick)(function () {
                                    r.css("opacity", 0), r.transition(400);
                                }, 1e3))),
                            t.emit("scrollbarDragEnd", e),
                            n.snapOnRelease && t.slideToClosest());
                    },
                    enableDraggable: function () {
                        var e = this;
                        if (e.params.scrollbar.el) {
                            var t = (0, i.getDocument)(),
                                n = e.scrollbar,
                                a = e.touchEventsTouch,
                                o = e.touchEventsDesktop,
                                r = e.params,
                                s = e.support,
                                l = n.$el[0],
                                c = !(!s.passiveListener || !r.passiveListeners) && { passive: !1, capture: !1 },
                                d = !(!s.passiveListener || !r.passiveListeners) && { passive: !0, capture: !1 };
                            s.touch
                                ? (l.addEventListener(a.start, e.scrollbar.onDragStart, c), l.addEventListener(a.move, e.scrollbar.onDragMove, c), l.addEventListener(a.end, e.scrollbar.onDragEnd, d))
                                : (l.addEventListener(o.start, e.scrollbar.onDragStart, c), t.addEventListener(o.move, e.scrollbar.onDragMove, c), t.addEventListener(o.end, e.scrollbar.onDragEnd, d));
                        }
                    },
                    disableDraggable: function () {
                        var e = this;
                        if (e.params.scrollbar.el) {
                            var t = (0, i.getDocument)(),
                                n = e.scrollbar,
                                a = e.touchEventsTouch,
                                o = e.touchEventsDesktop,
                                r = e.params,
                                s = e.support,
                                l = n.$el[0],
                                c = !(!s.passiveListener || !r.passiveListeners) && { passive: !1, capture: !1 },
                                d = !(!s.passiveListener || !r.passiveListeners) && { passive: !0, capture: !1 };
                            s.touch
                                ? (l.removeEventListener(a.start, e.scrollbar.onDragStart, c), l.removeEventListener(a.move, e.scrollbar.onDragMove, c), l.removeEventListener(a.end, e.scrollbar.onDragEnd, d))
                                : (l.removeEventListener(o.start, e.scrollbar.onDragStart, c), t.removeEventListener(o.move, e.scrollbar.onDragMove, c), t.removeEventListener(o.end, e.scrollbar.onDragEnd, d));
                        }
                    },
                    init: function () {
                        var e = this;
                        if (e.params.scrollbar.el) {
                            var t = e.scrollbar,
                                n = e.$el,
                                i = e.params.scrollbar,
                                r = (0, a.default)(i.el);
                            e.params.uniqueNavElements && "string" == typeof i.el && r.length > 1 && 1 === n.find(i.el).length && (r = n.find(i.el));
                            var s = r.find("." + e.params.scrollbar.dragClass);
                            0 === s.length && ((s = (0, a.default)('<div class="' + e.params.scrollbar.dragClass + '"></div>')), r.append(s)),
                                (0, o.extend)(t, { $el: r, el: r[0], $dragEl: s, dragEl: s[0] }),
                                i.draggable && t.enableDraggable();
                        }
                    },
                    destroy: function () {
                        this.scrollbar.disableDraggable();
                    },
                };
                const l = {
                    name: "scrollbar",
                    params: { scrollbar: { el: null, dragSize: "auto", hide: !1, draggable: !1, snapOnRelease: !0, lockClass: "swiper-scrollbar-lock", dragClass: "swiper-scrollbar-drag" } },
                    create: function () {
                        (0, o.bindModuleMethods)(this, { scrollbar: r({ isTouched: !1, timeout: null, dragTimeout: null }, s) });
                    },
                    on: {
                        init: function (e) {
                            e.scrollbar.init(), e.scrollbar.updateSize(), e.scrollbar.setTranslate();
                        },
                        update: function (e) {
                            e.scrollbar.updateSize();
                        },
                        resize: function (e) {
                            e.scrollbar.updateSize();
                        },
                        observerUpdate: function (e) {
                            e.scrollbar.updateSize();
                        },
                        setTranslate: function (e) {
                            e.scrollbar.setTranslate();
                        },
                        setTransition: function (e, t) {
                            e.scrollbar.setTransition(t);
                        },
                        destroy: function (e) {
                            e.scrollbar.destroy();
                        },
                    },
                };
            },
            (e, t, n) => {
                "use strict";
                n.r(t), n.d(t, { default: () => s });
                var i = n(4),
                    a = n(6);
                function o() {
                    return (o =
                        Object.assign ||
                        function (e) {
                            for (var t = 1; t < arguments.length; t++) {
                                var n = arguments[t];
                                for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
                            }
                            return e;
                        }).apply(this, arguments);
                }
                var r = {
                    run: function () {
                        var e = this,
                            t = e.slides.eq(e.activeIndex),
                            n = e.params.autoplay.delay;
                        t.attr("data-swiper-autoplay") && (n = t.attr("data-swiper-autoplay") || e.params.autoplay.delay),
                            clearTimeout(e.autoplay.timeout),
                            (e.autoplay.timeout = (0, a.nextTick)(function () {
                                var t;
                                e.params.autoplay.reverseDirection
                                    ? e.params.loop
                                        ? (e.loopFix(), (t = e.slidePrev(e.params.speed, !0, !0)), e.emit("autoplay"))
                                        : e.isBeginning
                                        ? e.params.autoplay.stopOnLastSlide
                                            ? e.autoplay.stop()
                                            : ((t = e.slideTo(e.slides.length - 1, e.params.speed, !0, !0)), e.emit("autoplay"))
                                        : ((t = e.slidePrev(e.params.speed, !0, !0)), e.emit("autoplay"))
                                    : e.params.loop
                                    ? (e.loopFix(), (t = e.slideNext(e.params.speed, !0, !0)), e.emit("autoplay"))
                                    : e.isEnd
                                    ? e.params.autoplay.stopOnLastSlide
                                        ? e.autoplay.stop()
                                        : ((t = e.slideTo(0, e.params.speed, !0, !0)), e.emit("autoplay"))
                                    : ((t = e.slideNext(e.params.speed, !0, !0)), e.emit("autoplay")),
                                    ((e.params.cssMode && e.autoplay.running) || !1 === t) && e.autoplay.run();
                            }, n));
                    },
                    start: function () {
                        var e = this;
                        return void 0 === e.autoplay.timeout && !e.autoplay.running && ((e.autoplay.running = !0), e.emit("autoplayStart"), e.autoplay.run(), !0);
                    },
                    stop: function () {
                        var e = this;
                        return !!e.autoplay.running && void 0 !== e.autoplay.timeout && (e.autoplay.timeout && (clearTimeout(e.autoplay.timeout), (e.autoplay.timeout = void 0)), (e.autoplay.running = !1), e.emit("autoplayStop"), !0);
                    },
                    pause: function (e) {
                        var t = this;
                        t.autoplay.running &&
                            (t.autoplay.paused ||
                                (t.autoplay.timeout && clearTimeout(t.autoplay.timeout),
                                (t.autoplay.paused = !0),
                                0 !== e && t.params.autoplay.waitForTransition
                                    ? (t.$wrapperEl[0].addEventListener("transitionend", t.autoplay.onTransitionEnd), t.$wrapperEl[0].addEventListener("webkitTransitionEnd", t.autoplay.onTransitionEnd))
                                    : ((t.autoplay.paused = !1), t.autoplay.run())));
                    },
                    onVisibilityChange: function () {
                        var e = this,
                            t = (0, i.getDocument)();
                        "hidden" === t.visibilityState && e.autoplay.running && e.autoplay.pause(), "visible" === t.visibilityState && e.autoplay.paused && (e.autoplay.run(), (e.autoplay.paused = !1));
                    },
                    onTransitionEnd: function (e) {
                        var t = this;
                        t &&
                            !t.destroyed &&
                            t.$wrapperEl &&
                            e.target === t.$wrapperEl[0] &&
                            (t.$wrapperEl[0].removeEventListener("transitionend", t.autoplay.onTransitionEnd),
                            t.$wrapperEl[0].removeEventListener("webkitTransitionEnd", t.autoplay.onTransitionEnd),
                            (t.autoplay.paused = !1),
                            t.autoplay.running ? t.autoplay.run() : t.autoplay.stop());
                    },
                };
                const s = {
                    name: "autoplay",
                    params: { autoplay: { enabled: !1, delay: 3e3, waitForTransition: !0, disableOnInteraction: !0, stopOnLastSlide: !1, reverseDirection: !1 } },
                    create: function () {
                        (0, a.bindModuleMethods)(this, { autoplay: o(o({}, r), {}, { running: !1, paused: !1 }) });
                    },
                    on: {
                        init: function (e) {
                            e.params.autoplay.enabled && (e.autoplay.start(), (0, i.getDocument)().addEventListener("visibilitychange", e.autoplay.onVisibilityChange));
                        },
                        beforeTransitionStart: function (e, t, n) {
                            e.autoplay.running && (n || !e.params.autoplay.disableOnInteraction ? e.autoplay.pause(t) : e.autoplay.stop());
                        },
                        sliderFirstMove: function (e) {
                            e.autoplay.running && (e.params.autoplay.disableOnInteraction ? e.autoplay.stop() : e.autoplay.pause());
                        },
                        touchEnd: function (e) {
                            e.params.cssMode && e.autoplay.paused && !e.params.autoplay.disableOnInteraction && e.autoplay.run();
                        },
                        destroy: function (e) {
                            e.autoplay.running && e.autoplay.stop(), (0, i.getDocument)().removeEventListener("visibilitychange", e.autoplay.onVisibilityChange);
                        },
                    },
                };
            },
            (e, t, n) => {
                "use strict";
                n.r(t), n.d(t, { default: () => s });
                var i = n(77),
                    a = n.n(i),
                    o = n(78),
                    r = { insert: "head", singleton: !1 };
                a()(o.default, r);
                const s = o.default.locals || {};
            },
            (e, t, n) => {
                "use strict";
                var i,
                    a = function () {
                        return void 0 === i && (i = Boolean(window && document && document.all && !window.atob)), i;
                    },
                    o = (function () {
                        var e = {};
                        return function (t) {
                            if (void 0 === e[t]) {
                                var n = document.querySelector(t);
                                if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement)
                                    try {
                                        n = n.contentDocument.head;
                                    } catch (e) {
                                        n = null;
                                    }
                                e[t] = n;
                            }
                            return e[t];
                        };
                    })(),
                    r = [];
                function s(e) {
                    for (var t = -1, n = 0; n < r.length; n++)
                        if (r[n].identifier === e) {
                            t = n;
                            break;
                        }
                    return t;
                }
                function l(e, t) {
                    for (var n = {}, i = [], a = 0; a < e.length; a++) {
                        var o = e[a],
                            l = t.base ? o[0] + t.base : o[0],
                            c = n[l] || 0,
                            d = "".concat(l, " ").concat(c);
                        n[l] = c + 1;
                        var u = s(d),
                            p = { css: o[1], media: o[2], sourceMap: o[3] };
                        -1 !== u ? (r[u].references++, r[u].updater(p)) : r.push({ identifier: d, updater: v(p, t), references: 1 }), i.push(d);
                    }
                    return i;
                }
                function c(e) {
                    var t = document.createElement("style"),
                        i = e.attributes || {};
                    if (void 0 === i.nonce) {
                        var a = n.nc;
                        a && (i.nonce = a);
                    }
                    if (
                        (Object.keys(i).forEach(function (e) {
                            t.setAttribute(e, i[e]);
                        }),
                        "function" == typeof e.insert)
                    )
                        e.insert(t);
                    else {
                        var r = o(e.insert || "head");
                        if (!r) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
                        r.appendChild(t);
                    }
                    return t;
                }
                var d,
                    u =
                        ((d = []),
                        function (e, t) {
                            return (d[e] = t), d.filter(Boolean).join("\n");
                        });
                function p(e, t, n, i) {
                    var a = n ? "" : i.media ? "@media ".concat(i.media, " {").concat(i.css, "}") : i.css;
                    if (e.styleSheet) e.styleSheet.cssText = u(t, a);
                    else {
                        var o = document.createTextNode(a),
                            r = e.childNodes;
                        r[t] && e.removeChild(r[t]), r.length ? e.insertBefore(o, r[t]) : e.appendChild(o);
                    }
                }
                function f(e, t, n) {
                    var i = n.css,
                        a = n.media,
                        o = n.sourceMap;
                    if (
                        (a ? e.setAttribute("media", a) : e.removeAttribute("media"),
                        o && "undefined" != typeof btoa && (i += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(o)))), " */")),
                        e.styleSheet)
                    )
                        e.styleSheet.cssText = i;
                    else {
                        for (; e.firstChild; ) e.removeChild(e.firstChild);
                        e.appendChild(document.createTextNode(i));
                    }
                }
                var h = null,
                    g = 0;
                function v(e, t) {
                    var n, i, a;
                    if (t.singleton) {
                        var o = g++;
                        (n = h || (h = c(t))), (i = p.bind(null, n, o, !1)), (a = p.bind(null, n, o, !0));
                    } else
                        (n = c(t)),
                            (i = f.bind(null, n, t)),
                            (a = function () {
                                !(function (e) {
                                    if (null === e.parentNode) return !1;
                                    e.parentNode.removeChild(e);
                                })(n);
                            });
                    return (
                        i(e),
                        function (t) {
                            if (t) {
                                if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
                                i((e = t));
                            } else a();
                        }
                    );
                }
                e.exports = function (e, t) {
                    (t = t || {}).singleton || "boolean" == typeof t.singleton || (t.singleton = a());
                    var n = l((e = e || []), t);
                    return function (e) {
                        if (((e = e || []), "[object Array]" === Object.prototype.toString.call(e))) {
                            for (var i = 0; i < n.length; i++) {
                                var a = s(n[i]);
                                r[a].references--;
                            }
                            for (var o = l(e, t), c = 0; c < n.length; c++) {
                                var d = s(n[c]);
                                0 === r[d].references && (r[d].updater(), r.splice(d, 1));
                            }
                            n = o;
                        }
                    };
                };
            },
            (e, t, n) => {
                "use strict";
                n.r(t), n.d(t, { default: () => o });
                var i = n(79),
                    a = n.n(i)()(function (e) {
                        return e[1];
                    });
                a.push([
                    e.id,
                    "/**\n * Swiper 6.4.1\n * Most modern mobile touch slider and framework with hardware accelerated transitions\n * https://swiperjs.com\n *\n * Copyright 2014-2020 Vladimir Kharlampidi\n *\n * Released under the MIT License\n *\n * Released on: December 9, 2020\n */\n\n@font-face {\n  font-family: 'swiper-icons';\n  src: url('data:application/font-woff;charset=utf-8;base64, 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') format('woff');\n  font-weight: 400;\n  font-style: normal;\n}\n:root {\n  --swiper-theme-color: #007aff;\n}\n.swiper-container {\n  margin-left: auto;\n  margin-right: auto;\n  position: relative;\n  overflow: hidden;\n  list-style: none;\n  padding: 0;\n  /* Fix of Webkit flickering */\n  z-index: 1;\n}\n.swiper-container-vertical > .swiper-wrapper {\n  flex-direction: column;\n}\n.swiper-wrapper {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  display: flex;\n  transition-property: transform;\n  box-sizing: content-box;\n}\n.swiper-container-android .swiper-slide,\n.swiper-wrapper {\n  transform: translate3d(0px, 0, 0);\n}\n.swiper-container-multirow > .swiper-wrapper {\n  flex-wrap: wrap;\n}\n.swiper-container-multirow-column > .swiper-wrapper {\n  flex-wrap: wrap;\n  flex-direction: column;\n}\n.swiper-container-free-mode > .swiper-wrapper {\n  transition-timing-function: ease-out;\n  margin: 0 auto;\n}\n.swiper-slide {\n  flex-shrink: 0;\n  width: 100%;\n  height: 100%;\n  position: relative;\n  transition-property: transform;\n}\n.swiper-slide-invisible-blank {\n  visibility: hidden;\n}\n/* Auto Height */\n.swiper-container-autoheight,\n.swiper-container-autoheight .swiper-slide {\n  height: auto;\n}\n.swiper-container-autoheight .swiper-wrapper {\n  align-items: flex-start;\n  transition-property: transform, height;\n}\n/* 3D Effects */\n.swiper-container-3d {\n  perspective: 1200px;\n}\n.swiper-container-3d .swiper-wrapper,\n.swiper-container-3d .swiper-slide,\n.swiper-container-3d .swiper-slide-shadow-left,\n.swiper-container-3d .swiper-slide-shadow-right,\n.swiper-container-3d .swiper-slide-shadow-top,\n.swiper-container-3d .swiper-slide-shadow-bottom,\n.swiper-container-3d .swiper-cube-shadow {\n  transform-style: preserve-3d;\n}\n.swiper-container-3d .swiper-slide-shadow-left,\n.swiper-container-3d .swiper-slide-shadow-right,\n.swiper-container-3d .swiper-slide-shadow-top,\n.swiper-container-3d .swiper-slide-shadow-bottom {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  z-index: 10;\n}\n.swiper-container-3d .swiper-slide-shadow-left {\n  background-image: linear-gradient(to left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n}\n.swiper-container-3d .swiper-slide-shadow-right {\n  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n}\n.swiper-container-3d .swiper-slide-shadow-top {\n  background-image: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n}\n.swiper-container-3d .swiper-slide-shadow-bottom {\n  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n}\n/* CSS Mode */\n.swiper-container-css-mode > .swiper-wrapper {\n  overflow: auto;\n  scrollbar-width: none;\n  /* For Firefox */\n  -ms-overflow-style: none;\n  /* For Internet Explorer and Edge */\n}\n.swiper-container-css-mode > .swiper-wrapper::-webkit-scrollbar {\n  display: none;\n}\n.swiper-container-css-mode > .swiper-wrapper > .swiper-slide {\n  scroll-snap-align: start start;\n}\n.swiper-container-horizontal.swiper-container-css-mode > .swiper-wrapper {\n  scroll-snap-type: x mandatory;\n}\n.swiper-container-vertical.swiper-container-css-mode > .swiper-wrapper {\n  scroll-snap-type: y mandatory;\n}\n:root {\n  --swiper-navigation-size: 44px;\n  /*\n  --swiper-navigation-color: var(--swiper-theme-color);\n  */\n}\n.swiper-button-prev,\n.swiper-button-next {\n  position: absolute;\n  top: 50%;\n  width: calc(var(--swiper-navigation-size) / 44 * 27);\n  height: var(--swiper-navigation-size);\n  margin-top: calc(-1 * var(--swiper-navigation-size) / 2);\n  z-index: 10;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--swiper-navigation-color, var(--swiper-theme-color));\n}\n.swiper-button-prev.swiper-button-disabled,\n.swiper-button-next.swiper-button-disabled {\n  opacity: 0.35;\n  cursor: auto;\n  pointer-events: none;\n}\n.swiper-button-prev:after,\n.swiper-button-next:after {\n  font-family: swiper-icons;\n  font-size: var(--swiper-navigation-size);\n  text-transform: none !important;\n  letter-spacing: 0;\n  text-transform: none;\n  font-variant: initial;\n  line-height: 1;\n}\n.swiper-button-prev,\n.swiper-container-rtl .swiper-button-next {\n  left: 10px;\n  right: auto;\n}\n.swiper-button-prev:after,\n.swiper-container-rtl .swiper-button-next:after {\n  content: 'prev';\n}\n.swiper-button-next,\n.swiper-container-rtl .swiper-button-prev {\n  right: 10px;\n  left: auto;\n}\n.swiper-button-next:after,\n.swiper-container-rtl .swiper-button-prev:after {\n  content: 'next';\n}\n.swiper-button-prev.swiper-button-white,\n.swiper-button-next.swiper-button-white {\n  --swiper-navigation-color: #ffffff;\n}\n.swiper-button-prev.swiper-button-black,\n.swiper-button-next.swiper-button-black {\n  --swiper-navigation-color: #000000;\n}\n.swiper-button-lock {\n  display: none;\n}\n:root {\n  /*\n  --swiper-pagination-color: var(--swiper-theme-color);\n  */\n}\n.swiper-pagination {\n  position: absolute;\n  text-align: center;\n  transition: 300ms opacity;\n  transform: translate3d(0, 0, 0);\n  z-index: 10;\n}\n.swiper-pagination.swiper-pagination-hidden {\n  opacity: 0;\n}\n/* Common Styles */\n.swiper-pagination-fraction,\n.swiper-pagination-custom,\n.swiper-container-horizontal > .swiper-pagination-bullets {\n  bottom: 10px;\n  left: 0;\n  width: 100%;\n}\n/* Bullets */\n.swiper-pagination-bullets-dynamic {\n  overflow: hidden;\n  font-size: 0;\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n  transform: scale(0.33);\n  position: relative;\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active {\n  transform: scale(1);\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main {\n  transform: scale(1);\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev {\n  transform: scale(0.66);\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev {\n  transform: scale(0.33);\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next {\n  transform: scale(0.66);\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next {\n  transform: scale(0.33);\n}\n.swiper-pagination-bullet {\n  width: 8px;\n  height: 8px;\n  display: inline-block;\n  border-radius: 100%;\n  background: #000;\n  opacity: 0.2;\n}\nbutton.swiper-pagination-bullet {\n  border: none;\n  margin: 0;\n  padding: 0;\n  box-shadow: none;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n}\n.swiper-pagination-clickable .swiper-pagination-bullet {\n  cursor: pointer;\n}\n.swiper-pagination-bullet-active {\n  opacity: 1;\n  background: var(--swiper-pagination-color, var(--swiper-theme-color));\n}\n.swiper-container-vertical > .swiper-pagination-bullets {\n  right: 10px;\n  top: 50%;\n  transform: translate3d(0px, -50%, 0);\n}\n.swiper-container-vertical > .swiper-pagination-bullets .swiper-pagination-bullet {\n  margin: 6px 0;\n  display: block;\n}\n.swiper-container-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic {\n  top: 50%;\n  transform: translateY(-50%);\n  width: 8px;\n}\n.swiper-container-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n  display: inline-block;\n  transition: 200ms transform, 200ms top;\n}\n.swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet {\n  margin: 0 4px;\n}\n.swiper-container-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic {\n  left: 50%;\n  transform: translateX(-50%);\n  white-space: nowrap;\n}\n.swiper-container-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n  transition: 200ms transform, 200ms left;\n}\n.swiper-container-horizontal.swiper-container-rtl > .swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n  transition: 200ms transform, 200ms right;\n}\n/* Progress */\n.swiper-pagination-progressbar {\n  background: rgba(0, 0, 0, 0.25);\n  position: absolute;\n}\n.swiper-pagination-progressbar .swiper-pagination-progressbar-fill {\n  background: var(--swiper-pagination-color, var(--swiper-theme-color));\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  transform: scale(0);\n  transform-origin: left top;\n}\n.swiper-container-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {\n  transform-origin: right top;\n}\n.swiper-container-horizontal > .swiper-pagination-progressbar,\n.swiper-container-vertical > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite {\n  width: 100%;\n  height: 4px;\n  left: 0;\n  top: 0;\n}\n.swiper-container-vertical > .swiper-pagination-progressbar,\n.swiper-container-horizontal > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite {\n  width: 4px;\n  height: 100%;\n  left: 0;\n  top: 0;\n}\n.swiper-pagination-white {\n  --swiper-pagination-color: #ffffff;\n}\n.swiper-pagination-black {\n  --swiper-pagination-color: #000000;\n}\n.swiper-pagination-lock {\n  display: none;\n}\n/* Scrollbar */\n.swiper-scrollbar {\n  border-radius: 10px;\n  position: relative;\n  -ms-touch-action: none;\n  background: rgba(0, 0, 0, 0.1);\n}\n.swiper-container-horizontal > .swiper-scrollbar {\n  position: absolute;\n  left: 1%;\n  bottom: 3px;\n  z-index: 50;\n  height: 5px;\n  width: 98%;\n}\n.swiper-container-vertical > .swiper-scrollbar {\n  position: absolute;\n  right: 3px;\n  top: 1%;\n  z-index: 50;\n  width: 5px;\n  height: 98%;\n}\n.swiper-scrollbar-drag {\n  height: 100%;\n  width: 100%;\n  position: relative;\n  background: rgba(0, 0, 0, 0.5);\n  border-radius: 10px;\n  left: 0;\n  top: 0;\n}\n.swiper-scrollbar-cursor-drag {\n  cursor: move;\n}\n.swiper-scrollbar-lock {\n  display: none;\n}\n.swiper-zoom-container {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n}\n.swiper-zoom-container > img,\n.swiper-zoom-container > svg,\n.swiper-zoom-container > canvas {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n}\n.swiper-slide-zoomed {\n  cursor: move;\n}\n/* Preloader */\n:root {\n  /*\n  --swiper-preloader-color: var(--swiper-theme-color);\n  */\n}\n.swiper-lazy-preloader {\n  width: 42px;\n  height: 42px;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  margin-left: -21px;\n  margin-top: -21px;\n  z-index: 10;\n  transform-origin: 50%;\n  animation: swiper-preloader-spin 1s infinite linear;\n  box-sizing: border-box;\n  border: 4px solid var(--swiper-preloader-color, var(--swiper-theme-color));\n  border-radius: 50%;\n  border-top-color: transparent;\n}\n.swiper-lazy-preloader-white {\n  --swiper-preloader-color: #fff;\n}\n.swiper-lazy-preloader-black {\n  --swiper-preloader-color: #000;\n}\n@keyframes swiper-preloader-spin {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n/* a11y */\n.swiper-container .swiper-notification {\n  position: absolute;\n  left: 0;\n  top: 0;\n  pointer-events: none;\n  opacity: 0;\n  z-index: -1000;\n}\n.swiper-container-fade.swiper-container-free-mode .swiper-slide {\n  transition-timing-function: ease-out;\n}\n.swiper-container-fade .swiper-slide {\n  pointer-events: none;\n  transition-property: opacity;\n}\n.swiper-container-fade .swiper-slide .swiper-slide {\n  pointer-events: none;\n}\n.swiper-container-fade .swiper-slide-active,\n.swiper-container-fade .swiper-slide-active .swiper-slide-active {\n  pointer-events: auto;\n}\n.swiper-container-cube {\n  overflow: visible;\n}\n.swiper-container-cube .swiper-slide {\n  pointer-events: none;\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n  z-index: 1;\n  visibility: hidden;\n  transform-origin: 0 0;\n  width: 100%;\n  height: 100%;\n}\n.swiper-container-cube .swiper-slide .swiper-slide {\n  pointer-events: none;\n}\n.swiper-container-cube.swiper-container-rtl .swiper-slide {\n  transform-origin: 100% 0;\n}\n.swiper-container-cube .swiper-slide-active,\n.swiper-container-cube .swiper-slide-active .swiper-slide-active {\n  pointer-events: auto;\n}\n.swiper-container-cube .swiper-slide-active,\n.swiper-container-cube .swiper-slide-next,\n.swiper-container-cube .swiper-slide-prev,\n.swiper-container-cube .swiper-slide-next + .swiper-slide {\n  pointer-events: auto;\n  visibility: visible;\n}\n.swiper-container-cube .swiper-slide-shadow-top,\n.swiper-container-cube .swiper-slide-shadow-bottom,\n.swiper-container-cube .swiper-slide-shadow-left,\n.swiper-container-cube .swiper-slide-shadow-right {\n  z-index: 0;\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n}\n.swiper-container-cube .swiper-cube-shadow {\n  position: absolute;\n  left: 0;\n  bottom: 0px;\n  width: 100%;\n  height: 100%;\n  background: #000;\n  opacity: 0.6;\n  -webkit-filter: blur(50px);\n  filter: blur(50px);\n  z-index: 0;\n}\n.swiper-container-flip {\n  overflow: visible;\n}\n.swiper-container-flip .swiper-slide {\n  pointer-events: none;\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n  z-index: 1;\n}\n.swiper-container-flip .swiper-slide .swiper-slide {\n  pointer-events: none;\n}\n.swiper-container-flip .swiper-slide-active,\n.swiper-container-flip .swiper-slide-active .swiper-slide-active {\n  pointer-events: auto;\n}\n.swiper-container-flip .swiper-slide-shadow-top,\n.swiper-container-flip .swiper-slide-shadow-bottom,\n.swiper-container-flip .swiper-slide-shadow-left,\n.swiper-container-flip .swiper-slide-shadow-right {\n  z-index: 0;\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n}\n",
                    "",
                ]);
                const o = a;
            },
            (e) => {
                "use strict";
                e.exports = function (e) {
                    var t = [];
                    return (
                        (t.toString = function () {
                            return this.map(function (t) {
                                var n = e(t);
                                return t[2] ? "@media ".concat(t[2], " {").concat(n, "}") : n;
                            }).join("");
                        }),
                        (t.i = function (e, n, i) {
                            "string" == typeof e && (e = [[null, e, ""]]);
                            var a = {};
                            if (i)
                                for (var o = 0; o < this.length; o++) {
                                    var r = this[o][0];
                                    null != r && (a[r] = !0);
                                }
                            for (var s = 0; s < e.length; s++) {
                                var l = [].concat(e[s]);
                                (i && a[l[0]]) || (n && (l[2] ? (l[2] = "".concat(n, " and ").concat(l[2])) : (l[2] = n)), t.push(l));
                            }
                        }),
                        t
                    );
                };
            },
            (e, t, n) => {
                "use strict";
                function i(e, t) {
                    for (var n = 0; n < t.length; n++) {
                        var i = t[n];
                        (i.enumerable = i.enumerable || !1), (i.configurable = !0), "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
                    }
                }
                function a(e) {
                    return (
                        (function (e) {
                            if (Array.isArray(e)) return o(e);
                        })(e) ||
                        (function (e) {
                            if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
                        })(e) ||
                        (function (e, t) {
                            if (!e) return;
                            if ("string" == typeof e) return o(e, t);
                            var n = Object.prototype.toString.call(e).slice(8, -1);
                            "Object" === n && e.constructor && (n = e.constructor.name);
                            if ("Map" === n || "Set" === n) return Array.from(n);
                            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return o(e, t);
                        })(e) ||
                        (function () {
                            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                        })()
                    );
                }
                function o(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for (var n = 0, i = new Array(t); n < t; n++) i[n] = e[n];
                    return i;
                }
                n.r(t), n.d(t, { default: () => p });
                var r,
                    s,
                    l,
                    c,
                    d,
                    u =
                        ((r = [
                            "a[href]",
                            "area[href]",
                            'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
                            "select:not([disabled]):not([aria-hidden])",
                            "textarea:not([disabled]):not([aria-hidden])",
                            "button:not([disabled]):not([aria-hidden])",
                            "iframe",
                            "object",
                            "embed",
                            "[contenteditable]",
                            '[tabindex]:not([tabindex^="-"])',
                        ]),
                        (s = (function () {
                            function e(t) {
                                var n = t.targetModal,
                                    i = t.triggers,
                                    o = void 0 === i ? [] : i,
                                    r = t.onShow,
                                    s = void 0 === r ? function () {} : r,
                                    l = t.onClose,
                                    c = void 0 === l ? function () {} : l,
                                    d = t.openTrigger,
                                    u = void 0 === d ? "data-micromodal-trigger" : d,
                                    p = t.closeTrigger,
                                    f = void 0 === p ? "data-micromodal-close" : p,
                                    h = t.openClass,
                                    g = void 0 === h ? "is-open" : h,
                                    v = t.disableScroll,
                                    m = void 0 !== v && v,
                                    b = t.disableFocus,
                                    w = void 0 !== b && b,
                                    y = t.awaitCloseAnimation,
                                    x = void 0 !== y && y,
                                    C = t.awaitOpenAnimation,
                                    T = void 0 !== C && C,
                                    S = t.debugMode,
                                    A = void 0 !== S && S;
                                !(function (e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                })(this, e),
                                    (this.modal = document.getElementById(n)),
                                    (this.config = { debugMode: A, disableScroll: m, openTrigger: u, closeTrigger: f, openClass: g, onShow: s, onClose: c, awaitCloseAnimation: x, awaitOpenAnimation: T, disableFocus: w }),
                                    o.length > 0 && this.registerTriggers.apply(this, a(o)),
                                    (this.onClick = this.onClick.bind(this)),
                                    (this.onKeydown = this.onKeydown.bind(this));
                            }
                            var t, n, o;
                            return (
                                (t = e),
                                (n = [
                                    {
                                        key: "registerTriggers",
                                        value: function () {
                                            for (var e = this, t = arguments.length, n = new Array(t), i = 0; i < t; i++) n[i] = arguments[i];
                                            n.filter(Boolean).forEach(function (t) {
                                                t.addEventListener("click", function (t) {
                                                    return e.showModal(t);
                                                });
                                            });
                                        },
                                    },
                                    {
                                        key: "showModal",
                                        value: function () {
                                            var e = this,
                                                t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
                                            if (
                                                ((this.activeElement = document.activeElement),
                                                this.modal.setAttribute("aria-hidden", "false"),
                                                this.modal.classList.add(this.config.openClass),
                                                this.scrollBehaviour("disable"),
                                                this.addEventListeners(),
                                                this.config.awaitOpenAnimation)
                                            ) {
                                                var n = function t() {
                                                    e.modal.removeEventListener("animationend", t, !1), e.setFocusToFirstNode();
                                                };
                                                this.modal.addEventListener("animationend", n, !1);
                                            } else this.setFocusToFirstNode();
                                            this.config.onShow(this.modal, this.activeElement, t);
                                        },
                                    },
                                    {
                                        key: "closeModal",
                                        value: function () {
                                            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
                                                t = this.modal;
                                            if (
                                                (this.modal.setAttribute("aria-hidden", "true"),
                                                this.removeEventListeners(),
                                                this.scrollBehaviour("enable"),
                                                this.activeElement && this.activeElement.focus && this.activeElement.focus(),
                                                this.config.onClose(this.modal, this.activeElement, e),
                                                this.config.awaitCloseAnimation)
                                            ) {
                                                var n = this.config.openClass;
                                                this.modal.addEventListener(
                                                    "animationend",
                                                    function e() {
                                                        t.classList.remove(n), t.removeEventListener("animationend", e, !1);
                                                    },
                                                    !1
                                                );
                                            } else t.classList.remove(this.config.openClass);
                                        },
                                    },
                                    {
                                        key: "closeModalById",
                                        value: function (e) {
                                            (this.modal = document.getElementById(e)), this.modal && this.closeModal();
                                        },
                                    },
                                    {
                                        key: "scrollBehaviour",
                                        value: function (e) {
                                            if (this.config.disableScroll) {
                                                var t = document.querySelector("body");
                                                switch (e) {
                                                    case "enable":
                                                        Object.assign(t.style, { overflow: "" });
                                                        break;
                                                    case "disable":
                                                        Object.assign(t.style, { overflow: "hidden" });
                                                }
                                            }
                                        },
                                    },
                                    {
                                        key: "addEventListeners",
                                        value: function () {
                                            this.modal.addEventListener("touchstart", this.onClick), this.modal.addEventListener("click", this.onClick), document.addEventListener("keydown", this.onKeydown);
                                        },
                                    },
                                    {
                                        key: "removeEventListeners",
                                        value: function () {
                                            this.modal.removeEventListener("touchstart", this.onClick), this.modal.removeEventListener("click", this.onClick), document.removeEventListener("keydown", this.onKeydown);
                                        },
                                    },
                                    {
                                        key: "onClick",
                                        value: function (e) {
                                            e.target.hasAttribute(this.config.closeTrigger) && this.closeModal(e);
                                        },
                                    },
                                    {
                                        key: "onKeydown",
                                        value: function (e) {
                                            27 === e.keyCode && this.closeModal(e), 9 === e.keyCode && this.retainFocus(e);
                                        },
                                    },
                                    {
                                        key: "getFocusableNodes",
                                        value: function () {
                                            var e = this.modal.querySelectorAll(r);
                                            return Array.apply(void 0, a(e));
                                        },
                                    },
                                    {
                                        key: "setFocusToFirstNode",
                                        value: function () {
                                            var e = this;
                                            if (!this.config.disableFocus) {
                                                var t = this.getFocusableNodes();
                                                if (0 !== t.length) {
                                                    var n = t.filter(function (t) {
                                                        return !t.hasAttribute(e.config.closeTrigger);
                                                    });
                                                    n.length > 0 && n[0].focus(), 0 === n.length && t[0].focus();
                                                }
                                            }
                                        },
                                    },
                                    {
                                        key: "retainFocus",
                                        value: function (e) {
                                            var t = this.getFocusableNodes();
                                            if (0 !== t.length)
                                                if (
                                                    ((t = t.filter(function (e) {
                                                        return null !== e.offsetParent;
                                                    })),
                                                    this.modal.contains(document.activeElement))
                                                ) {
                                                    var n = t.indexOf(document.activeElement);
                                                    e.shiftKey && 0 === n && (t[t.length - 1].focus(), e.preventDefault()), !e.shiftKey && t.length > 0 && n === t.length - 1 && (t[0].focus(), e.preventDefault());
                                                } else t[0].focus();
                                        },
                                    },
                                ]) && i(t.prototype, n),
                                o && i(t, o),
                                e
                            );
                        })()),
                        (l = null),
                        (c = function (e) {
                            if (!document.getElementById(e))
                                return (
                                    console.warn("MicroModal: ❗Seems like you have missed %c'".concat(e, "'"), "background-color: #f8f9fa;color: #50596c;font-weight: bold;", "ID somewhere in your code. Refer example below to resolve it."),
                                    console.warn("%cExample:", "background-color: #f8f9fa;color: #50596c;font-weight: bold;", '<div class="modal" id="'.concat(e, '"></div>')),
                                    !1
                                );
                        }),
                        (d = function (e, t) {
                            if (
                                ((function (e) {
                                    e.length <= 0 &&
                                        (console.warn("MicroModal: ❗Please specify at least one %c'micromodal-trigger'", "background-color: #f8f9fa;color: #50596c;font-weight: bold;", "data attribute."),
                                        console.warn("%cExample:", "background-color: #f8f9fa;color: #50596c;font-weight: bold;", '<a href="#" data-micromodal-trigger="my-modal"></a>'));
                                })(e),
                                !t)
                            )
                                return !0;
                            for (var n in t) c(n);
                            return !0;
                        }),
                        {
                            init: function (e) {
                                var t = Object.assign({}, { openTrigger: "data-micromodal-trigger" }, e),
                                    n = a(document.querySelectorAll("[".concat(t.openTrigger, "]"))),
                                    i = (function (e, t) {
                                        var n = [];
                                        return (
                                            e.forEach(function (e) {
                                                var i = e.attributes[t].value;
                                                void 0 === n[i] && (n[i] = []), n[i].push(e);
                                            }),
                                            n
                                        );
                                    })(n, t.openTrigger);
                                if (!0 !== t.debugMode || !1 !== d(n, i))
                                    for (var o in i) {
                                        var r = i[o];
                                        (t.targetModal = o), (t.triggers = a(r)), (l = new s(t));
                                    }
                            },
                            show: function (e, t) {
                                var n = t || {};
                                (n.targetModal = e), (!0 === n.debugMode && !1 === c(e)) || (l && l.removeEventListeners(), (l = new s(n)).showModal());
                            },
                            close: function (e) {
                                e ? l.closeModalById(e) : l.closeModal();
                            },
                        });
                window.MicroModal = u;
                const p = u;
            },
            () => {
                !(function (e, t, n, i) {
                    "use strict";
                    if (((e.console = e.console || { info: function (e) {} }), n))
                        if (n.fn.fancybox) console.info("fancyBox already initialized");
                        else {
                            var a,
                                o,
                                r,
                                s,
                                l = {
                                    closeExisting: !1,
                                    loop: !1,
                                    gutter: 50,
                                    keyboard: !0,
                                    preventCaptionOverlap: !0,
                                    arrows: !0,
                                    infobar: !0,
                                    smallBtn: "auto",
                                    toolbar: "auto",
                                    buttons: ["zoom", "slideShow", "thumbs", "close"],
                                    idleTime: 3,
                                    protect: !1,
                                    modal: !1,
                                    image: { preload: !1 },
                                    ajax: { settings: { data: { fancybox: !0 } } },
                                    iframe: {
                                        tpl: '<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" allowfullscreen="allowfullscreen" allow="autoplay; fullscreen" src=""></iframe>',
                                        preload: !0,
                                        css: {},
                                        attr: { scrolling: "auto" },
                                    },
                                    video: {
                                        tpl:
                                            '<video class="fancybox-video" controls controlsList="nodownload" poster="{{poster}}"><source src="{{src}}" type="{{format}}" />Sorry, your browser doesn\'t support embedded videos, <a href="{{src}}">download</a> and watch with your favorite video player!</video>',
                                        format: "",
                                        autoStart: !0,
                                    },
                                    defaultType: "image",
                                    animationEffect: "zoom",
                                    animationDuration: 366,
                                    zoomOpacity: "auto",
                                    transitionEffect: "fade",
                                    transitionDuration: 366,
                                    slideClass: "",
                                    baseClass: "",
                                    baseTpl:
                                        '<div class="fancybox-container" role="dialog" tabindex="-1"><div class="fancybox-bg"></div><div class="fancybox-inner"><div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div><div class="fancybox-toolbar">{{buttons}}</div><div class="fancybox-navigation">{{arrows}}</div><div class="fancybox-stage"></div><div class="fancybox-caption"><div class="fancybox-caption__body"></div></div></div></div>',
                                    spinnerTpl: '<div class="fancybox-loading"></div>',
                                    errorTpl: '<div class="fancybox-error"><p>{{ERROR}}</p></div>',
                                    btnTpl: {
                                        download:
                                            '<a download data-fancybox-download class="fancybox-button fancybox-button--download" title="{{DOWNLOAD}}" href="javascript:;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.62 17.09V19H5.38v-1.91zm-2.97-6.96L17 11.45l-5 4.87-5-4.87 1.36-1.32 2.68 2.64V5h1.92v7.77z"/></svg></a>',
                                        zoom:
                                            '<button data-fancybox-zoom class="fancybox-button fancybox-button--zoom" title="{{ZOOM}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.7 17.3l-3-3a5.9 5.9 0 0 0-.6-7.6 5.9 5.9 0 0 0-8.4 0 5.9 5.9 0 0 0 0 8.4 5.9 5.9 0 0 0 7.7.7l3 3a1 1 0 0 0 1.3 0c.4-.5.4-1 0-1.5zM8.1 13.8a4 4 0 0 1 0-5.7 4 4 0 0 1 5.7 0 4 4 0 0 1 0 5.7 4 4 0 0 1-5.7 0z"/></svg></button>',
                                        close:
                                            '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 10.6L6.6 5.2 5.2 6.6l5.4 5.4-5.4 5.4 1.4 1.4 5.4-5.4 5.4 5.4 1.4-1.4-5.4-5.4 5.4-5.4-1.4-1.4-5.4 5.4z"/></svg></button>',
                                        arrowLeft:
                                            '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}"><div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M11.28 15.7l-1.34 1.37L5 12l4.94-5.07 1.34 1.38-2.68 2.72H19v1.94H8.6z"/></svg></div></button>',
                                        arrowRight:
                                            '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}"><div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.4 12.97l-2.68 2.72 1.34 1.38L19 12l-4.94-5.07-1.34 1.38 2.68 2.72H5v1.94z"/></svg></div></button>',
                                        smallBtn:
                                            '<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 24 24"><path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"/></svg></button>',
                                    },
                                    parentEl: "body",
                                    hideScrollbar: !0,
                                    autoFocus: !0,
                                    backFocus: !0,
                                    trapFocus: !0,
                                    fullScreen: { autoStart: !1 },
                                    touch: { vertical: !0, momentum: !0 },
                                    hash: null,
                                    media: {},
                                    slideShow: { autoStart: !1, speed: 3e3 },
                                    thumbs: { autoStart: !1, hideOnClose: !0, parentEl: ".fancybox-container", axis: "y" },
                                    wheel: "auto",
                                    onInit: n.noop,
                                    beforeLoad: n.noop,
                                    afterLoad: n.noop,
                                    beforeShow: n.noop,
                                    afterShow: n.noop,
                                    beforeClose: n.noop,
                                    afterClose: n.noop,
                                    onActivate: n.noop,
                                    onDeactivate: n.noop,
                                    clickContent: function (e, t) {
                                        return "image" === e.type && "zoom";
                                    },
                                    clickSlide: "close",
                                    clickOutside: "close",
                                    dblclickContent: !1,
                                    dblclickSlide: !1,
                                    dblclickOutside: !1,
                                    mobile: {
                                        preventCaptionOverlap: !1,
                                        idleTime: !1,
                                        clickContent: function (e, t) {
                                            return "image" === e.type && "toggleControls";
                                        },
                                        clickSlide: function (e, t) {
                                            return "image" === e.type ? "toggleControls" : "close";
                                        },
                                        dblclickContent: function (e, t) {
                                            return "image" === e.type && "zoom";
                                        },
                                        dblclickSlide: function (e, t) {
                                            return "image" === e.type && "zoom";
                                        },
                                    },
                                    lang: "en",
                                    i18n: {
                                        en: {
                                            CLOSE: "Close",
                                            NEXT: "Next",
                                            PREV: "Previous",
                                            ERROR: "The requested content cannot be loaded. <br/> Please try again later.",
                                            PLAY_START: "Start slideshow",
                                            PLAY_STOP: "Pause slideshow",
                                            FULL_SCREEN: "Full screen",
                                            THUMBS: "Thumbnails",
                                            DOWNLOAD: "Download",
                                            SHARE: "Share",
                                            ZOOM: "Zoom",
                                        },
                                        de: {
                                            CLOSE: "Schlie&szlig;en",
                                            NEXT: "Weiter",
                                            PREV: "Zur&uuml;ck",
                                            ERROR: "Die angeforderten Daten konnten nicht geladen werden. <br/> Bitte versuchen Sie es sp&auml;ter nochmal.",
                                            PLAY_START: "Diaschau starten",
                                            PLAY_STOP: "Diaschau beenden",
                                            FULL_SCREEN: "Vollbild",
                                            THUMBS: "Vorschaubilder",
                                            DOWNLOAD: "Herunterladen",
                                            SHARE: "Teilen",
                                            ZOOM: "Vergr&ouml;&szlig;ern",
                                        },
                                    },
                                },
                                c = n(e),
                                d = n(t),
                                u = 0,
                                p =
                                    e.requestAnimationFrame ||
                                    e.webkitRequestAnimationFrame ||
                                    e.mozRequestAnimationFrame ||
                                    e.oRequestAnimationFrame ||
                                    function (t) {
                                        return e.setTimeout(t, 1e3 / 60);
                                    },
                                f =
                                    e.cancelAnimationFrame ||
                                    e.webkitCancelAnimationFrame ||
                                    e.mozCancelAnimationFrame ||
                                    e.oCancelAnimationFrame ||
                                    function (t) {
                                        e.clearTimeout(t);
                                    },
                                h = (function () {
                                    var e,
                                        n = t.createElement("fakeelement"),
                                        a = { transition: "transitionend", OTransition: "oTransitionEnd", MozTransition: "transitionend", WebkitTransition: "webkitTransitionEnd" };
                                    for (e in a) if (n.style[e] !== i) return a[e];
                                    return "transitionend";
                                })(),
                                g = function (e) {
                                    return e && e.length && e[0].offsetHeight;
                                },
                                v = function (e, t) {
                                    var i = n.extend(!0, {}, e, t);
                                    return (
                                        n.each(t, function (e, t) {
                                            n.isArray(t) && (i[e] = t);
                                        }),
                                        i
                                    );
                                },
                                m = function (e, t, i) {
                                    var a = this;
                                    (a.opts = v({ index: i }, n.fancybox.defaults)),
                                        n.isPlainObject(t) && (a.opts = v(a.opts, t)),
                                        n.fancybox.isMobile && (a.opts = v(a.opts, a.opts.mobile)),
                                        (a.id = a.opts.id || ++u),
                                        (a.currIndex = parseInt(a.opts.index, 10) || 0),
                                        (a.prevIndex = null),
                                        (a.prevPos = null),
                                        (a.currPos = 0),
                                        (a.firstRun = !0),
                                        (a.group = []),
                                        (a.slides = {}),
                                        a.addContent(e),
                                        a.group.length && a.init();
                                };
                            n.extend(m.prototype, {
                                init: function () {
                                    var i,
                                        a,
                                        o = this,
                                        r = o.group[o.currIndex].opts;
                                    r.closeExisting && n.fancybox.close(!0),
                                        n("body").addClass("fancybox-active"),
                                        !n.fancybox.getInstance() &&
                                            !1 !== r.hideScrollbar &&
                                            !n.fancybox.isMobile &&
                                            t.body.scrollHeight > e.innerHeight &&
                                            (n("head").append('<style id="fancybox-style-noscroll" type="text/css">.compensate-for-scrollbar{margin-right:' + (e.innerWidth - t.documentElement.clientWidth) + "px;}</style>"),
                                            n("body").addClass("compensate-for-scrollbar")),
                                        (a = ""),
                                        n.each(r.buttons, function (e, t) {
                                            a += r.btnTpl[t] || "";
                                        }),
                                        (i = n(o.translate(o, r.baseTpl.replace("{{buttons}}", a).replace("{{arrows}}", r.btnTpl.arrowLeft + r.btnTpl.arrowRight)))
                                            .attr("id", "fancybox-container-" + o.id)
                                            .addClass(r.baseClass)
                                            .data("FancyBox", o)
                                            .appendTo(r.parentEl)),
                                        (o.$refs = { container: i }),
                                        ["bg", "inner", "infobar", "toolbar", "stage", "caption", "navigation"].forEach(function (e) {
                                            o.$refs[e] = i.find(".fancybox-" + e);
                                        }),
                                        o.trigger("onInit"),
                                        o.activate(),
                                        o.jumpTo(o.currIndex);
                                },
                                translate: function (e, t) {
                                    var n = e.opts.i18n[e.opts.lang] || e.opts.i18n.en;
                                    return t.replace(/\{\{(\w+)\}\}/g, function (e, t) {
                                        return n[t] === i ? e : n[t];
                                    });
                                },
                                addContent: function (e) {
                                    var t,
                                        a = this,
                                        o = n.makeArray(e);
                                    n.each(o, function (e, t) {
                                        var o,
                                            r,
                                            s,
                                            l,
                                            c,
                                            d = {},
                                            u = {};
                                        n.isPlainObject(t)
                                            ? ((d = t), (u = t.opts || t))
                                            : "object" === n.type(t) && n(t).length
                                            ? ((u = (o = n(t)).data() || {}), ((u = n.extend(!0, {}, u, u.options)).$orig = o), (d.src = a.opts.src || u.src || o.attr("href")), d.type || d.src || ((d.type = "inline"), (d.src = t)))
                                            : (d = { type: "html", src: t + "" }),
                                            (d.opts = n.extend(!0, {}, a.opts, u)),
                                            n.isArray(u.buttons) && (d.opts.buttons = u.buttons),
                                            n.fancybox.isMobile && d.opts.mobile && (d.opts = v(d.opts, d.opts.mobile)),
                                            (r = d.type || d.opts.type),
                                            (l = d.src || ""),
                                            !r &&
                                                l &&
                                                ((s = l.match(/\.(mp4|mov|ogv|webm)((\?|#).*)?$/i))
                                                    ? ((r = "video"), d.opts.video.format || (d.opts.video.format = "video/" + ("ogv" === s[1] ? "ogg" : s[1])))
                                                    : l.match(/(^data:image\/[a-z0-9+\/=]*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg|ico)((\?|#).*)?$)/i)
                                                    ? (r = "image")
                                                    : l.match(/\.(pdf)((\?|#).*)?$/i)
                                                    ? ((r = "iframe"), (d = n.extend(!0, d, { contentType: "pdf", opts: { iframe: { preload: !1 } } })))
                                                    : "#" === l.charAt(0) && (r = "inline")),
                                            r ? (d.type = r) : a.trigger("objectNeedsType", d),
                                            d.contentType || (d.contentType = n.inArray(d.type, ["html", "inline", "ajax"]) > -1 ? "html" : d.type),
                                            (d.index = a.group.length),
                                            "auto" == d.opts.smallBtn && (d.opts.smallBtn = n.inArray(d.type, ["html", "inline", "ajax"]) > -1),
                                            "auto" === d.opts.toolbar && (d.opts.toolbar = !d.opts.smallBtn),
                                            (d.$thumb = d.opts.$thumb || null),
                                            d.opts.$trigger && d.index === a.opts.index && ((d.$thumb = d.opts.$trigger.find("img:first")), d.$thumb.length && (d.opts.$orig = d.opts.$trigger)),
                                            (d.$thumb && d.$thumb.length) || !d.opts.$orig || (d.$thumb = d.opts.$orig.find("img:first")),
                                            d.$thumb && !d.$thumb.length && (d.$thumb = null),
                                            (d.thumb = d.opts.thumb || (d.$thumb ? d.$thumb[0].src : null)),
                                            "function" === n.type(d.opts.caption) && (d.opts.caption = d.opts.caption.apply(t, [a, d])),
                                            "function" === n.type(a.opts.caption) && (d.opts.caption = a.opts.caption.apply(t, [a, d])),
                                            d.opts.caption instanceof n || (d.opts.caption = d.opts.caption === i ? "" : d.opts.caption + ""),
                                            "ajax" === d.type && (c = l.split(/\s+/, 2)).length > 1 && ((d.src = c.shift()), (d.opts.filter = c.shift())),
                                            d.opts.modal &&
                                                (d.opts = n.extend(!0, d.opts, {
                                                    trapFocus: !0,
                                                    infobar: 0,
                                                    toolbar: 0,
                                                    smallBtn: 0,
                                                    keyboard: 0,
                                                    slideShow: 0,
                                                    fullScreen: 0,
                                                    thumbs: 0,
                                                    touch: 0,
                                                    clickContent: !1,
                                                    clickSlide: !1,
                                                    clickOutside: !1,
                                                    dblclickContent: !1,
                                                    dblclickSlide: !1,
                                                    dblclickOutside: !1,
                                                })),
                                            a.group.push(d);
                                    }),
                                        Object.keys(a.slides).length && (a.updateControls(), (t = a.Thumbs) && t.isActive && (t.create(), t.focus()));
                                },
                                addEvents: function () {
                                    var t = this;
                                    t.removeEvents(),
                                        t.$refs.container
                                            .on("click.fb-close", "[data-fancybox-close]", function (e) {
                                                e.stopPropagation(), e.preventDefault(), t.close(e);
                                            })
                                            .on("touchstart.fb-prev click.fb-prev", "[data-fancybox-prev]", function (e) {
                                                e.stopPropagation(), e.preventDefault(), t.previous();
                                            })
                                            .on("touchstart.fb-next click.fb-next", "[data-fancybox-next]", function (e) {
                                                e.stopPropagation(), e.preventDefault(), t.next();
                                            })
                                            .on("click.fb", "[data-fancybox-zoom]", function (e) {
                                                t[t.isScaledDown() ? "scaleToActual" : "scaleToFit"]();
                                            }),
                                        c.on("orientationchange.fb resize.fb", function (e) {
                                            e && e.originalEvent && "resize" === e.originalEvent.type
                                                ? (t.requestId && f(t.requestId),
                                                  (t.requestId = p(function () {
                                                      t.update(e);
                                                  })))
                                                : (t.current && "iframe" === t.current.type && t.$refs.stage.hide(),
                                                  setTimeout(
                                                      function () {
                                                          t.$refs.stage.show(), t.update(e);
                                                      },
                                                      n.fancybox.isMobile ? 600 : 250
                                                  ));
                                        }),
                                        d.on("keydown.fb", function (e) {
                                            var i = (n.fancybox ? n.fancybox.getInstance() : null).current,
                                                a = e.keyCode || e.which;
                                            if (9 != a) {
                                                if (!(!i.opts.keyboard || e.ctrlKey || e.altKey || e.shiftKey || n(e.target).is("input,textarea,video,audio,select")))
                                                    return 8 === a || 27 === a
                                                        ? (e.preventDefault(), void t.close(e))
                                                        : 37 === a || 38 === a
                                                        ? (e.preventDefault(), void t.previous())
                                                        : 39 === a || 40 === a
                                                        ? (e.preventDefault(), void t.next())
                                                        : void t.trigger("afterKeydown", e, a);
                                            } else i.opts.trapFocus && t.focus(e);
                                        }),
                                        t.group[t.currIndex].opts.idleTime &&
                                            ((t.idleSecondsCounter = 0),
                                            d.on("mousemove.fb-idle mouseleave.fb-idle mousedown.fb-idle touchstart.fb-idle touchmove.fb-idle scroll.fb-idle keydown.fb-idle", function (e) {
                                                (t.idleSecondsCounter = 0), t.isIdle && t.showControls(), (t.isIdle = !1);
                                            }),
                                            (t.idleInterval = e.setInterval(function () {
                                                t.idleSecondsCounter++, t.idleSecondsCounter >= t.group[t.currIndex].opts.idleTime && !t.isDragging && ((t.isIdle = !0), (t.idleSecondsCounter = 0), t.hideControls());
                                            }, 1e3)));
                                },
                                removeEvents: function () {
                                    var t = this;
                                    c.off("orientationchange.fb resize.fb"),
                                        d.off("keydown.fb .fb-idle"),
                                        this.$refs.container.off(".fb-close .fb-prev .fb-next"),
                                        t.idleInterval && (e.clearInterval(t.idleInterval), (t.idleInterval = null));
                                },
                                previous: function (e) {
                                    return this.jumpTo(this.currPos - 1, e);
                                },
                                next: function (e) {
                                    return this.jumpTo(this.currPos + 1, e);
                                },
                                jumpTo: function (e, t) {
                                    var a,
                                        o,
                                        r,
                                        s,
                                        l,
                                        c,
                                        d,
                                        u,
                                        p,
                                        f = this,
                                        h = f.group.length;
                                    if (!(f.isDragging || f.isClosing || (f.isAnimating && f.firstRun))) {
                                        if (((e = parseInt(e, 10)), !(r = f.current ? f.current.opts.loop : f.opts.loop) && (e < 0 || e >= h))) return !1;
                                        if (
                                            ((a = f.firstRun = !Object.keys(f.slides).length),
                                            (l = f.current),
                                            (f.prevIndex = f.currIndex),
                                            (f.prevPos = f.currPos),
                                            (s = f.createSlide(e)),
                                            h > 1 && ((r || s.index < h - 1) && f.createSlide(e + 1), (r || s.index > 0) && f.createSlide(e - 1)),
                                            (f.current = s),
                                            (f.currIndex = s.index),
                                            (f.currPos = s.pos),
                                            f.trigger("beforeShow", a),
                                            f.updateControls(),
                                            (s.forcedDuration = i),
                                            n.isNumeric(t) ? (s.forcedDuration = t) : (t = s.opts[a ? "animationDuration" : "transitionDuration"]),
                                            (t = parseInt(t, 10)),
                                            (o = f.isMoved(s)),
                                            s.$slide.addClass("fancybox-slide--current"),
                                            a)
                                        )
                                            return (
                                                s.opts.animationEffect && t && f.$refs.container.css("transition-duration", t + "ms"), f.$refs.container.addClass("fancybox-is-open").trigger("focus"), f.loadSlide(s), void f.preload("image")
                                            );
                                        (c = n.fancybox.getTranslate(l.$slide)),
                                            (d = n.fancybox.getTranslate(f.$refs.stage)),
                                            n.each(f.slides, function (e, t) {
                                                n.fancybox.stop(t.$slide, !0);
                                            }),
                                            l.pos !== s.pos && (l.isComplete = !1),
                                            l.$slide.removeClass("fancybox-slide--complete fancybox-slide--current"),
                                            o
                                                ? ((p = c.left - (l.pos * c.width + l.pos * l.opts.gutter)),
                                                  n.each(f.slides, function (e, i) {
                                                      i.$slide.removeClass("fancybox-animated").removeClass(function (e, t) {
                                                          return (t.match(/(^|\s)fancybox-fx-\S+/g) || []).join(" ");
                                                      });
                                                      var a = i.pos * c.width + i.pos * i.opts.gutter;
                                                      n.fancybox.setTranslate(i.$slide, { top: 0, left: a - d.left + p }),
                                                          i.pos !== s.pos && i.$slide.addClass("fancybox-slide--" + (i.pos > s.pos ? "next" : "previous")),
                                                          g(i.$slide),
                                                          n.fancybox.animate(i.$slide, { top: 0, left: (i.pos - s.pos) * c.width + (i.pos - s.pos) * i.opts.gutter }, t, function () {
                                                              i.$slide.css({ transform: "", opacity: "" }).removeClass("fancybox-slide--next fancybox-slide--previous"), i.pos === f.currPos && f.complete();
                                                          });
                                                  }))
                                                : t &&
                                                  s.opts.transitionEffect &&
                                                  ((u = "fancybox-animated fancybox-fx-" + s.opts.transitionEffect),
                                                  l.$slide.addClass("fancybox-slide--" + (l.pos > s.pos ? "next" : "previous")),
                                                  n.fancybox.animate(
                                                      l.$slide,
                                                      u,
                                                      t,
                                                      function () {
                                                          l.$slide.removeClass(u).removeClass("fancybox-slide--next fancybox-slide--previous");
                                                      },
                                                      !1
                                                  )),
                                            s.isLoaded ? f.revealContent(s) : f.loadSlide(s),
                                            f.preload("image");
                                    }
                                },
                                createSlide: function (e) {
                                    var t,
                                        i,
                                        a = this;
                                    return (
                                        (i = (i = e % a.group.length) < 0 ? a.group.length + i : i),
                                        !a.slides[e] &&
                                            a.group[i] &&
                                            ((t = n('<div class="fancybox-slide"></div>').appendTo(a.$refs.stage)), (a.slides[e] = n.extend(!0, {}, a.group[i], { pos: e, $slide: t, isLoaded: !1 })), a.updateSlide(a.slides[e])),
                                        a.slides[e]
                                    );
                                },
                                scaleToActual: function (e, t, a) {
                                    var o,
                                        r,
                                        s,
                                        l,
                                        c,
                                        d = this,
                                        u = d.current,
                                        p = u.$content,
                                        f = n.fancybox.getTranslate(u.$slide).width,
                                        h = n.fancybox.getTranslate(u.$slide).height,
                                        g = u.width,
                                        v = u.height;
                                    d.isAnimating ||
                                        d.isMoved() ||
                                        !p ||
                                        "image" != u.type ||
                                        !u.isLoaded ||
                                        u.hasError ||
                                        ((d.isAnimating = !0),
                                        n.fancybox.stop(p),
                                        (e = e === i ? 0.5 * f : e),
                                        (t = t === i ? 0.5 * h : t),
                                        ((o = n.fancybox.getTranslate(p)).top -= n.fancybox.getTranslate(u.$slide).top),
                                        (o.left -= n.fancybox.getTranslate(u.$slide).left),
                                        (l = g / o.width),
                                        (c = v / o.height),
                                        (r = 0.5 * f - 0.5 * g),
                                        (s = 0.5 * h - 0.5 * v),
                                        g > f && ((r = o.left * l - (e * l - e)) > 0 && (r = 0), r < f - g && (r = f - g)),
                                        v > h && ((s = o.top * c - (t * c - t)) > 0 && (s = 0), s < h - v && (s = h - v)),
                                        d.updateCursor(g, v),
                                        n.fancybox.animate(p, { top: s, left: r, scaleX: l, scaleY: c }, a || 366, function () {
                                            d.isAnimating = !1;
                                        }),
                                        d.SlideShow && d.SlideShow.isActive && d.SlideShow.stop());
                                },
                                scaleToFit: function (e) {
                                    var t,
                                        i = this,
                                        a = i.current,
                                        o = a.$content;
                                    i.isAnimating ||
                                        i.isMoved() ||
                                        !o ||
                                        "image" != a.type ||
                                        !a.isLoaded ||
                                        a.hasError ||
                                        ((i.isAnimating = !0),
                                        n.fancybox.stop(o),
                                        (t = i.getFitPos(a)),
                                        i.updateCursor(t.width, t.height),
                                        n.fancybox.animate(o, { top: t.top, left: t.left, scaleX: t.width / o.width(), scaleY: t.height / o.height() }, e || 366, function () {
                                            i.isAnimating = !1;
                                        }));
                                },
                                getFitPos: function (e) {
                                    var t,
                                        i,
                                        a,
                                        o,
                                        r = e.$content,
                                        s = e.$slide,
                                        l = e.width || e.opts.width,
                                        c = e.height || e.opts.height,
                                        d = {};
                                    return (
                                        !!(e.isLoaded && r && r.length) &&
                                        ((t = n.fancybox.getTranslate(this.$refs.stage).width),
                                        (i = n.fancybox.getTranslate(this.$refs.stage).height),
                                        (t -= parseFloat(s.css("paddingLeft")) + parseFloat(s.css("paddingRight")) + parseFloat(r.css("marginLeft")) + parseFloat(r.css("marginRight"))),
                                        (i -= parseFloat(s.css("paddingTop")) + parseFloat(s.css("paddingBottom")) + parseFloat(r.css("marginTop")) + parseFloat(r.css("marginBottom"))),
                                        (l && c) || ((l = t), (c = i)),
                                        (l *= a = Math.min(1, t / l, i / c)) > t - 0.5 && (l = t),
                                        (c *= a) > i - 0.5 && (c = i),
                                        "image" === e.type
                                            ? ((d.top = Math.floor(0.5 * (i - c)) + parseFloat(s.css("paddingTop"))), (d.left = Math.floor(0.5 * (t - l)) + parseFloat(s.css("paddingLeft"))))
                                            : "video" === e.contentType && (c > l / (o = e.opts.width && e.opts.height ? l / c : e.opts.ratio || 16 / 9) ? (c = l / o) : l > c * o && (l = c * o)),
                                        (d.width = l),
                                        (d.height = c),
                                        d)
                                    );
                                },
                                update: function (e) {
                                    var t = this;
                                    n.each(t.slides, function (n, i) {
                                        t.updateSlide(i, e);
                                    });
                                },
                                updateSlide: function (e, t) {
                                    var i = this,
                                        a = e && e.$content,
                                        o = e.width || e.opts.width,
                                        r = e.height || e.opts.height,
                                        s = e.$slide;
                                    i.adjustCaption(e),
                                        a && (o || r || "video" === e.contentType) && !e.hasError && (n.fancybox.stop(a), n.fancybox.setTranslate(a, i.getFitPos(e)), e.pos === i.currPos && ((i.isAnimating = !1), i.updateCursor())),
                                        i.adjustLayout(e),
                                        s.length &&
                                            (s.trigger("refresh"),
                                            e.pos === i.currPos && i.$refs.toolbar.add(i.$refs.navigation.find(".fancybox-button--arrow_right")).toggleClass("compensate-for-scrollbar", s.get(0).scrollHeight > s.get(0).clientHeight)),
                                        i.trigger("onUpdate", e, t);
                                },
                                centerSlide: function (e) {
                                    var t = this,
                                        a = t.current,
                                        o = a.$slide;
                                    !t.isClosing &&
                                        a &&
                                        (o.siblings().css({ transform: "", opacity: "" }),
                                        o.parent().children().removeClass("fancybox-slide--previous fancybox-slide--next"),
                                        n.fancybox.animate(
                                            o,
                                            { top: 0, left: 0, opacity: 1 },
                                            e === i ? 0 : e,
                                            function () {
                                                o.css({ transform: "", opacity: "" }), a.isComplete || t.complete();
                                            },
                                            !1
                                        ));
                                },
                                isMoved: function (e) {
                                    var t,
                                        i,
                                        a = e || this.current;
                                    return (
                                        !!a &&
                                        ((i = n.fancybox.getTranslate(this.$refs.stage)),
                                        (t = n.fancybox.getTranslate(a.$slide)),
                                        !a.$slide.hasClass("fancybox-animated") && (Math.abs(t.top - i.top) > 0.5 || Math.abs(t.left - i.left) > 0.5))
                                    );
                                },
                                updateCursor: function (e, t) {
                                    var i,
                                        a,
                                        o = this,
                                        r = o.current,
                                        s = o.$refs.container;
                                    r &&
                                        !o.isClosing &&
                                        o.Guestures &&
                                        (s.removeClass("fancybox-is-zoomable fancybox-can-zoomIn fancybox-can-zoomOut fancybox-can-swipe fancybox-can-pan"),
                                        (a = !!(i = o.canPan(e, t)) || o.isZoomable()),
                                        s.toggleClass("fancybox-is-zoomable", a),
                                        n("[data-fancybox-zoom]").prop("disabled", !a),
                                        i
                                            ? s.addClass("fancybox-can-pan")
                                            : a && ("zoom" === r.opts.clickContent || (n.isFunction(r.opts.clickContent) && "zoom" == r.opts.clickContent(r)))
                                            ? s.addClass("fancybox-can-zoomIn")
                                            : r.opts.touch && (r.opts.touch.vertical || o.group.length > 1) && "video" !== r.contentType && s.addClass("fancybox-can-swipe"));
                                },
                                isZoomable: function () {
                                    var e,
                                        t = this,
                                        n = t.current;
                                    if (n && !t.isClosing && "image" === n.type && !n.hasError) {
                                        if (!n.isLoaded) return !0;
                                        if ((e = t.getFitPos(n)) && (n.width > e.width || n.height > e.height)) return !0;
                                    }
                                    return !1;
                                },
                                isScaledDown: function (e, t) {
                                    var a = !1,
                                        o = this.current,
                                        r = o.$content;
                                    return e !== i && t !== i ? (a = e < o.width && t < o.height) : r && (a = (a = n.fancybox.getTranslate(r)).width < o.width && a.height < o.height), a;
                                },
                                canPan: function (e, t) {
                                    var a = this.current,
                                        o = null,
                                        r = !1;
                                    return (
                                        "image" === a.type &&
                                            (a.isComplete || (e && t)) &&
                                            !a.hasError &&
                                            ((r = this.getFitPos(a)),
                                            e !== i && t !== i ? (o = { width: e, height: t }) : a.isComplete && (o = n.fancybox.getTranslate(a.$content)),
                                            o && r && (r = Math.abs(o.width - r.width) > 1.5 || Math.abs(o.height - r.height) > 1.5)),
                                        r
                                    );
                                },
                                loadSlide: function (e) {
                                    var t,
                                        i,
                                        a,
                                        o = this;
                                    if (!e.isLoading && !e.isLoaded) {
                                        if (((e.isLoading = !0), !1 === o.trigger("beforeLoad", e))) return (e.isLoading = !1), !1;
                                        switch (((t = e.type), (i = e.$slide).off("refresh").trigger("onReset").addClass(e.opts.slideClass), t)) {
                                            case "image":
                                                o.setImage(e);
                                                break;
                                            case "iframe":
                                                o.setIframe(e);
                                                break;
                                            case "html":
                                                o.setContent(e, e.src || e.content);
                                                break;
                                            case "video":
                                                o.setContent(
                                                    e,
                                                    e.opts.video.tpl
                                                        .replace(/\{\{src\}\}/gi, e.src)
                                                        .replace("{{format}}", e.opts.videoFormat || e.opts.video.format || "")
                                                        .replace("{{poster}}", e.thumb || "")
                                                );
                                                break;
                                            case "inline":
                                                n(e.src).length ? o.setContent(e, n(e.src)) : o.setError(e);
                                                break;
                                            case "ajax":
                                                o.showLoading(e),
                                                    (a = n.ajax(
                                                        n.extend({}, e.opts.ajax.settings, {
                                                            url: e.src,
                                                            success: function (t, n) {
                                                                "success" === n && o.setContent(e, t);
                                                            },
                                                            error: function (t, n) {
                                                                t && "abort" !== n && o.setError(e);
                                                            },
                                                        })
                                                    )),
                                                    i.one("onReset", function () {
                                                        a.abort();
                                                    });
                                                break;
                                            default:
                                                o.setError(e);
                                        }
                                        return !0;
                                    }
                                },
                                setImage: function (e) {
                                    var i,
                                        a = this;
                                    setTimeout(function () {
                                        var t = e.$image;
                                        a.isClosing || !e.isLoading || (t && t.length && t[0].complete) || e.hasError || a.showLoading(e);
                                    }, 50),
                                        a.checkSrcset(e),
                                        (e.$content = n('<div class="fancybox-content"></div>').addClass("fancybox-is-hidden").appendTo(e.$slide.addClass("fancybox-slide--image"))),
                                        !1 !== e.opts.preload &&
                                            e.opts.width &&
                                            e.opts.height &&
                                            e.thumb &&
                                            ((e.width = e.opts.width),
                                            (e.height = e.opts.height),
                                            ((i = t.createElement("img")).onerror = function () {
                                                n(this).remove(), (e.$ghost = null);
                                            }),
                                            (i.onload = function () {
                                                a.afterLoad(e);
                                            }),
                                            (e.$ghost = n(i).addClass("fancybox-image").appendTo(e.$content).attr("src", e.thumb))),
                                        a.setBigImage(e);
                                },
                                checkSrcset: function (t) {
                                    var n,
                                        i,
                                        a,
                                        o,
                                        r = t.opts.srcset || t.opts.image.srcset;
                                    if (r) {
                                        (a = e.devicePixelRatio || 1),
                                            (o = e.innerWidth * a),
                                            (i = r.split(",").map(function (e) {
                                                var t = {};
                                                return (
                                                    e
                                                        .trim()
                                                        .split(/\s+/)
                                                        .forEach(function (e, n) {
                                                            var i = parseInt(e.substring(0, e.length - 1), 10);
                                                            if (0 === n) return (t.url = e);
                                                            i && ((t.value = i), (t.postfix = e[e.length - 1]));
                                                        }),
                                                    t
                                                );
                                            })).sort(function (e, t) {
                                                return e.value - t.value;
                                            });
                                        for (var s = 0; s < i.length; s++) {
                                            var l = i[s];
                                            if (("w" === l.postfix && l.value >= o) || ("x" === l.postfix && l.value >= a)) {
                                                n = l;
                                                break;
                                            }
                                        }
                                        !n && i.length && (n = i[i.length - 1]), n && ((t.src = n.url), t.width && t.height && "w" == n.postfix && ((t.height = (t.width / t.height) * n.value), (t.width = n.value)), (t.opts.srcset = r));
                                    }
                                },
                                setBigImage: function (e) {
                                    var i = this,
                                        a = t.createElement("img"),
                                        o = n(a);
                                    (e.$image = o
                                        .one("error", function () {
                                            i.setError(e);
                                        })
                                        .one("load", function () {
                                            var t;
                                            e.$ghost || (i.resolveImageSlideSize(e, this.naturalWidth, this.naturalHeight), i.afterLoad(e)),
                                                i.isClosing ||
                                                    (e.opts.srcset &&
                                                        (((t = e.opts.sizes) && "auto" !== t) || (t = (e.width / e.height > 1 && c.width() / c.height() > 1 ? "100" : Math.round((e.width / e.height) * 100)) + "vw"),
                                                        o.attr("sizes", t).attr("srcset", e.opts.srcset)),
                                                    e.$ghost &&
                                                        setTimeout(function () {
                                                            e.$ghost && !i.isClosing && e.$ghost.hide();
                                                        }, Math.min(300, Math.max(1e3, e.height / 1600))),
                                                    i.hideLoading(e));
                                        })
                                        .addClass("fancybox-image")
                                        .attr("src", e.src)
                                        .appendTo(e.$content)),
                                        (a.complete || "complete" == a.readyState) && o.naturalWidth && o.naturalHeight ? o.trigger("load") : a.error && o.trigger("error");
                                },
                                resolveImageSlideSize: function (e, t, n) {
                                    var i = parseInt(e.opts.width, 10),
                                        a = parseInt(e.opts.height, 10);
                                    (e.width = t), (e.height = n), i > 0 && ((e.width = i), (e.height = Math.floor((i * n) / t))), a > 0 && ((e.width = Math.floor((a * t) / n)), (e.height = a));
                                },
                                setIframe: function (e) {
                                    var t,
                                        a = this,
                                        o = e.opts.iframe,
                                        r = e.$slide;
                                    (e.$content = n('<div class="fancybox-content' + (o.preload ? " fancybox-is-hidden" : "") + '"></div>')
                                        .css(o.css)
                                        .appendTo(r)),
                                        r.addClass("fancybox-slide--" + e.contentType),
                                        (e.$iframe = t = n(o.tpl.replace(/\{rnd\}/g, new Date().getTime()))
                                            .attr(o.attr)
                                            .appendTo(e.$content)),
                                        o.preload
                                            ? (a.showLoading(e),
                                              t.on("load.fb error.fb", function (t) {
                                                  (this.isReady = 1), e.$slide.trigger("refresh"), a.afterLoad(e);
                                              }),
                                              r.on("refresh.fb", function () {
                                                  var n,
                                                      a = e.$content,
                                                      s = o.css.width,
                                                      l = o.css.height;
                                                  if (1 === t[0].isReady) {
                                                      try {
                                                          n = t.contents().find("body");
                                                      } catch (e) {}
                                                      n &&
                                                          n.length &&
                                                          n.children().length &&
                                                          (r.css("overflow", "visible"),
                                                          a.css({ width: "100%", "max-width": "100%", height: "9999px" }),
                                                          s === i && (s = Math.ceil(Math.max(n[0].clientWidth, n.outerWidth(!0)))),
                                                          a.css("width", s || "").css("max-width", ""),
                                                          l === i && (l = Math.ceil(Math.max(n[0].clientHeight, n.outerHeight(!0)))),
                                                          a.css("height", l || ""),
                                                          r.css("overflow", "auto")),
                                                          a.removeClass("fancybox-is-hidden");
                                                  }
                                              }))
                                            : a.afterLoad(e),
                                        t.attr("src", e.src),
                                        r.one("onReset", function () {
                                            try {
                                                n(this).find("iframe").hide().unbind().attr("src", "//about:blank");
                                            } catch (e) {}
                                            n(this).off("refresh.fb").empty(), (e.isLoaded = !1), (e.isRevealed = !1);
                                        });
                                },
                                setContent: function (e, t) {
                                    var i,
                                        a = this;
                                    a.isClosing ||
                                        (a.hideLoading(e),
                                        e.$content && n.fancybox.stop(e.$content),
                                        e.$slide.empty(),
                                        (i = t) && i.hasOwnProperty && i instanceof n && t.parent().length
                                            ? ((t.hasClass("fancybox-content") || t.parent().hasClass("fancybox-content")) && t.parents(".fancybox-slide").trigger("onReset"),
                                              (e.$placeholder = n("<div>").hide().insertAfter(t)),
                                              t.css("display", "inline-block"))
                                            : e.hasError || ("string" === n.type(t) && (t = n("<div>").append(n.trim(t)).contents()), e.opts.filter && (t = n("<div>").html(t).find(e.opts.filter))),
                                        e.$slide.one("onReset", function () {
                                            n(this).find("video,audio").trigger("pause"),
                                                e.$placeholder && (e.$placeholder.after(t.removeClass("fancybox-content").hide()).remove(), (e.$placeholder = null)),
                                                e.$smallBtn && (e.$smallBtn.remove(), (e.$smallBtn = null)),
                                                e.hasError || (n(this).empty(), (e.isLoaded = !1), (e.isRevealed = !1));
                                        }),
                                        n(t).appendTo(e.$slide),
                                        n(t).is("video,audio") &&
                                            (n(t).addClass("fancybox-video"), n(t).wrap("<div></div>"), (e.contentType = "video"), (e.opts.width = e.opts.width || n(t).attr("width")), (e.opts.height = e.opts.height || n(t).attr("height"))),
                                        (e.$content = e.$slide.children().filter("div,form,main,video,audio,article,.fancybox-content").first()),
                                        e.$content.siblings().hide(),
                                        e.$content.length || (e.$content = e.$slide.wrapInner("<div></div>").children().first()),
                                        e.$content.addClass("fancybox-content"),
                                        e.$slide.addClass("fancybox-slide--" + e.contentType),
                                        a.afterLoad(e));
                                },
                                setError: function (e) {
                                    (e.hasError = !0),
                                        e.$slide
                                            .trigger("onReset")
                                            .removeClass("fancybox-slide--" + e.contentType)
                                            .addClass("fancybox-slide--error"),
                                        (e.contentType = "html"),
                                        this.setContent(e, this.translate(e, e.opts.errorTpl)),
                                        e.pos === this.currPos && (this.isAnimating = !1);
                                },
                                showLoading: function (e) {
                                    var t = this;
                                    (e = e || t.current) && !e.$spinner && (e.$spinner = n(t.translate(t, t.opts.spinnerTpl)).appendTo(e.$slide).hide().fadeIn("fast"));
                                },
                                hideLoading: function (e) {
                                    (e = e || this.current) && e.$spinner && (e.$spinner.stop().remove(), delete e.$spinner);
                                },
                                afterLoad: function (e) {
                                    var t = this;
                                    t.isClosing ||
                                        ((e.isLoading = !1),
                                        (e.isLoaded = !0),
                                        t.trigger("afterLoad", e),
                                        t.hideLoading(e),
                                        !e.opts.smallBtn || (e.$smallBtn && e.$smallBtn.length) || (e.$smallBtn = n(t.translate(e, e.opts.btnTpl.smallBtn)).appendTo(e.$content)),
                                        e.opts.protect &&
                                            e.$content &&
                                            !e.hasError &&
                                            (e.$content.on("contextmenu.fb", function (e) {
                                                return 2 == e.button && e.preventDefault(), !0;
                                            }),
                                            "image" === e.type && n('<div class="fancybox-spaceball"></div>').appendTo(e.$content)),
                                        t.adjustCaption(e),
                                        t.adjustLayout(e),
                                        e.pos === t.currPos && t.updateCursor(),
                                        t.revealContent(e));
                                },
                                adjustCaption: function (e) {
                                    var t,
                                        n = this,
                                        i = e || n.current,
                                        a = i.opts.caption,
                                        o = i.opts.preventCaptionOverlap,
                                        r = n.$refs.caption,
                                        s = !1;
                                    r.toggleClass("fancybox-caption--separate", o),
                                        o &&
                                            a &&
                                            a.length &&
                                            (i.pos !== n.currPos ? ((t = r.clone().appendTo(r.parent())).children().eq(0).empty().html(a), (s = t.outerHeight(!0)), t.empty().remove()) : n.$caption && (s = n.$caption.outerHeight(!0)),
                                            i.$slide.css("padding-bottom", s || ""));
                                },
                                adjustLayout: function (e) {
                                    var t,
                                        n,
                                        i,
                                        a,
                                        o = e || this.current;
                                    o.isLoaded &&
                                        !0 !== o.opts.disableLayoutFix &&
                                        (o.$content.css("margin-bottom", ""),
                                        o.$content.outerHeight() > o.$slide.height() + 0.5 &&
                                            ((i = o.$slide[0].style["padding-bottom"]),
                                            (a = o.$slide.css("padding-bottom")),
                                            parseFloat(a) > 0 && ((t = o.$slide[0].scrollHeight), o.$slide.css("padding-bottom", 0), Math.abs(t - o.$slide[0].scrollHeight) < 1 && (n = a), o.$slide.css("padding-bottom", i))),
                                        o.$content.css("margin-bottom", n));
                                },
                                revealContent: function (e) {
                                    var t,
                                        a,
                                        o,
                                        r,
                                        s = this,
                                        l = e.$slide,
                                        c = !1,
                                        d = !1,
                                        u = s.isMoved(e),
                                        p = e.isRevealed;
                                    return (
                                        (e.isRevealed = !0),
                                        (t = e.opts[s.firstRun ? "animationEffect" : "transitionEffect"]),
                                        (o = e.opts[s.firstRun ? "animationDuration" : "transitionDuration"]),
                                        (o = parseInt(e.forcedDuration === i ? o : e.forcedDuration, 10)),
                                        (!u && e.pos === s.currPos && o) || (t = !1),
                                        "zoom" === t && (e.pos === s.currPos && o && "image" === e.type && !e.hasError && (d = s.getThumbPos(e)) ? (c = s.getFitPos(e)) : (t = "fade")),
                                        "zoom" === t
                                            ? ((s.isAnimating = !0),
                                              (c.scaleX = c.width / d.width),
                                              (c.scaleY = c.height / d.height),
                                              "auto" == (r = e.opts.zoomOpacity) && (r = Math.abs(e.width / e.height - d.width / d.height) > 0.1),
                                              r && ((d.opacity = 0.1), (c.opacity = 1)),
                                              n.fancybox.setTranslate(e.$content.removeClass("fancybox-is-hidden"), d),
                                              g(e.$content),
                                              void n.fancybox.animate(e.$content, c, o, function () {
                                                  (s.isAnimating = !1), s.complete();
                                              }))
                                            : (s.updateSlide(e),
                                              t
                                                  ? (n.fancybox.stop(l),
                                                    (a = "fancybox-slide--" + (e.pos >= s.prevPos ? "next" : "previous") + " fancybox-animated fancybox-fx-" + t),
                                                    l.addClass(a).removeClass("fancybox-slide--current"),
                                                    e.$content.removeClass("fancybox-is-hidden"),
                                                    g(l),
                                                    "image" !== e.type && e.$content.hide().show(0),
                                                    void n.fancybox.animate(
                                                        l,
                                                        "fancybox-slide--current",
                                                        o,
                                                        function () {
                                                            l.removeClass(a).css({ transform: "", opacity: "" }), e.pos === s.currPos && s.complete();
                                                        },
                                                        !0
                                                    ))
                                                  : (e.$content.removeClass("fancybox-is-hidden"), p || !u || "image" !== e.type || e.hasError || e.$content.hide().fadeIn("fast"), void (e.pos === s.currPos && s.complete())))
                                    );
                                },
                                getThumbPos: function (e) {
                                    var i,
                                        a,
                                        o,
                                        r,
                                        s,
                                        l,
                                        c = e.$thumb;
                                    return (
                                        !(
                                            !c ||
                                            !(function (e) {
                                                var i, a;
                                                return (
                                                    !(!e || e.ownerDocument !== t) &&
                                                    (n(".fancybox-container").css("pointer-events", "none"),
                                                    (i = { x: e.getBoundingClientRect().left + e.offsetWidth / 2, y: e.getBoundingClientRect().top + e.offsetHeight / 2 }),
                                                    (a = t.elementFromPoint(i.x, i.y) === e),
                                                    n(".fancybox-container").css("pointer-events", ""),
                                                    a)
                                                );
                                            })(c[0])
                                        ) &&
                                        ((a = n.fancybox.getTranslate(c)),
                                        (o = parseFloat(c.css("border-top-width") || 0)),
                                        (r = parseFloat(c.css("border-right-width") || 0)),
                                        (s = parseFloat(c.css("border-bottom-width") || 0)),
                                        (l = parseFloat(c.css("border-left-width") || 0)),
                                        (i = { top: a.top + o, left: a.left + l, width: a.width - r - l, height: a.height - o - s, scaleX: 1, scaleY: 1 }),
                                        a.width > 0 && a.height > 0 && i)
                                    );
                                },
                                complete: function () {
                                    var e,
                                        t = this,
                                        i = t.current,
                                        a = {};
                                    !t.isMoved() &&
                                        i.isLoaded &&
                                        (i.isComplete ||
                                            ((i.isComplete = !0),
                                            i.$slide.siblings().trigger("onReset"),
                                            t.preload("inline"),
                                            g(i.$slide),
                                            i.$slide.addClass("fancybox-slide--complete"),
                                            n.each(t.slides, function (e, i) {
                                                i.pos >= t.currPos - 1 && i.pos <= t.currPos + 1 ? (a[i.pos] = i) : i && (n.fancybox.stop(i.$slide), i.$slide.off().remove());
                                            }),
                                            (t.slides = a)),
                                        (t.isAnimating = !1),
                                        t.updateCursor(),
                                        t.trigger("afterShow"),
                                        i.opts.video.autoStart &&
                                            i.$slide
                                                .find("video,audio")
                                                .filter(":visible:first")
                                                .trigger("play")
                                                .one("ended", function () {
                                                    Document.exitFullscreen ? Document.exitFullscreen() : this.webkitExitFullscreen && this.webkitExitFullscreen(), t.next();
                                                }),
                                        i.opts.autoFocus && "html" === i.contentType && ((e = i.$content.find("input[autofocus]:enabled:visible:first")).length ? e.trigger("focus") : t.focus(null, !0)),
                                        i.$slide.scrollTop(0).scrollLeft(0));
                                },
                                preload: function (e) {
                                    var t,
                                        n,
                                        i = this;
                                    i.group.length < 2 || ((n = i.slides[i.currPos + 1]), (t = i.slides[i.currPos - 1]) && t.type === e && i.loadSlide(t), n && n.type === e && i.loadSlide(n));
                                },
                                focus: function (e, i) {
                                    var a,
                                        o,
                                        r = this,
                                        s = [
                                            "a[href]",
                                            "area[href]",
                                            'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
                                            "select:not([disabled]):not([aria-hidden])",
                                            "textarea:not([disabled]):not([aria-hidden])",
                                            "button:not([disabled]):not([aria-hidden])",
                                            "iframe",
                                            "object",
                                            "embed",
                                            "video",
                                            "audio",
                                            "[contenteditable]",
                                            '[tabindex]:not([tabindex^="-"])',
                                        ].join(",");
                                    r.isClosing ||
                                        ((a = (a = !e && r.current && r.current.isComplete ? r.current.$slide.find("*:visible" + (i ? ":not(.fancybox-close-small)" : "")) : r.$refs.container.find("*:visible")).filter(s).filter(function () {
                                            return "hidden" !== n(this).css("visibility") && !n(this).hasClass("disabled");
                                        })).length
                                            ? ((o = a.index(t.activeElement)),
                                              e && e.shiftKey ? (o < 0 || 0 == o) && (e.preventDefault(), a.eq(a.length - 1).trigger("focus")) : (o < 0 || o == a.length - 1) && (e && e.preventDefault(), a.eq(0).trigger("focus")))
                                            : r.$refs.container.trigger("focus"));
                                },
                                activate: function () {
                                    var e = this;
                                    n(".fancybox-container").each(function () {
                                        var t = n(this).data("FancyBox");
                                        t && t.id !== e.id && !t.isClosing && (t.trigger("onDeactivate"), t.removeEvents(), (t.isVisible = !1));
                                    }),
                                        (e.isVisible = !0),
                                        (e.current || e.isIdle) && (e.update(), e.updateControls()),
                                        e.trigger("onActivate"),
                                        e.addEvents();
                                },
                                close: function (e, t) {
                                    var i,
                                        a,
                                        o,
                                        r,
                                        s,
                                        l,
                                        c,
                                        d = this,
                                        u = d.current,
                                        f = function () {
                                            d.cleanUp(e);
                                        };
                                    return (
                                        !d.isClosing &&
                                        ((d.isClosing = !0),
                                        !1 === d.trigger("beforeClose", e)
                                            ? ((d.isClosing = !1),
                                              p(function () {
                                                  d.update();
                                              }),
                                              !1)
                                            : (d.removeEvents(),
                                              (o = u.$content),
                                              (i = u.opts.animationEffect),
                                              (a = n.isNumeric(t) ? t : i ? u.opts.animationDuration : 0),
                                              u.$slide.removeClass("fancybox-slide--complete fancybox-slide--next fancybox-slide--previous fancybox-animated"),
                                              !0 !== e ? n.fancybox.stop(u.$slide) : (i = !1),
                                              u.$slide.siblings().trigger("onReset").remove(),
                                              a &&
                                                  d.$refs.container
                                                      .removeClass("fancybox-is-open")
                                                      .addClass("fancybox-is-closing")
                                                      .css("transition-duration", a + "ms"),
                                              d.hideLoading(u),
                                              d.hideControls(!0),
                                              d.updateCursor(),
                                              "zoom" !== i || (o && a && "image" === u.type && !d.isMoved() && !u.hasError && (c = d.getThumbPos(u))) || (i = "fade"),
                                              "zoom" === i
                                                  ? (n.fancybox.stop(o),
                                                    (l = { top: (r = n.fancybox.getTranslate(o)).top, left: r.left, scaleX: r.width / c.width, scaleY: r.height / c.height, width: c.width, height: c.height }),
                                                    "auto" == (s = u.opts.zoomOpacity) && (s = Math.abs(u.width / u.height - c.width / c.height) > 0.1),
                                                    s && (c.opacity = 0),
                                                    n.fancybox.setTranslate(o, l),
                                                    g(o),
                                                    n.fancybox.animate(o, c, a, f),
                                                    !0)
                                                  : (i && a
                                                        ? n.fancybox.animate(u.$slide.addClass("fancybox-slide--previous").removeClass("fancybox-slide--current"), "fancybox-animated fancybox-fx-" + i, a, f)
                                                        : !0 === e
                                                        ? setTimeout(f, a)
                                                        : f(),
                                                    !0)))
                                    );
                                },
                                cleanUp: function (t) {
                                    var i,
                                        a,
                                        o,
                                        r = this,
                                        s = r.current.opts.$orig;
                                    r.current.$slide.trigger("onReset"),
                                        r.$refs.container.empty().remove(),
                                        r.trigger("afterClose", t),
                                        r.current.opts.backFocus &&
                                            ((s && s.length && s.is(":visible")) || (s = r.$trigger), s && s.length && ((a = e.scrollX), (o = e.scrollY), s.trigger("focus"), n("html, body").scrollTop(o).scrollLeft(a))),
                                        (r.current = null),
                                        (i = n.fancybox.getInstance()) ? i.activate() : (n("body").removeClass("fancybox-active compensate-for-scrollbar"), n("#fancybox-style-noscroll").remove());
                                },
                                trigger: function (e, t) {
                                    var i,
                                        a = Array.prototype.slice.call(arguments, 1),
                                        o = this,
                                        r = t && t.opts ? t : o.current;
                                    if ((r ? a.unshift(r) : (r = o), a.unshift(o), n.isFunction(r.opts[e]) && (i = r.opts[e].apply(r, a)), !1 === i)) return i;
                                    "afterClose" !== e && o.$refs ? o.$refs.container.trigger(e + ".fb", a) : d.trigger(e + ".fb", a);
                                },
                                updateControls: function () {
                                    var e = this,
                                        i = e.current,
                                        a = i.index,
                                        o = e.$refs.container,
                                        r = e.$refs.caption,
                                        s = i.opts.caption;
                                    i.$slide.trigger("refresh"),
                                        s && s.length ? ((e.$caption = r), r.children().eq(0).html(s)) : (e.$caption = null),
                                        e.hasHiddenControls || e.isIdle || e.showControls(),
                                        o.find("[data-fancybox-count]").html(e.group.length),
                                        o.find("[data-fancybox-index]").html(a + 1),
                                        o.find("[data-fancybox-prev]").prop("disabled", !i.opts.loop && a <= 0),
                                        o.find("[data-fancybox-next]").prop("disabled", !i.opts.loop && a >= e.group.length - 1),
                                        "image" === i.type
                                            ? o
                                                  .find("[data-fancybox-zoom]")
                                                  .show()
                                                  .end()
                                                  .find("[data-fancybox-download]")
                                                  .attr("href", i.opts.image.src || i.src)
                                                  .show()
                                            : i.opts.toolbar && o.find("[data-fancybox-download],[data-fancybox-zoom]").hide(),
                                        n(t.activeElement).is(":hidden,[disabled]") && e.$refs.container.trigger("focus");
                                },
                                hideControls: function (e) {
                                    var t = ["infobar", "toolbar", "nav"];
                                    (!e && this.current.opts.preventCaptionOverlap) || t.push("caption"),
                                        this.$refs.container.removeClass(
                                            t
                                                .map(function (e) {
                                                    return "fancybox-show-" + e;
                                                })
                                                .join(" ")
                                        ),
                                        (this.hasHiddenControls = !0);
                                },
                                showControls: function () {
                                    var e = this,
                                        t = e.current ? e.current.opts : e.opts,
                                        n = e.$refs.container;
                                    (e.hasHiddenControls = !1),
                                        (e.idleSecondsCounter = 0),
                                        n
                                            .toggleClass("fancybox-show-toolbar", !(!t.toolbar || !t.buttons))
                                            .toggleClass("fancybox-show-infobar", !!(t.infobar && e.group.length > 1))
                                            .toggleClass("fancybox-show-caption", !!e.$caption)
                                            .toggleClass("fancybox-show-nav", !!(t.arrows && e.group.length > 1))
                                            .toggleClass("fancybox-is-modal", !!t.modal);
                                },
                                toggleControls: function () {
                                    this.hasHiddenControls ? this.showControls() : this.hideControls();
                                },
                            }),
                                (n.fancybox = {
                                    version: "3.5.7",
                                    defaults: l,
                                    getInstance: function (e) {
                                        var t = n('.fancybox-container:not(".fancybox-is-closing"):last').data("FancyBox"),
                                            i = Array.prototype.slice.call(arguments, 1);
                                        return t instanceof m && ("string" === n.type(e) ? t[e].apply(t, i) : "function" === n.type(e) && e.apply(t, i), t);
                                    },
                                    open: function (e, t, n) {
                                        return new m(e, t, n);
                                    },
                                    close: function (e) {
                                        var t = this.getInstance();
                                        t && (t.close(), !0 === e && this.close(e));
                                    },
                                    destroy: function () {
                                        this.close(!0), d.add("body").off("click.fb-start", "**");
                                    },
                                    isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
                                    use3d: ((a = t.createElement("div")), e.getComputedStyle && e.getComputedStyle(a) && e.getComputedStyle(a).getPropertyValue("transform") && !(t.documentMode && t.documentMode < 11)),
                                    getTranslate: function (e) {
                                        var t;
                                        return !(!e || !e.length) && { top: (t = e[0].getBoundingClientRect()).top || 0, left: t.left || 0, width: t.width, height: t.height, opacity: parseFloat(e.css("opacity")) };
                                    },
                                    setTranslate: function (e, t) {
                                        var n = "",
                                            a = {};
                                        if (e && t)
                                            return (
                                                (t.left === i && t.top === i) ||
                                                    ((n = (t.left === i ? e.position().left : t.left) + "px, " + (t.top === i ? e.position().top : t.top) + "px"), (n = this.use3d ? "translate3d(" + n + ", 0px)" : "translate(" + n + ")")),
                                                t.scaleX !== i && t.scaleY !== i ? (n += " scale(" + t.scaleX + ", " + t.scaleY + ")") : t.scaleX !== i && (n += " scaleX(" + t.scaleX + ")"),
                                                n.length && (a.transform = n),
                                                t.opacity !== i && (a.opacity = t.opacity),
                                                t.width !== i && (a.width = t.width),
                                                t.height !== i && (a.height = t.height),
                                                e.css(a)
                                            );
                                    },
                                    animate: function (e, t, a, o, r) {
                                        var s,
                                            l = this;
                                        n.isFunction(a) && ((o = a), (a = null)),
                                            l.stop(e),
                                            (s = l.getTranslate(e)),
                                            e.on(h, function (c) {
                                                (!c || !c.originalEvent || (e.is(c.originalEvent.target) && "z-index" != c.originalEvent.propertyName)) &&
                                                    (l.stop(e),
                                                    n.isNumeric(a) && e.css("transition-duration", ""),
                                                    n.isPlainObject(t)
                                                        ? t.scaleX !== i && t.scaleY !== i && l.setTranslate(e, { top: t.top, left: t.left, width: s.width * t.scaleX, height: s.height * t.scaleY, scaleX: 1, scaleY: 1 })
                                                        : !0 !== r && e.removeClass(t),
                                                    n.isFunction(o) && o(c));
                                            }),
                                            n.isNumeric(a) && e.css("transition-duration", a + "ms"),
                                            n.isPlainObject(t)
                                                ? (t.scaleX !== i && t.scaleY !== i && (delete t.width, delete t.height, e.parent().hasClass("fancybox-slide--image") && e.parent().addClass("fancybox-is-scaling")),
                                                  n.fancybox.setTranslate(e, t))
                                                : e.addClass(t),
                                            e.data(
                                                "timer",
                                                setTimeout(function () {
                                                    e.trigger(h);
                                                }, a + 33)
                                            );
                                    },
                                    stop: function (e, t) {
                                        e && e.length && (clearTimeout(e.data("timer")), t && e.trigger(h), e.off(h).css("transition-duration", ""), e.parent().removeClass("fancybox-is-scaling"));
                                    },
                                }),
                                (n.fn.fancybox = function (e) {
                                    var t;
                                    return (
                                        (t = (e = e || {}).selector || !1) ? n("body").off("click.fb-start", t).on("click.fb-start", t, { options: e }, b) : this.off("click.fb-start").on("click.fb-start", { items: this, options: e }, b),
                                        this
                                    );
                                }),
                                d.on("click.fb-start", "[data-fancybox]", b),
                                d.on("click.fb-start", "[data-fancybox-trigger]", function (e) {
                                    n('[data-fancybox="' + n(this).attr("data-fancybox-trigger") + '"]')
                                        .eq(n(this).attr("data-fancybox-index") || 0)
                                        .trigger("click.fb-start", { $trigger: n(this) });
                                }),
                                (o = ".fancybox-button"),
                                (r = "fancybox-focus"),
                                (s = null),
                                d.on("mousedown mouseup focus blur", o, function (e) {
                                    switch (e.type) {
                                        case "mousedown":
                                            s = n(this);
                                            break;
                                        case "mouseup":
                                            s = null;
                                            break;
                                        case "focusin":
                                            n(o).removeClass(r), n(this).is(s) || n(this).is("[disabled]") || n(this).addClass(r);
                                            break;
                                        case "focusout":
                                            n(o).removeClass(r);
                                    }
                                });
                        }
                    function b(e, t) {
                        var i,
                            a,
                            o,
                            r = [],
                            s = 0;
                        (e && e.isDefaultPrevented()) ||
                            (e.preventDefault(),
                            (t = t || {}),
                            e && e.data && (t = v(e.data.options, t)),
                            (i = t.$target || n(e.currentTarget).trigger("blur")),
                            ((o = n.fancybox.getInstance()) && o.$trigger && o.$trigger.is(i)) ||
                                ((r = t.selector ? n(t.selector) : (a = i.attr("data-fancybox") || "") ? ((r = e.data ? e.data.items : []).length ? r.filter('[data-fancybox="' + a + '"]') : n('[data-fancybox="' + a + '"]')) : [i]),
                                (s = n(r).index(i)) < 0 && (s = 0),
                                ((o = n.fancybox.open(r, t, s)).$trigger = i)));
                    }
                })(window, document, jQuery),
                    (function (e) {
                        "use strict";
                        var t = {
                                youtube: {
                                    matcher: /(youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(watch\?(.*&)?v=|v\/|u\/|embed\/?)?(videoseries\?list=(.*)|[\w-]{11}|\?listType=(.*)&list=(.*))(.*)/i,
                                    params: { autoplay: 1, autohide: 1, fs: 1, rel: 0, hd: 1, wmode: "transparent", enablejsapi: 1, html5: 1 },
                                    paramPlace: 8,
                                    type: "iframe",
                                    url: "https://www.youtube-nocookie.com/embed/$4",
                                    thumb: "https://img.youtube.com/vi/$4/hqdefault.jpg",
                                },
                                vimeo: {
                                    matcher: /^.+vimeo.com\/(.*\/)?([\d]+)(.*)?/,
                                    params: { autoplay: 1, hd: 1, show_title: 1, show_byline: 1, show_portrait: 0, fullscreen: 1 },
                                    paramPlace: 3,
                                    type: "iframe",
                                    url: "//player.vimeo.com/video/$2",
                                },
                                instagram: { matcher: /(instagr\.am|instagram\.com)\/p\/([a-zA-Z0-9_\-]+)\/?/i, type: "image", url: "//$1/p/$2/media/?size=l" },
                                gmap_place: {
                                    matcher: /(maps\.)?google\.([a-z]{2,3}(\.[a-z]{2})?)\/(((maps\/(place\/(.*)\/)?\@(.*),(\d+.?\d+?)z))|(\?ll=))(.*)?/i,
                                    type: "iframe",
                                    url: function (e) {
                                        return (
                                            "//maps.google." +
                                            e[2] +
                                            "/?ll=" +
                                            (e[9] ? e[9] + "&z=" + Math.floor(e[10]) + (e[12] ? e[12].replace(/^\//, "&") : "") : e[12] + "").replace(/\?/, "&") +
                                            "&output=" +
                                            (e[12] && e[12].indexOf("layer=c") > 0 ? "svembed" : "embed")
                                        );
                                    },
                                },
                                gmap_search: {
                                    matcher: /(maps\.)?google\.([a-z]{2,3}(\.[a-z]{2})?)\/(maps\/search\/)(.*)/i,
                                    type: "iframe",
                                    url: function (e) {
                                        return "//maps.google." + e[2] + "/maps?q=" + e[5].replace("query=", "q=").replace("api=1", "") + "&output=embed";
                                    },
                                },
                            },
                            n = function (t, n, i) {
                                if (t)
                                    return (
                                        (i = i || ""),
                                        "object" === e.type(i) && (i = e.param(i, !0)),
                                        e.each(n, function (e, n) {
                                            t = t.replace("$" + e, n || "");
                                        }),
                                        i.length && (t += (t.indexOf("?") > 0 ? "&" : "?") + i),
                                        t
                                    );
                            };
                        e(document).on("objectNeedsType.fb", function (i, a, o) {
                            var r,
                                s,
                                l,
                                c,
                                d,
                                u,
                                p,
                                f = o.src || "",
                                h = !1;
                            (r = e.extend(!0, {}, t, o.opts.media)),
                                e.each(r, function (t, i) {
                                    if ((l = f.match(i.matcher))) {
                                        if (((h = i.type), (p = t), (u = {}), i.paramPlace && l[i.paramPlace])) {
                                            "?" == (d = l[i.paramPlace])[0] && (d = d.substring(1)), (d = d.split("&"));
                                            for (var a = 0; a < d.length; ++a) {
                                                var r = d[a].split("=", 2);
                                                2 == r.length && (u[r[0]] = decodeURIComponent(r[1].replace(/\+/g, " ")));
                                            }
                                        }
                                        return (
                                            (c = e.extend(!0, {}, i.params, o.opts[t], u)),
                                            (f = "function" === e.type(i.url) ? i.url.call(this, l, c, o) : n(i.url, l, c)),
                                            (s = "function" === e.type(i.thumb) ? i.thumb.call(this, l, c, o) : n(i.thumb, l)),
                                            "youtube" === t
                                                ? (f = f.replace(/&t=((\d+)m)?(\d+)s/, function (e, t, n, i) {
                                                      return "&start=" + ((n ? 60 * parseInt(n, 10) : 0) + parseInt(i, 10));
                                                  }))
                                                : "vimeo" === t && (f = f.replace("&%23", "#")),
                                            !1
                                        );
                                    }
                                }),
                                h
                                    ? (o.opts.thumb || (o.opts.$thumb && o.opts.$thumb.length) || (o.opts.thumb = s),
                                      "iframe" === h && (o.opts = e.extend(!0, o.opts, { iframe: { preload: !1, attr: { scrolling: "no" } } })),
                                      e.extend(o, { type: h, src: f, origSrc: o.src, contentSource: p, contentType: "image" === h ? "image" : "gmap_place" == p || "gmap_search" == p ? "map" : "video" }))
                                    : f && (o.type = o.opts.defaultType);
                        });
                        var i = {
                            youtube: { src: "https://www.youtube.com/iframe_api", class: "YT", loading: !1, loaded: !1 },
                            vimeo: { src: "https://player.vimeo.com/api/player.js", class: "Vimeo", loading: !1, loaded: !1 },
                            load: function (e) {
                                var t,
                                    n = this;
                                this[e].loaded
                                    ? setTimeout(function () {
                                          n.done(e);
                                      })
                                    : this[e].loading ||
                                      ((this[e].loading = !0),
                                      ((t = document.createElement("script")).type = "text/javascript"),
                                      (t.src = this[e].src),
                                      "youtube" === e
                                          ? (window.onYouTubeIframeAPIReady = function () {
                                                (n[e].loaded = !0), n.done(e);
                                            })
                                          : (t.onload = function () {
                                                (n[e].loaded = !0), n.done(e);
                                            }),
                                      document.body.appendChild(t));
                            },
                            done: function (t) {
                                var n, i;
                                "youtube" === t && delete window.onYouTubeIframeAPIReady,
                                    (n = e.fancybox.getInstance()) &&
                                        ((i = n.current.$content.find("iframe")),
                                        "youtube" === t && void 0 !== YT && YT
                                            ? new YT.Player(i.attr("id"), {
                                                  events: {
                                                      onStateChange: function (e) {
                                                          0 == e.data && n.next();
                                                      },
                                                  },
                                              })
                                            : "vimeo" === t &&
                                              void 0 !== Vimeo &&
                                              Vimeo &&
                                              new Vimeo.Player(i).on("ended", function () {
                                                  n.next();
                                              }));
                            },
                        };
                        e(document).on({
                            "afterShow.fb": function (e, t, n) {
                                t.group.length > 1 && ("youtube" === n.contentSource || "vimeo" === n.contentSource) && i.load(n.contentSource);
                            },
                        });
                    })(jQuery),
                    (function (e, t, n) {
                        "use strict";
                        var i =
                                e.requestAnimationFrame ||
                                e.webkitRequestAnimationFrame ||
                                e.mozRequestAnimationFrame ||
                                e.oRequestAnimationFrame ||
                                function (t) {
                                    return e.setTimeout(t, 1e3 / 60);
                                },
                            a =
                                e.cancelAnimationFrame ||
                                e.webkitCancelAnimationFrame ||
                                e.mozCancelAnimationFrame ||
                                e.oCancelAnimationFrame ||
                                function (t) {
                                    e.clearTimeout(t);
                                },
                            o = function (t) {
                                var n = [];
                                for (var i in (t = (t = t.originalEvent || t || e.e).touches && t.touches.length ? t.touches : t.changedTouches && t.changedTouches.length ? t.changedTouches : [t]))
                                    t[i].pageX ? n.push({ x: t[i].pageX, y: t[i].pageY }) : t[i].clientX && n.push({ x: t[i].clientX, y: t[i].clientY });
                                return n;
                            },
                            r = function (e, t, n) {
                                return t && e ? ("x" === n ? e.x - t.x : "y" === n ? e.y - t.y : Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2))) : 0;
                            },
                            s = function (e) {
                                if (e.is('a,area,button,[role="button"],input,label,select,summary,textarea,video,audio,iframe') || n.isFunction(e.get(0).onclick) || e.data("selectable")) return !0;
                                for (var t = 0, i = e[0].attributes, a = i.length; t < a; t++) if ("data-fancybox-" === i[t].nodeName.substr(0, 14)) return !0;
                                return !1;
                            },
                            l = function (t) {
                                for (
                                    var n, i, a, o, r, s = !1;
                                    (n = t.get(0)),
                                        (i = void 0),
                                        (a = void 0),
                                        (o = void 0),
                                        (r = void 0),
                                        (i = e.getComputedStyle(n)["overflow-y"]),
                                        (a = e.getComputedStyle(n)["overflow-x"]),
                                        (o = ("scroll" === i || "auto" === i) && n.scrollHeight > n.clientHeight),
                                        (r = ("scroll" === a || "auto" === a) && n.scrollWidth > n.clientWidth),
                                        !(s = o || r) && (t = t.parent()).length && !t.hasClass("fancybox-stage") && !t.is("body");

                                );
                                return s;
                            },
                            c = function (e) {
                                var t = this;
                                (t.instance = e), (t.$bg = e.$refs.bg), (t.$stage = e.$refs.stage), (t.$container = e.$refs.container), t.destroy(), t.$container.on("touchstart.fb.touch mousedown.fb.touch", n.proxy(t, "ontouchstart"));
                            };
                        (c.prototype.destroy = function () {
                            var e = this;
                            e.$container.off(".fb.touch"), n(t).off(".fb.touch"), e.requestId && (a(e.requestId), (e.requestId = null)), e.tapped && (clearTimeout(e.tapped), (e.tapped = null));
                        }),
                            (c.prototype.ontouchstart = function (i) {
                                var a = this,
                                    c = n(i.target),
                                    d = a.instance,
                                    u = d.current,
                                    p = u.$slide,
                                    f = u.$content,
                                    h = "touchstart" == i.type;
                                if (
                                    (h && a.$container.off("mousedown.fb.touch"),
                                    (!i.originalEvent || 2 != i.originalEvent.button) && p.length && c.length && !s(c) && !s(c.parent()) && (c.is("img") || !(i.originalEvent.clientX > c[0].clientWidth + c.offset().left)))
                                ) {
                                    if (!u || d.isAnimating || u.$slide.hasClass("fancybox-animated")) return i.stopPropagation(), void i.preventDefault();
                                    (a.realPoints = a.startPoints = o(i)),
                                        a.startPoints.length &&
                                            (u.touch && i.stopPropagation(),
                                            (a.startEvent = i),
                                            (a.canTap = !0),
                                            (a.$target = c),
                                            (a.$content = f),
                                            (a.opts = u.opts.touch),
                                            (a.isPanning = !1),
                                            (a.isSwiping = !1),
                                            (a.isZooming = !1),
                                            (a.isScrolling = !1),
                                            (a.canPan = d.canPan()),
                                            (a.startTime = new Date().getTime()),
                                            (a.distanceX = a.distanceY = a.distance = 0),
                                            (a.canvasWidth = Math.round(p[0].clientWidth)),
                                            (a.canvasHeight = Math.round(p[0].clientHeight)),
                                            (a.contentLastPos = null),
                                            (a.contentStartPos = n.fancybox.getTranslate(a.$content) || { top: 0, left: 0 }),
                                            (a.sliderStartPos = n.fancybox.getTranslate(p)),
                                            (a.stagePos = n.fancybox.getTranslate(d.$refs.stage)),
                                            (a.sliderStartPos.top -= a.stagePos.top),
                                            (a.sliderStartPos.left -= a.stagePos.left),
                                            (a.contentStartPos.top -= a.stagePos.top),
                                            (a.contentStartPos.left -= a.stagePos.left),
                                            n(t)
                                                .off(".fb.touch")
                                                .on(h ? "touchend.fb.touch touchcancel.fb.touch" : "mouseup.fb.touch mouseleave.fb.touch", n.proxy(a, "ontouchend"))
                                                .on(h ? "touchmove.fb.touch" : "mousemove.fb.touch", n.proxy(a, "ontouchmove")),
                                            n.fancybox.isMobile && t.addEventListener("scroll", a.onscroll, !0),
                                            (((a.opts || a.canPan) && (c.is(a.$stage) || a.$stage.find(c).length)) || (c.is(".fancybox-image") && i.preventDefault(), n.fancybox.isMobile && c.parents(".fancybox-caption").length)) &&
                                                ((a.isScrollable = l(c) || l(c.parent())),
                                                (n.fancybox.isMobile && a.isScrollable) || i.preventDefault(),
                                                (1 === a.startPoints.length || u.hasError) && (a.canPan ? (n.fancybox.stop(a.$content), (a.isPanning = !0)) : (a.isSwiping = !0), a.$container.addClass("fancybox-is-grabbing")),
                                                2 === a.startPoints.length &&
                                                    "image" === u.type &&
                                                    (u.isLoaded || u.$ghost) &&
                                                    ((a.canTap = !1),
                                                    (a.isSwiping = !1),
                                                    (a.isPanning = !1),
                                                    (a.isZooming = !0),
                                                    n.fancybox.stop(a.$content),
                                                    (a.centerPointStartX = 0.5 * (a.startPoints[0].x + a.startPoints[1].x) - n(e).scrollLeft()),
                                                    (a.centerPointStartY = 0.5 * (a.startPoints[0].y + a.startPoints[1].y) - n(e).scrollTop()),
                                                    (a.percentageOfImageAtPinchPointX = (a.centerPointStartX - a.contentStartPos.left) / a.contentStartPos.width),
                                                    (a.percentageOfImageAtPinchPointY = (a.centerPointStartY - a.contentStartPos.top) / a.contentStartPos.height),
                                                    (a.startDistanceBetweenFingers = r(a.startPoints[0], a.startPoints[1])))));
                                }
                            }),
                            (c.prototype.onscroll = function (e) {
                                (this.isScrolling = !0), t.removeEventListener("scroll", this.onscroll, !0);
                            }),
                            (c.prototype.ontouchmove = function (e) {
                                var t = this;
                                void 0 === e.originalEvent.buttons || 0 !== e.originalEvent.buttons
                                    ? t.isScrolling
                                        ? (t.canTap = !1)
                                        : ((t.newPoints = o(e)),
                                          (t.opts || t.canPan) &&
                                              t.newPoints.length &&
                                              t.newPoints.length &&
                                              ((t.isSwiping && !0 === t.isSwiping) || e.preventDefault(),
                                              (t.distanceX = r(t.newPoints[0], t.startPoints[0], "x")),
                                              (t.distanceY = r(t.newPoints[0], t.startPoints[0], "y")),
                                              (t.distance = r(t.newPoints[0], t.startPoints[0])),
                                              t.distance > 0 && (t.isSwiping ? t.onSwipe(e) : t.isPanning ? t.onPan() : t.isZooming && t.onZoom())))
                                    : t.ontouchend(e);
                            }),
                            (c.prototype.onSwipe = function (t) {
                                var o,
                                    r = this,
                                    s = r.instance,
                                    l = r.isSwiping,
                                    c = r.sliderStartPos.left || 0;
                                if (!0 !== l)
                                    "x" == l &&
                                        (r.distanceX > 0 && (r.instance.group.length < 2 || (0 === r.instance.current.index && !r.instance.current.opts.loop))
                                            ? (c += Math.pow(r.distanceX, 0.8))
                                            : r.distanceX < 0 && (r.instance.group.length < 2 || (r.instance.current.index === r.instance.group.length - 1 && !r.instance.current.opts.loop))
                                            ? (c -= Math.pow(-r.distanceX, 0.8))
                                            : (c += r.distanceX)),
                                        (r.sliderLastPos = { top: "x" == l ? 0 : r.sliderStartPos.top + r.distanceY, left: c }),
                                        r.requestId && (a(r.requestId), (r.requestId = null)),
                                        (r.requestId = i(function () {
                                            r.sliderLastPos &&
                                                (n.each(r.instance.slides, function (e, t) {
                                                    var i = t.pos - r.instance.currPos;
                                                    n.fancybox.setTranslate(t.$slide, { top: r.sliderLastPos.top, left: r.sliderLastPos.left + i * r.canvasWidth + i * t.opts.gutter });
                                                }),
                                                r.$container.addClass("fancybox-is-sliding"));
                                        }));
                                else if (Math.abs(r.distance) > 10) {
                                    if (
                                        ((r.canTap = !1),
                                        s.group.length < 2 && r.opts.vertical
                                            ? (r.isSwiping = "y")
                                            : s.isDragging || !1 === r.opts.vertical || ("auto" === r.opts.vertical && n(e).width() > 800)
                                            ? (r.isSwiping = "x")
                                            : ((o = Math.abs((180 * Math.atan2(r.distanceY, r.distanceX)) / Math.PI)), (r.isSwiping = o > 45 && o < 135 ? "y" : "x")),
                                        "y" === r.isSwiping && n.fancybox.isMobile && r.isScrollable)
                                    )
                                        return void (r.isScrolling = !0);
                                    (s.isDragging = r.isSwiping),
                                        (r.startPoints = r.newPoints),
                                        n.each(s.slides, function (e, t) {
                                            var i, a;
                                            n.fancybox.stop(t.$slide),
                                                (i = n.fancybox.getTranslate(t.$slide)),
                                                (a = n.fancybox.getTranslate(s.$refs.stage)),
                                                t.$slide
                                                    .css({ transform: "", opacity: "", "transition-duration": "" })
                                                    .removeClass("fancybox-animated")
                                                    .removeClass(function (e, t) {
                                                        return (t.match(/(^|\s)fancybox-fx-\S+/g) || []).join(" ");
                                                    }),
                                                t.pos === s.current.pos && ((r.sliderStartPos.top = i.top - a.top), (r.sliderStartPos.left = i.left - a.left)),
                                                n.fancybox.setTranslate(t.$slide, { top: i.top - a.top, left: i.left - a.left });
                                        }),
                                        s.SlideShow && s.SlideShow.isActive && s.SlideShow.stop();
                                }
                            }),
                            (c.prototype.onPan = function () {
                                var e = this;
                                r(e.newPoints[0], e.realPoints[0]) < (n.fancybox.isMobile ? 10 : 5)
                                    ? (e.startPoints = e.newPoints)
                                    : ((e.canTap = !1),
                                      (e.contentLastPos = e.limitMovement()),
                                      e.requestId && a(e.requestId),
                                      (e.requestId = i(function () {
                                          n.fancybox.setTranslate(e.$content, e.contentLastPos);
                                      })));
                            }),
                            (c.prototype.limitMovement = function () {
                                var e,
                                    t,
                                    n,
                                    i,
                                    a,
                                    o,
                                    r = this,
                                    s = r.canvasWidth,
                                    l = r.canvasHeight,
                                    c = r.distanceX,
                                    d = r.distanceY,
                                    u = r.contentStartPos,
                                    p = u.left,
                                    f = u.top,
                                    h = u.width,
                                    g = u.height;
                                return (
                                    (a = h > s ? p + c : p),
                                    (o = f + d),
                                    (e = Math.max(0, 0.5 * s - 0.5 * h)),
                                    (t = Math.max(0, 0.5 * l - 0.5 * g)),
                                    (n = Math.min(s - h, 0.5 * s - 0.5 * h)),
                                    (i = Math.min(l - g, 0.5 * l - 0.5 * g)),
                                    c > 0 && a > e && (a = e - 1 + Math.pow(-e + p + c, 0.8) || 0),
                                    c < 0 && a < n && (a = n + 1 - Math.pow(n - p - c, 0.8) || 0),
                                    d > 0 && o > t && (o = t - 1 + Math.pow(-t + f + d, 0.8) || 0),
                                    d < 0 && o < i && (o = i + 1 - Math.pow(i - f - d, 0.8) || 0),
                                    { top: o, left: a }
                                );
                            }),
                            (c.prototype.limitPosition = function (e, t, n, i) {
                                var a = this.canvasWidth,
                                    o = this.canvasHeight;
                                return (e = n > a ? ((e = e > 0 ? 0 : e) < a - n ? a - n : e) : Math.max(0, a / 2 - n / 2)), { top: (t = i > o ? ((t = t > 0 ? 0 : t) < o - i ? o - i : t) : Math.max(0, o / 2 - i / 2)), left: e };
                            }),
                            (c.prototype.onZoom = function () {
                                var t = this,
                                    o = t.contentStartPos,
                                    s = o.width,
                                    l = o.height,
                                    c = o.left,
                                    d = o.top,
                                    u = r(t.newPoints[0], t.newPoints[1]) / t.startDistanceBetweenFingers,
                                    p = Math.floor(s * u),
                                    f = Math.floor(l * u),
                                    h = (s - p) * t.percentageOfImageAtPinchPointX,
                                    g = (l - f) * t.percentageOfImageAtPinchPointY,
                                    v = (t.newPoints[0].x + t.newPoints[1].x) / 2 - n(e).scrollLeft(),
                                    m = (t.newPoints[0].y + t.newPoints[1].y) / 2 - n(e).scrollTop(),
                                    b = v - t.centerPointStartX,
                                    w = { top: d + (g + (m - t.centerPointStartY)), left: c + (h + b), scaleX: u, scaleY: u };
                                (t.canTap = !1),
                                    (t.newWidth = p),
                                    (t.newHeight = f),
                                    (t.contentLastPos = w),
                                    t.requestId && a(t.requestId),
                                    (t.requestId = i(function () {
                                        n.fancybox.setTranslate(t.$content, t.contentLastPos);
                                    }));
                            }),
                            (c.prototype.ontouchend = function (e) {
                                var i = this,
                                    r = i.isSwiping,
                                    s = i.isPanning,
                                    l = i.isZooming,
                                    c = i.isScrolling;
                                if (
                                    ((i.endPoints = o(e)),
                                    (i.dMs = Math.max(new Date().getTime() - i.startTime, 1)),
                                    i.$container.removeClass("fancybox-is-grabbing"),
                                    n(t).off(".fb.touch"),
                                    t.removeEventListener("scroll", i.onscroll, !0),
                                    i.requestId && (a(i.requestId), (i.requestId = null)),
                                    (i.isSwiping = !1),
                                    (i.isPanning = !1),
                                    (i.isZooming = !1),
                                    (i.isScrolling = !1),
                                    (i.instance.isDragging = !1),
                                    i.canTap)
                                )
                                    return i.onTap(e);
                                (i.speed = 100), (i.velocityX = (i.distanceX / i.dMs) * 0.5), (i.velocityY = (i.distanceY / i.dMs) * 0.5), s ? i.endPanning() : l ? i.endZooming() : i.endSwiping(r, c);
                            }),
                            (c.prototype.endSwiping = function (e, t) {
                                var i = this,
                                    a = !1,
                                    o = i.instance.group.length,
                                    r = Math.abs(i.distanceX),
                                    s = "x" == e && o > 1 && ((i.dMs > 130 && r > 10) || r > 50);
                                (i.sliderLastPos = null),
                                    "y" == e && !t && Math.abs(i.distanceY) > 50
                                        ? (n.fancybox.animate(i.instance.current.$slide, { top: i.sliderStartPos.top + i.distanceY + 150 * i.velocityY, opacity: 0 }, 200), (a = i.instance.close(!0, 250)))
                                        : s && i.distanceX > 0
                                        ? (a = i.instance.previous(300))
                                        : s && i.distanceX < 0 && (a = i.instance.next(300)),
                                    !1 !== a || ("x" != e && "y" != e) || i.instance.centerSlide(200),
                                    i.$container.removeClass("fancybox-is-sliding");
                            }),
                            (c.prototype.endPanning = function () {
                                var e,
                                    t,
                                    i,
                                    a = this;
                                a.contentLastPos &&
                                    (!1 === a.opts.momentum || a.dMs > 350 ? ((e = a.contentLastPos.left), (t = a.contentLastPos.top)) : ((e = a.contentLastPos.left + 500 * a.velocityX), (t = a.contentLastPos.top + 500 * a.velocityY)),
                                    ((i = a.limitPosition(e, t, a.contentStartPos.width, a.contentStartPos.height)).width = a.contentStartPos.width),
                                    (i.height = a.contentStartPos.height),
                                    n.fancybox.animate(a.$content, i, 366));
                            }),
                            (c.prototype.endZooming = function () {
                                var e,
                                    t,
                                    i,
                                    a,
                                    o = this,
                                    r = o.instance.current,
                                    s = o.newWidth,
                                    l = o.newHeight;
                                o.contentLastPos &&
                                    ((e = o.contentLastPos.left),
                                    (a = { top: (t = o.contentLastPos.top), left: e, width: s, height: l, scaleX: 1, scaleY: 1 }),
                                    n.fancybox.setTranslate(o.$content, a),
                                    s < o.canvasWidth && l < o.canvasHeight
                                        ? o.instance.scaleToFit(150)
                                        : s > r.width || l > r.height
                                        ? o.instance.scaleToActual(o.centerPointStartX, o.centerPointStartY, 150)
                                        : ((i = o.limitPosition(e, t, s, l)), n.fancybox.animate(o.$content, i, 150)));
                            }),
                            (c.prototype.onTap = function (t) {
                                var i,
                                    a = this,
                                    r = n(t.target),
                                    s = a.instance,
                                    l = s.current,
                                    c = (t && o(t)) || a.startPoints,
                                    d = c[0] ? c[0].x - n(e).scrollLeft() - a.stagePos.left : 0,
                                    u = c[0] ? c[0].y - n(e).scrollTop() - a.stagePos.top : 0,
                                    p = function (e) {
                                        var i = l.opts[e];
                                        if ((n.isFunction(i) && (i = i.apply(s, [l, t])), i))
                                            switch (i) {
                                                case "close":
                                                    s.close(a.startEvent);
                                                    break;
                                                case "toggleControls":
                                                    s.toggleControls();
                                                    break;
                                                case "next":
                                                    s.next();
                                                    break;
                                                case "nextOrClose":
                                                    s.group.length > 1 ? s.next() : s.close(a.startEvent);
                                                    break;
                                                case "zoom":
                                                    "image" == l.type && (l.isLoaded || l.$ghost) && (s.canPan() ? s.scaleToFit() : s.isScaledDown() ? s.scaleToActual(d, u) : s.group.length < 2 && s.close(a.startEvent));
                                            }
                                    };
                                if ((!t.originalEvent || 2 != t.originalEvent.button) && (r.is("img") || !(d > r[0].clientWidth + r.offset().left))) {
                                    if (r.is(".fancybox-bg,.fancybox-inner,.fancybox-outer,.fancybox-container")) i = "Outside";
                                    else if (r.is(".fancybox-slide")) i = "Slide";
                                    else {
                                        if (!s.current.$content || !s.current.$content.find(r).addBack().filter(r).length) return;
                                        i = "Content";
                                    }
                                    if (a.tapped) {
                                        if ((clearTimeout(a.tapped), (a.tapped = null), Math.abs(d - a.tapX) > 50 || Math.abs(u - a.tapY) > 50)) return this;
                                        p("dblclick" + i);
                                    } else
                                        (a.tapX = d),
                                            (a.tapY = u),
                                            l.opts["dblclick" + i] && l.opts["dblclick" + i] !== l.opts["click" + i]
                                                ? (a.tapped = setTimeout(function () {
                                                      (a.tapped = null), s.isAnimating || p("click" + i);
                                                  }, 500))
                                                : p("click" + i);
                                    return this;
                                }
                            }),
                            n(t)
                                .on("onActivate.fb", function (e, t) {
                                    t && !t.Guestures && (t.Guestures = new c(t));
                                })
                                .on("beforeClose.fb", function (e, t) {
                                    t && t.Guestures && t.Guestures.destroy();
                                });
                    })(window, document, jQuery),
                    (function (e, t) {
                        "use strict";
                        t.extend(!0, t.fancybox.defaults, {
                            btnTpl: {
                                slideShow:
                                    '<button data-fancybox-play class="fancybox-button fancybox-button--play" title="{{PLAY_START}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M6.5 5.4v13.2l11-6.6z"/></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M8.33 5.75h2.2v12.5h-2.2V5.75zm5.15 0h2.2v12.5h-2.2V5.75z"/></svg></button>',
                            },
                            slideShow: { autoStart: !1, speed: 3e3, progress: !0 },
                        });
                        var n = function (e) {
                            (this.instance = e), this.init();
                        };
                        t.extend(n.prototype, {
                            timer: null,
                            isActive: !1,
                            $button: null,
                            init: function () {
                                var e = this,
                                    n = e.instance,
                                    i = n.group[n.currIndex].opts.slideShow;
                                (e.$button = n.$refs.toolbar.find("[data-fancybox-play]").on("click", function () {
                                    e.toggle();
                                })),
                                    n.group.length < 2 || !i ? e.$button.hide() : i.progress && (e.$progress = t('<div class="fancybox-progress"></div>').appendTo(n.$refs.inner));
                            },
                            set: function (e) {
                                var n = this,
                                    i = n.instance,
                                    a = i.current;
                                a && (!0 === e || a.opts.loop || i.currIndex < i.group.length - 1)
                                    ? n.isActive &&
                                      "video" !== a.contentType &&
                                      (n.$progress && t.fancybox.animate(n.$progress.show(), { scaleX: 1 }, a.opts.slideShow.speed),
                                      (n.timer = setTimeout(function () {
                                          i.current.opts.loop || i.current.index != i.group.length - 1 ? i.next() : i.jumpTo(0);
                                      }, a.opts.slideShow.speed)))
                                    : (n.stop(), (i.idleSecondsCounter = 0), i.showControls());
                            },
                            clear: function () {
                                var e = this;
                                clearTimeout(e.timer), (e.timer = null), e.$progress && e.$progress.removeAttr("style").hide();
                            },
                            start: function () {
                                var e = this,
                                    t = e.instance.current;
                                t &&
                                    (e.$button
                                        .attr("title", (t.opts.i18n[t.opts.lang] || t.opts.i18n.en).PLAY_STOP)
                                        .removeClass("fancybox-button--play")
                                        .addClass("fancybox-button--pause"),
                                    (e.isActive = !0),
                                    t.isComplete && e.set(!0),
                                    e.instance.trigger("onSlideShowChange", !0));
                            },
                            stop: function () {
                                var e = this,
                                    t = e.instance.current;
                                e.clear(),
                                    e.$button
                                        .attr("title", (t.opts.i18n[t.opts.lang] || t.opts.i18n.en).PLAY_START)
                                        .removeClass("fancybox-button--pause")
                                        .addClass("fancybox-button--play"),
                                    (e.isActive = !1),
                                    e.instance.trigger("onSlideShowChange", !1),
                                    e.$progress && e.$progress.removeAttr("style").hide();
                            },
                            toggle: function () {
                                var e = this;
                                e.isActive ? e.stop() : e.start();
                            },
                        }),
                            t(e).on({
                                "onInit.fb": function (e, t) {
                                    t && !t.SlideShow && (t.SlideShow = new n(t));
                                },
                                "beforeShow.fb": function (e, t, n, i) {
                                    var a = t && t.SlideShow;
                                    i ? a && n.opts.slideShow.autoStart && a.start() : a && a.isActive && a.clear();
                                },
                                "afterShow.fb": function (e, t, n) {
                                    var i = t && t.SlideShow;
                                    i && i.isActive && i.set();
                                },
                                "afterKeydown.fb": function (n, i, a, o, r) {
                                    var s = i && i.SlideShow;
                                    !s || !a.opts.slideShow || (80 !== r && 32 !== r) || t(e.activeElement).is("button,a,input") || (o.preventDefault(), s.toggle());
                                },
                                "beforeClose.fb onDeactivate.fb": function (e, t) {
                                    var n = t && t.SlideShow;
                                    n && n.stop();
                                },
                            }),
                            t(e).on("visibilitychange", function () {
                                var n = t.fancybox.getInstance(),
                                    i = n && n.SlideShow;
                                i && i.isActive && (e.hidden ? i.clear() : i.set());
                            });
                    })(document, jQuery),
                    (function (e, t) {
                        "use strict";
                        var n = (function () {
                            for (
                                var t = [
                                        ["requestFullscreen", "exitFullscreen", "fullscreenElement", "fullscreenEnabled", "fullscreenchange", "fullscreenerror"],
                                        ["webkitRequestFullscreen", "webkitExitFullscreen", "webkitFullscreenElement", "webkitFullscreenEnabled", "webkitfullscreenchange", "webkitfullscreenerror"],
                                        ["webkitRequestFullScreen", "webkitCancelFullScreen", "webkitCurrentFullScreenElement", "webkitCancelFullScreen", "webkitfullscreenchange", "webkitfullscreenerror"],
                                        ["mozRequestFullScreen", "mozCancelFullScreen", "mozFullScreenElement", "mozFullScreenEnabled", "mozfullscreenchange", "mozfullscreenerror"],
                                        ["msRequestFullscreen", "msExitFullscreen", "msFullscreenElement", "msFullscreenEnabled", "MSFullscreenChange", "MSFullscreenError"],
                                    ],
                                    n = {},
                                    i = 0;
                                i < t.length;
                                i++
                            ) {
                                var a = t[i];
                                if (a && a[1] in e) {
                                    for (var o = 0; o < a.length; o++) n[t[0][o]] = a[o];
                                    return n;
                                }
                            }
                            return !1;
                        })();
                        if (n) {
                            var i = {
                                request: function (t) {
                                    (t = t || e.documentElement)[n.requestFullscreen](t.ALLOW_KEYBOARD_INPUT);
                                },
                                exit: function () {
                                    e[n.exitFullscreen]();
                                },
                                toggle: function (t) {
                                    (t = t || e.documentElement), this.isFullscreen() ? this.exit() : this.request(t);
                                },
                                isFullscreen: function () {
                                    return Boolean(e[n.fullscreenElement]);
                                },
                                enabled: function () {
                                    return Boolean(e[n.fullscreenEnabled]);
                                },
                            };
                            t.extend(!0, t.fancybox.defaults, {
                                btnTpl: {
                                    fullScreen:
                                        '<button data-fancybox-fullscreen class="fancybox-button fancybox-button--fsenter" title="{{FULL_SCREEN}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 16h3v3h2v-5H5zm3-8H5v2h5V5H8zm6 11h2v-3h3v-2h-5zm2-11V5h-2v5h5V8z"/></svg></button>',
                                },
                                fullScreen: { autoStart: !1 },
                            }),
                                t(e).on(n.fullscreenchange, function () {
                                    var e = i.isFullscreen(),
                                        n = t.fancybox.getInstance();
                                    n &&
                                        (n.current && "image" === n.current.type && n.isAnimating && ((n.isAnimating = !1), n.update(!0, !0, 0), n.isComplete || n.complete()),
                                        n.trigger("onFullscreenChange", e),
                                        n.$refs.container.toggleClass("fancybox-is-fullscreen", e),
                                        n.$refs.toolbar.find("[data-fancybox-fullscreen]").toggleClass("fancybox-button--fsenter", !e).toggleClass("fancybox-button--fsexit", e));
                                });
                        }
                        t(e).on({
                            "onInit.fb": function (e, t) {
                                n
                                    ? t && t.group[t.currIndex].opts.fullScreen
                                        ? (t.$refs.container.on("click.fb-fullscreen", "[data-fancybox-fullscreen]", function (e) {
                                              e.stopPropagation(), e.preventDefault(), i.toggle();
                                          }),
                                          t.opts.fullScreen && !0 === t.opts.fullScreen.autoStart && i.request(),
                                          (t.FullScreen = i))
                                        : t && t.$refs.toolbar.find("[data-fancybox-fullscreen]").hide()
                                    : t.$refs.toolbar.find("[data-fancybox-fullscreen]").remove();
                            },
                            "afterKeydown.fb": function (e, t, n, i, a) {
                                t && t.FullScreen && 70 === a && (i.preventDefault(), t.FullScreen.toggle());
                            },
                            "beforeClose.fb": function (e, t) {
                                t && t.FullScreen && t.$refs.container.hasClass("fancybox-is-fullscreen") && i.exit();
                            },
                        });
                    })(document, jQuery),
                    (function (e, t) {
                        "use strict";
                        var n = "fancybox-thumbs",
                            i = n + "-active";
                        t.fancybox.defaults = t.extend(
                            !0,
                            {
                                btnTpl: {
                                    thumbs:
                                        '<button data-fancybox-thumbs class="fancybox-button fancybox-button--thumbs" title="{{THUMBS}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M14.59 14.59h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76H5.65v-3.76zm8.94-4.47h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76H5.65v-3.76zm8.94-4.47h3.76v3.76h-3.76V5.65zm-4.47 0h3.76v3.76h-3.76V5.65zm-4.47 0h3.76v3.76H5.65V5.65z"/></svg></button>',
                                },
                                thumbs: { autoStart: !1, hideOnClose: !0, parentEl: ".fancybox-container", axis: "y" },
                            },
                            t.fancybox.defaults
                        );
                        var a = function (e) {
                            this.init(e);
                        };
                        t.extend(a.prototype, {
                            $button: null,
                            $grid: null,
                            $list: null,
                            isVisible: !1,
                            isActive: !1,
                            init: function (e) {
                                var t = this,
                                    n = e.group,
                                    i = 0;
                                (t.instance = e), (t.opts = n[e.currIndex].opts.thumbs), (e.Thumbs = t), (t.$button = e.$refs.toolbar.find("[data-fancybox-thumbs]"));
                                for (var a = 0, o = n.length; a < o && (n[a].thumb && i++, !(i > 1)); a++);
                                i > 1 && t.opts
                                    ? (t.$button.removeAttr("style").on("click", function () {
                                          t.toggle();
                                      }),
                                      (t.isActive = !0))
                                    : t.$button.hide();
                            },
                            create: function () {
                                var e,
                                    i = this,
                                    a = i.instance,
                                    o = i.opts.parentEl,
                                    r = [];
                                i.$grid ||
                                    ((i.$grid = t('<div class="' + n + " " + n + "-" + i.opts.axis + '"></div>').appendTo(a.$refs.container.find(o).addBack().filter(o))),
                                    i.$grid.on("click", "a", function () {
                                        a.jumpTo(t(this).attr("data-index"));
                                    })),
                                    i.$list || (i.$list = t('<div class="' + n + '__list">').appendTo(i.$grid)),
                                    t.each(a.group, function (t, n) {
                                        (e = n.thumb) || "image" !== n.type || (e = n.src),
                                            r.push('<a href="javascript:;" tabindex="0" data-index="' + t + '"' + (e && e.length ? ' style="background-image:url(' + e + ')"' : 'class="fancybox-thumbs-missing"') + "></a>");
                                    }),
                                    (i.$list[0].innerHTML = r.join("")),
                                    "x" === i.opts.axis && i.$list.width(parseInt(i.$grid.css("padding-right"), 10) + a.group.length * i.$list.children().eq(0).outerWidth(!0));
                            },
                            focus: function (e) {
                                var t,
                                    n,
                                    a = this,
                                    o = a.$list,
                                    r = a.$grid;
                                a.instance.current &&
                                    ((n = (t = o
                                        .children()
                                        .removeClass(i)
                                        .filter('[data-index="' + a.instance.current.index + '"]')
                                        .addClass(i)).position()),
                                    "y" === a.opts.axis && (n.top < 0 || n.top > o.height() - t.outerHeight())
                                        ? o.stop().animate({ scrollTop: o.scrollTop() + n.top }, e)
                                        : "x" === a.opts.axis && (n.left < r.scrollLeft() || n.left > r.scrollLeft() + (r.width() - t.outerWidth())) && o.parent().stop().animate({ scrollLeft: n.left }, e));
                            },
                            update: function () {
                                var e = this;
                                e.instance.$refs.container.toggleClass("fancybox-show-thumbs", this.isVisible),
                                    e.isVisible ? (e.$grid || e.create(), e.instance.trigger("onThumbsShow"), e.focus(0)) : e.$grid && e.instance.trigger("onThumbsHide"),
                                    e.instance.update();
                            },
                            hide: function () {
                                (this.isVisible = !1), this.update();
                            },
                            show: function () {
                                (this.isVisible = !0), this.update();
                            },
                            toggle: function () {
                                (this.isVisible = !this.isVisible), this.update();
                            },
                        }),
                            t(e).on({
                                "onInit.fb": function (e, t) {
                                    var n;
                                    t && !t.Thumbs && (n = new a(t)).isActive && !0 === n.opts.autoStart && n.show();
                                },
                                "beforeShow.fb": function (e, t, n, i) {
                                    var a = t && t.Thumbs;
                                    a && a.isVisible && a.focus(i ? 0 : 250);
                                },
                                "afterKeydown.fb": function (e, t, n, i, a) {
                                    var o = t && t.Thumbs;
                                    o && o.isActive && 71 === a && (i.preventDefault(), o.toggle());
                                },
                                "beforeClose.fb": function (e, t) {
                                    var n = t && t.Thumbs;
                                    n && n.isVisible && !1 !== n.opts.hideOnClose && n.$grid.hide();
                                },
                            });
                    })(document, jQuery),
                    (function (e, t) {
                        "use strict";
                        t.extend(!0, t.fancybox.defaults, {
                            btnTpl: {
                                share:
                                    '<button data-fancybox-share class="fancybox-button fancybox-button--share" title="{{SHARE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M2.55 19c1.4-8.4 9.1-9.8 11.9-9.8V5l7 7-7 6.3v-3.5c-2.8 0-10.5 2.1-11.9 4.2z"/></svg></button>',
                            },
                            share: {
                                url: function (e, t) {
                                    return (!e.currentHash && "inline" !== t.type && "html" !== t.type && (t.origSrc || t.src)) || window.location;
                                },
                                tpl:
                                    '<div class="fancybox-share"><h1>{{SHARE}}</h1><p><a class="fancybox-share__button fancybox-share__button--fb" href="https://www.facebook.com/sharer/sharer.php?u={{url}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m287 456v-299c0-21 6-35 35-35h38v-63c-7-1-29-3-55-3-54 0-91 33-91 94v306m143-254h-205v72h196" /></svg><span>Facebook</span></a><a class="fancybox-share__button fancybox-share__button--tw" href="https://twitter.com/intent/tweet?url={{url}}&text={{descr}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m456 133c-14 7-31 11-47 13 17-10 30-27 37-46-15 10-34 16-52 20-61-62-157-7-141 75-68-3-129-35-169-85-22 37-11 86 26 109-13 0-26-4-37-9 0 39 28 72 65 80-12 3-25 4-37 2 10 33 41 57 77 57-42 30-77 38-122 34 170 111 378-32 359-208 16-11 30-25 41-42z" /></svg><span>Twitter</span></a><a class="fancybox-share__button fancybox-share__button--pt" href="https://www.pinterest.com/pin/create/button/?url={{url}}&description={{descr}}&media={{media}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m265 56c-109 0-164 78-164 144 0 39 15 74 47 87 5 2 10 0 12-5l4-19c2-6 1-8-3-13-9-11-15-25-15-45 0-58 43-110 113-110 62 0 96 38 96 88 0 67-30 122-73 122-24 0-42-19-36-44 6-29 20-60 20-81 0-19-10-35-31-35-25 0-44 26-44 60 0 21 7 36 7 36l-30 125c-8 37-1 83 0 87 0 3 4 4 5 2 2-3 32-39 42-75l16-64c8 16 31 29 56 29 74 0 124-67 124-157 0-69-58-132-146-132z" fill="#fff"/></svg><span>Pinterest</span></a></p><p><input class="fancybox-share__input" type="text" value="{{url_raw}}" onclick="select()" /></p></div>',
                            },
                        }),
                            t(e).on("click", "[data-fancybox-share]", function () {
                                var e,
                                    n,
                                    i,
                                    a,
                                    o = t.fancybox.getInstance(),
                                    r = o.current || null;
                                r &&
                                    ("function" === t.type(r.opts.share.url) && (e = r.opts.share.url.apply(r, [o, r])),
                                    (n = r.opts.share.tpl
                                        .replace(/\{\{media\}\}/g, "image" === r.type ? encodeURIComponent(r.src) : "")
                                        .replace(/\{\{url\}\}/g, encodeURIComponent(e))
                                        .replace(
                                            /\{\{url_raw\}\}/g,
                                            ((i = e),
                                            (a = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;", "/": "&#x2F;", "`": "&#x60;", "=": "&#x3D;" }),
                                            String(i).replace(/[&<>"'`=\/]/g, function (e) {
                                                return a[e];
                                            }))
                                        )
                                        .replace(/\{\{descr\}\}/g, o.$caption ? encodeURIComponent(o.$caption.text()) : "")),
                                    t.fancybox.open({
                                        src: o.translate(o, n),
                                        type: "html",
                                        opts: {
                                            touch: !1,
                                            animationEffect: !1,
                                            afterLoad: function (e, t) {
                                                o.$refs.container.one("beforeClose.fb", function () {
                                                    e.close(null, 0);
                                                }),
                                                    t.$content.find(".fancybox-share__button").click(function () {
                                                        return window.open(this.href, "Share", "width=550, height=450"), !1;
                                                    });
                                            },
                                            mobile: { autoFocus: !1 },
                                        },
                                    }));
                            });
                    })(document, jQuery),
                    (function (e, t, n) {
                        "use strict";
                        function i() {
                            var t = e.location.hash.substr(1),
                                n = t.split("-"),
                                i = (n.length > 1 && /^\+?\d+$/.test(n[n.length - 1]) && parseInt(n.pop(-1), 10)) || 1;
                            return { hash: t, index: i < 1 ? 1 : i, gallery: n.join("-") };
                        }
                        function a(e) {
                            "" !== e.gallery &&
                                n("[data-fancybox='" + n.escapeSelector(e.gallery) + "']")
                                    .eq(e.index - 1)
                                    .focus()
                                    .trigger("click.fb-start");
                        }
                        function o(e) {
                            var t, n;
                            return !!e && "" !== (n = (t = e.current ? e.current.opts : e.opts).hash || (t.$orig ? t.$orig.data("fancybox") || t.$orig.data("fancybox-trigger") : "")) && n;
                        }
                        n.escapeSelector ||
                            (n.escapeSelector = function (e) {
                                return (e + "").replace(/([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g, function (e, t) {
                                    return t ? ("\0" === e ? "�" : e.slice(0, -1) + "\\" + e.charCodeAt(e.length - 1).toString(16) + " ") : "\\" + e;
                                });
                            }),
                            n(function () {
                                !1 !== n.fancybox.defaults.hash &&
                                    (n(t).on({
                                        "onInit.fb": function (e, t) {
                                            var n, a;
                                            !1 !== t.group[t.currIndex].opts.hash && ((n = i()), (a = o(t)) && n.gallery && a == n.gallery && (t.currIndex = n.index - 1));
                                        },
                                        "beforeShow.fb": function (n, i, a, r) {
                                            var s;
                                            a &&
                                                !1 !== a.opts.hash &&
                                                (s = o(i)) &&
                                                ((i.currentHash = s + (i.group.length > 1 ? "-" + (a.index + 1) : "")),
                                                e.location.hash !== "#" + i.currentHash &&
                                                    (r && !i.origHash && (i.origHash = e.location.hash),
                                                    i.hashTimer && clearTimeout(i.hashTimer),
                                                    (i.hashTimer = setTimeout(function () {
                                                        "replaceState" in e.history
                                                            ? (e.history[r ? "pushState" : "replaceState"]({}, t.title, e.location.pathname + e.location.search + "#" + i.currentHash), r && (i.hasCreatedHistory = !0))
                                                            : (e.location.hash = i.currentHash),
                                                            (i.hashTimer = null);
                                                    }, 300))));
                                        },
                                        "beforeClose.fb": function (n, i, a) {
                                            a &&
                                                !1 !== a.opts.hash &&
                                                (clearTimeout(i.hashTimer),
                                                i.currentHash && i.hasCreatedHistory
                                                    ? e.history.back()
                                                    : i.currentHash && ("replaceState" in e.history ? e.history.replaceState({}, t.title, e.location.pathname + e.location.search + (i.origHash || "")) : (e.location.hash = i.origHash)),
                                                (i.currentHash = null));
                                        },
                                    }),
                                    n(e).on("hashchange.fb", function () {
                                        var e = i(),
                                            t = null;
                                        n.each(n(".fancybox-container").get().reverse(), function (e, i) {
                                            var a = n(i).data("FancyBox");
                                            if (a && a.currentHash) return (t = a), !1;
                                        }),
                                            t ? t.currentHash === e.gallery + "-" + e.index || (1 === e.index && t.currentHash == e.gallery) || ((t.currentHash = null), t.close()) : "" !== e.gallery && a(e);
                                    }),
                                    setTimeout(function () {
                                        n.fancybox.getInstance() || a(i());
                                    }, 50));
                            });
                    })(window, document, jQuery),
                    (function (e, t) {
                        "use strict";
                        var n = new Date().getTime();
                        t(e).on({
                            "onInit.fb": function (e, t, i) {
                                t.$refs.stage.on("mousewheel DOMMouseScroll wheel MozMousePixelScroll", function (e) {
                                    var i = t.current,
                                        a = new Date().getTime();
                                    t.group.length < 2 ||
                                        !1 === i.opts.wheel ||
                                        ("auto" === i.opts.wheel && "image" !== i.type) ||
                                        (e.preventDefault(),
                                        e.stopPropagation(),
                                        i.$slide.hasClass("fancybox-animated") || ((e = e.originalEvent || e), a - n < 250 || ((n = a), t[(-e.deltaY || -e.deltaX || e.wheelDelta || -e.detail) < 0 ? "next" : "previous"]())));
                                });
                            },
                        });
                    })(document, jQuery);
            },
        ],
        t = {};
    function n(i) {
        if (t[i]) return t[i].exports;
        var a = (t[i] = { id: i, exports: {} });
        return e[i](a, a.exports, n), a.exports;
    }
    (n.n = (e) => {
        var t = e && e.__esModule ? () => e.default : () => e;
        return n.d(t, { a: t }), t;
    }),
        (n.d = (e, t) => {
            for (var i in t) n.o(t, i) && !n.o(e, i) && Object.defineProperty(e, i, { enumerable: !0, get: t[i] });
        }),
        (n.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t)),
        (n.r = (e) => {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e, "__esModule", { value: !0 });
        }),
        n(0);
})();